  /* eslint-disable */
  
  // Generated by JavaScript APG, Version [`apg-js2`](https://github.com/ldthomas/apg-js2)
  module.exports = {
    grammarObject: function(){
    "use strict";
      //```
      // SUMMARY
      //      rules = 332
      //       udts = 0
      //    opcodes = 1744
      //        ---   ABNF original opcodes
      //        ALT = 50
      //        CAT = 218
      //        REP = 198
      //        RNM = 565
      //        TLS = 707
      //        TBS = 1
      //        TRG = 5
      //        ---   SABNF superset opcodes
      //        UDT = 0
      //        AND = 0
      //        NOT = 0
      //        BKA = 0
      //        BKN = 0
      //        BKR = 0
      //        ABG = 0
      //        AEN = 0
      // characters = [33 - 126]
      //```
      /* OBJECT IDENTIFIER (for internal parser use) */
      this.grammarObject = 'grammarObject';
  
      /* RULES */
      this.rules = [];
      this.rules[0] = {name: 'DIGIT', lower: 'digit', index: 0, isBkr: false};
      this.rules[1] = {name: 'BOOLEAN', lower: 'boolean', index: 1, isBkr: false};
      this.rules[2] = {name: 'UPPERALPHA', lower: 'upperalpha', index: 2, isBkr: false};
      this.rules[3] = {name: 'LOWERALPHA', lower: 'loweralpha', index: 3, isBkr: false};
      this.rules[4] = {name: 'ALPHA', lower: 'alpha', index: 4, isBkr: false};
      this.rules[5] = {name: 'HEXDIG', lower: 'hexdig', index: 5, isBkr: false};
      this.rules[6] = {name: 'DoubleQuote', lower: 'doublequote', index: 6, isBkr: false};
      this.rules[7] = {name: 'Octothorpe', lower: 'octothorpe', index: 7, isBkr: false};
      this.rules[8] = {name: 'ForwardSlash', lower: 'forwardslash', index: 8, isBkr: false};
      this.rules[9] = {name: 'Percent', lower: 'percent', index: 9, isBkr: false};
      this.rules[10] = {name: 'Ampersand', lower: 'ampersand', index: 10, isBkr: false};
      this.rules[11] = {name: 'Plus', lower: 'plus', index: 11, isBkr: false};
      this.rules[12] = {name: 'Comma', lower: 'comma', index: 12, isBkr: false};
      this.rules[13] = {name: 'Exclamation', lower: 'exclamation', index: 13, isBkr: false};
      this.rules[14] = {name: 'LeftBracket', lower: 'leftbracket', index: 14, isBkr: false};
      this.rules[15] = {name: 'RightBracket', lower: 'rightbracket', index: 15, isBkr: false};
      this.rules[16] = {name: 'Asterisk', lower: 'asterisk', index: 16, isBkr: false};
      this.rules[17] = {name: 'Apostrophe', lower: 'apostrophe', index: 17, isBkr: false};
      this.rules[18] = {name: 'Colon', lower: 'colon', index: 18, isBkr: false};
      this.rules[19] = {name: 'Semicolon', lower: 'semicolon', index: 19, isBkr: false};
      this.rules[20] = {name: 'LeftAngleBracket', lower: 'leftanglebracket', index: 20, isBkr: false};
      this.rules[21] = {name: 'Equals', lower: 'equals', index: 21, isBkr: false};
      this.rules[22] = {name: 'RightAngleBracket', lower: 'rightanglebracket', index: 22, isBkr: false};
      this.rules[23] = {name: 'QuestionMark', lower: 'questionmark', index: 23, isBkr: false};
      this.rules[24] = {name: 'XSYMBOL', lower: 'xsymbol', index: 24, isBkr: false};
      this.rules[25] = {name: 'YSYMBOL', lower: 'ysymbol', index: 25, isBkr: false};
      this.rules[26] = {name: 'XCHAR', lower: 'xchar', index: 26, isBkr: false};
      this.rules[27] = {name: 'YCHAR', lower: 'ychar', index: 27, isBkr: false};
      this.rules[28] = {name: 'gtin-code', lower: 'gtin-code', index: 28, isBkr: false};
      this.rules[29] = {name: 'itip-code', lower: 'itip-code', index: 29, isBkr: false};
      this.rules[30] = {name: 'gmn-code', lower: 'gmn-code', index: 30, isBkr: false};
      this.rules[31] = {name: 'cpid-code', lower: 'cpid-code', index: 31, isBkr: false};
      this.rules[32] = {name: 'gln-code', lower: 'gln-code', index: 32, isBkr: false};
      this.rules[33] = {name: 'payTo-code', lower: 'payto-code', index: 33, isBkr: false};
      this.rules[34] = {name: 'partyGln-code', lower: 'partygln-code', index: 34, isBkr: false};
      this.rules[35] = {name: 'gsrnp-code', lower: 'gsrnp-code', index: 35, isBkr: false};
      this.rules[36] = {name: 'gsrn-code', lower: 'gsrn-code', index: 36, isBkr: false};
      this.rules[37] = {name: 'gcn-code', lower: 'gcn-code', index: 37, isBkr: false};
      this.rules[38] = {name: 'sscc-code', lower: 'sscc-code', index: 38, isBkr: false};
      this.rules[39] = {name: 'gdti-code', lower: 'gdti-code', index: 39, isBkr: false};
      this.rules[40] = {name: 'ginc-code', lower: 'ginc-code', index: 40, isBkr: false};
      this.rules[41] = {name: 'gsin-code', lower: 'gsin-code', index: 41, isBkr: false};
      this.rules[42] = {name: 'grai-code', lower: 'grai-code', index: 42, isBkr: false};
      this.rules[43] = {name: 'giai-code', lower: 'giai-code', index: 43, isBkr: false};
      this.rules[44] = {name: 'cpv-code', lower: 'cpv-code', index: 44, isBkr: false};
      this.rules[45] = {name: 'lot-code', lower: 'lot-code', index: 45, isBkr: false};
      this.rules[46] = {name: 'ser-code', lower: 'ser-code', index: 46, isBkr: false};
      this.rules[47] = {name: 'cpsn-code', lower: 'cpsn-code', index: 47, isBkr: false};
      this.rules[48] = {name: 'glnx-code', lower: 'glnx-code', index: 48, isBkr: false};
      this.rules[49] = {name: 'refno-code', lower: 'refno-code', index: 49, isBkr: false};
      this.rules[50] = {name: 'srin-code', lower: 'srin-code', index: 50, isBkr: false};
      this.rules[51] = {name: 'tpx-code', lower: 'tpx-code', index: 51, isBkr: false};
      this.rules[52] = {name: 'uic-ext-code', lower: 'uic-ext-code', index: 52, isBkr: false};
      this.rules[53] = {name: 'gtin-value', lower: 'gtin-value', index: 53, isBkr: false};
      this.rules[54] = {name: 'itip-value', lower: 'itip-value', index: 54, isBkr: false};
      this.rules[55] = {name: 'gmn-value', lower: 'gmn-value', index: 55, isBkr: false};
      this.rules[56] = {name: 'cpid-value', lower: 'cpid-value', index: 56, isBkr: false};
      this.rules[57] = {name: 'gln-value', lower: 'gln-value', index: 57, isBkr: false};
      this.rules[58] = {name: 'payTo-value', lower: 'payto-value', index: 58, isBkr: false};
      this.rules[59] = {name: 'partyGln-value', lower: 'partygln-value', index: 59, isBkr: false};
      this.rules[60] = {name: 'gsrnp-value', lower: 'gsrnp-value', index: 60, isBkr: false};
      this.rules[61] = {name: 'gsrn-value', lower: 'gsrn-value', index: 61, isBkr: false};
      this.rules[62] = {name: 'gcn-value', lower: 'gcn-value', index: 62, isBkr: false};
      this.rules[63] = {name: 'sscc-value', lower: 'sscc-value', index: 63, isBkr: false};
      this.rules[64] = {name: 'gdti-value', lower: 'gdti-value', index: 64, isBkr: false};
      this.rules[65] = {name: 'ginc-value', lower: 'ginc-value', index: 65, isBkr: false};
      this.rules[66] = {name: 'gsin-value', lower: 'gsin-value', index: 66, isBkr: false};
      this.rules[67] = {name: 'grai-value', lower: 'grai-value', index: 67, isBkr: false};
      this.rules[68] = {name: 'giai-value', lower: 'giai-value', index: 68, isBkr: false};
      this.rules[69] = {name: 'cpv-value', lower: 'cpv-value', index: 69, isBkr: false};
      this.rules[70] = {name: 'lot-value', lower: 'lot-value', index: 70, isBkr: false};
      this.rules[71] = {name: 'ser-value', lower: 'ser-value', index: 71, isBkr: false};
      this.rules[72] = {name: 'cpsn-value', lower: 'cpsn-value', index: 72, isBkr: false};
      this.rules[73] = {name: 'glnx-value', lower: 'glnx-value', index: 73, isBkr: false};
      this.rules[74] = {name: 'refno-value', lower: 'refno-value', index: 74, isBkr: false};
      this.rules[75] = {name: 'srin-value', lower: 'srin-value', index: 75, isBkr: false};
      this.rules[76] = {name: 'tpx-value', lower: 'tpx-value', index: 76, isBkr: false};
      this.rules[77] = {name: 'uic-ext-value', lower: 'uic-ext-value', index: 77, isBkr: false};
      this.rules[78] = {name: 'gtin-comp', lower: 'gtin-comp', index: 78, isBkr: false};
      this.rules[79] = {name: 'itip-comp', lower: 'itip-comp', index: 79, isBkr: false};
      this.rules[80] = {name: 'gmn-comp', lower: 'gmn-comp', index: 80, isBkr: false};
      this.rules[81] = {name: 'cpid-comp', lower: 'cpid-comp', index: 81, isBkr: false};
      this.rules[82] = {name: 'gln-comp', lower: 'gln-comp', index: 82, isBkr: false};
      this.rules[83] = {name: 'payTo-comp', lower: 'payto-comp', index: 83, isBkr: false};
      this.rules[84] = {name: 'partyGln-comp', lower: 'partygln-comp', index: 84, isBkr: false};
      this.rules[85] = {name: 'gsrnp-comp', lower: 'gsrnp-comp', index: 85, isBkr: false};
      this.rules[86] = {name: 'gsrn-comp', lower: 'gsrn-comp', index: 86, isBkr: false};
      this.rules[87] = {name: 'gcn-comp', lower: 'gcn-comp', index: 87, isBkr: false};
      this.rules[88] = {name: 'sscc-comp', lower: 'sscc-comp', index: 88, isBkr: false};
      this.rules[89] = {name: 'gdti-comp', lower: 'gdti-comp', index: 89, isBkr: false};
      this.rules[90] = {name: 'ginc-comp', lower: 'ginc-comp', index: 90, isBkr: false};
      this.rules[91] = {name: 'gsin-comp', lower: 'gsin-comp', index: 91, isBkr: false};
      this.rules[92] = {name: 'grai-comp', lower: 'grai-comp', index: 92, isBkr: false};
      this.rules[93] = {name: 'giai-comp', lower: 'giai-comp', index: 93, isBkr: false};
      this.rules[94] = {name: 'cpv-comp', lower: 'cpv-comp', index: 94, isBkr: false};
      this.rules[95] = {name: 'lot-comp', lower: 'lot-comp', index: 95, isBkr: false};
      this.rules[96] = {name: 'ser-comp', lower: 'ser-comp', index: 96, isBkr: false};
      this.rules[97] = {name: 'cpsn-comp', lower: 'cpsn-comp', index: 97, isBkr: false};
      this.rules[98] = {name: 'glnx-comp', lower: 'glnx-comp', index: 98, isBkr: false};
      this.rules[99] = {name: 'refno-comp', lower: 'refno-comp', index: 99, isBkr: false};
      this.rules[100] = {name: 'srin-comp', lower: 'srin-comp', index: 100, isBkr: false};
      this.rules[101] = {name: 'tpx-comp', lower: 'tpx-comp', index: 101, isBkr: false};
      this.rules[102] = {name: 'uic-ext-comp', lower: 'uic-ext-comp', index: 102, isBkr: false};
      this.rules[103] = {name: 'gtin-path', lower: 'gtin-path', index: 103, isBkr: false};
      this.rules[104] = {name: 'itip-path', lower: 'itip-path', index: 104, isBkr: false};
      this.rules[105] = {name: 'gmn-path', lower: 'gmn-path', index: 105, isBkr: false};
      this.rules[106] = {name: 'cpid-path', lower: 'cpid-path', index: 106, isBkr: false};
      this.rules[107] = {name: 'gln-path', lower: 'gln-path', index: 107, isBkr: false};
      this.rules[108] = {name: 'payTo-path', lower: 'payto-path', index: 108, isBkr: false};
      this.rules[109] = {name: 'partyGln-path', lower: 'partygln-path', index: 109, isBkr: false};
      this.rules[110] = {name: 'gsrnp-path', lower: 'gsrnp-path', index: 110, isBkr: false};
      this.rules[111] = {name: 'gsrn-path', lower: 'gsrn-path', index: 111, isBkr: false};
      this.rules[112] = {name: 'gcn-path', lower: 'gcn-path', index: 112, isBkr: false};
      this.rules[113] = {name: 'sscc-path', lower: 'sscc-path', index: 113, isBkr: false};
      this.rules[114] = {name: 'gdti-path', lower: 'gdti-path', index: 114, isBkr: false};
      this.rules[115] = {name: 'ginc-path', lower: 'ginc-path', index: 115, isBkr: false};
      this.rules[116] = {name: 'gsin-path', lower: 'gsin-path', index: 116, isBkr: false};
      this.rules[117] = {name: 'grai-path', lower: 'grai-path', index: 117, isBkr: false};
      this.rules[118] = {name: 'giai-path', lower: 'giai-path', index: 118, isBkr: false};
      this.rules[119] = {name: 'upui-path', lower: 'upui-path', index: 119, isBkr: false};
      this.rules[120] = {name: 'eoid-path', lower: 'eoid-path', index: 120, isBkr: false};
      this.rules[121] = {name: 'fid-path', lower: 'fid-path', index: 121, isBkr: false};
      this.rules[122] = {name: 'mid-path', lower: 'mid-path', index: 122, isBkr: false};
      this.rules[123] = {name: 'gs1path', lower: 'gs1path', index: 123, isBkr: false};
      this.rules[124] = {name: 'netWeightVMTICode', lower: 'netweightvmticode', index: 124, isBkr: false};
      this.rules[125] = {name: 'netWeightVMTIValue', lower: 'netweightvmtivalue', index: 125, isBkr: false};
      this.rules[126] = {name: 'netWeightVMTIParameter', lower: 'netweightvmtiparameter', index: 126, isBkr: false};
      this.rules[127] = {name: 'lengthVMTICode', lower: 'lengthvmticode', index: 127, isBkr: false};
      this.rules[128] = {name: 'lengthVMTIValue', lower: 'lengthvmtivalue', index: 128, isBkr: false};
      this.rules[129] = {name: 'lengthVMTIParameter', lower: 'lengthvmtiparameter', index: 129, isBkr: false};
      this.rules[130] = {name: 'widthVMTICode', lower: 'widthvmticode', index: 130, isBkr: false};
      this.rules[131] = {name: 'widthVMTIValue', lower: 'widthvmtivalue', index: 131, isBkr: false};
      this.rules[132] = {name: 'widthVMTIParameter', lower: 'widthvmtiparameter', index: 132, isBkr: false};
      this.rules[133] = {name: 'depthVMTICode', lower: 'depthvmticode', index: 133, isBkr: false};
      this.rules[134] = {name: 'depthVMTIValue', lower: 'depthvmtivalue', index: 134, isBkr: false};
      this.rules[135] = {name: 'depthVMTIParameter', lower: 'depthvmtiparameter', index: 135, isBkr: false};
      this.rules[136] = {name: 'areaVMTICode', lower: 'areavmticode', index: 136, isBkr: false};
      this.rules[137] = {name: 'areaVMTIValue', lower: 'areavmtivalue', index: 137, isBkr: false};
      this.rules[138] = {name: 'areaVMTIParameter', lower: 'areavmtiparameter', index: 138, isBkr: false};
      this.rules[139] = {name: 'netVolumeVMTICode', lower: 'netvolumevmticode', index: 139, isBkr: false};
      this.rules[140] = {name: 'netVolumeVMTIValue', lower: 'netvolumevmtivalue', index: 140, isBkr: false};
      this.rules[141] = {name: 'netVolumeVMTIParameter', lower: 'netvolumevmtiparameter', index: 141, isBkr: false};
      this.rules[142] = {name: 'massPerUnitAreaVMTICode', lower: 'massperunitareavmticode', index: 142, isBkr: false};
      this.rules[143] = {name: 'massPerUnitAreaVMTIValue', lower: 'massperunitareavmtivalue', index: 143, isBkr: false};
      this.rules[144] = {name: 'massPerUnitAreaVMTIParameter', lower: 'massperunitareavmtiparameter', index: 144, isBkr: false};
      this.rules[145] = {name: 'grossWeightCode', lower: 'grossweightcode', index: 145, isBkr: false};
      this.rules[146] = {name: 'grossWeightValue', lower: 'grossweightvalue', index: 146, isBkr: false};
      this.rules[147] = {name: 'grossWeightParameter', lower: 'grossweightparameter', index: 147, isBkr: false};
      this.rules[148] = {name: 'logisticLengthCode', lower: 'logisticlengthcode', index: 148, isBkr: false};
      this.rules[149] = {name: 'logisticLengthValue', lower: 'logisticlengthvalue', index: 149, isBkr: false};
      this.rules[150] = {name: 'logisticLengthParameter', lower: 'logisticlengthparameter', index: 150, isBkr: false};
      this.rules[151] = {name: 'logisticWidthCode', lower: 'logisticwidthcode', index: 151, isBkr: false};
      this.rules[152] = {name: 'logisticWidthValue', lower: 'logisticwidthvalue', index: 152, isBkr: false};
      this.rules[153] = {name: 'logisticWidthParameter', lower: 'logisticwidthparameter', index: 153, isBkr: false};
      this.rules[154] = {name: 'logisticDepthCode', lower: 'logisticdepthcode', index: 154, isBkr: false};
      this.rules[155] = {name: 'logisticDepthValue', lower: 'logisticdepthvalue', index: 155, isBkr: false};
      this.rules[156] = {name: 'logisticDepthParameter', lower: 'logisticdepthparameter', index: 156, isBkr: false};
      this.rules[157] = {name: 'logisticAreaCode', lower: 'logisticareacode', index: 157, isBkr: false};
      this.rules[158] = {name: 'logisticAreaValue', lower: 'logisticareavalue', index: 158, isBkr: false};
      this.rules[159] = {name: 'logisticAreaParameter', lower: 'logisticareaparameter', index: 159, isBkr: false};
      this.rules[160] = {name: 'logisticVolumeCode', lower: 'logisticvolumecode', index: 160, isBkr: false};
      this.rules[161] = {name: 'logisticVolumeValue', lower: 'logisticvolumevalue', index: 161, isBkr: false};
      this.rules[162] = {name: 'logisticVolumeParameter', lower: 'logisticvolumeparameter', index: 162, isBkr: false};
      this.rules[163] = {name: 'processorCode', lower: 'processorcode', index: 163, isBkr: false};
      this.rules[164] = {name: 'processorValue', lower: 'processorvalue', index: 164, isBkr: false};
      this.rules[165] = {name: 'processorParameter', lower: 'processorparameter', index: 165, isBkr: false};
      this.rules[166] = {name: 'contentParameter', lower: 'contentparameter', index: 166, isBkr: false};
      this.rules[167] = {name: 'prodDateParameter', lower: 'proddateparameter', index: 167, isBkr: false};
      this.rules[168] = {name: 'dueDateParameter', lower: 'duedateparameter', index: 168, isBkr: false};
      this.rules[169] = {name: 'packDateParameter', lower: 'packdateparameter', index: 169, isBkr: false};
      this.rules[170] = {name: 'bestBeforeDateParameter', lower: 'bestbeforedateparameter', index: 170, isBkr: false};
      this.rules[171] = {name: 'sellByDateParameter', lower: 'sellbydateparameter', index: 171, isBkr: false};
      this.rules[172] = {name: 'firstFreezeDateParameter', lower: 'firstfreezedateparameter', index: 172, isBkr: false};
      this.rules[173] = {name: 'harvestDateParameter', lower: 'harvestdateparameter', index: 173, isBkr: false};
      this.rules[174] = {name: 'pricePerUnitParameter', lower: 'priceperunitparameter', index: 174, isBkr: false};
      this.rules[175] = {name: 'variantParameter', lower: 'variantparameter', index: 175, isBkr: false};
      this.rules[176] = {name: 'varCountParameter', lower: 'varcountparameter', index: 176, isBkr: false};
      this.rules[177] = {name: 'countParameter', lower: 'countparameter', index: 177, isBkr: false};
      this.rules[178] = {name: 'mutualParameter', lower: 'mutualparameter', index: 178, isBkr: false};
      this.rules[179] = {name: 'additionalIdParameter', lower: 'additionalidparameter', index: 179, isBkr: false};
      this.rules[180] = {name: 'custPartNoParameter', lower: 'custpartnoparameter', index: 180, isBkr: false};
      this.rules[181] = {name: 'mtoVariantParameter', lower: 'mtovariantparameter', index: 181, isBkr: false};
      this.rules[182] = {name: 'pcnParameter', lower: 'pcnparameter', index: 182, isBkr: false};
      this.rules[183] = {name: 'secondarySerialParameter', lower: 'secondaryserialparameter', index: 183, isBkr: false};
      this.rules[184] = {name: 'refToSourceParameter', lower: 'reftosourceparameter', index: 184, isBkr: false};
      this.rules[185] = {name: 'amountCode', lower: 'amountcode', index: 185, isBkr: false};
      this.rules[186] = {name: 'amountValue', lower: 'amountvalue', index: 186, isBkr: false};
      this.rules[187] = {name: 'amountParameter', lower: 'amountparameter', index: 187, isBkr: false};
      this.rules[188] = {name: 'amountISOCode', lower: 'amountisocode', index: 188, isBkr: false};
      this.rules[189] = {name: 'amountISOValue', lower: 'amountisovalue', index: 189, isBkr: false};
      this.rules[190] = {name: 'amountISOParameter', lower: 'amountisoparameter', index: 190, isBkr: false};
      this.rules[191] = {name: 'priceCode', lower: 'pricecode', index: 191, isBkr: false};
      this.rules[192] = {name: 'priceValue', lower: 'pricevalue', index: 192, isBkr: false};
      this.rules[193] = {name: 'priceParameter', lower: 'priceparameter', index: 193, isBkr: false};
      this.rules[194] = {name: 'priceISOCode', lower: 'priceisocode', index: 194, isBkr: false};
      this.rules[195] = {name: 'priceISOValue', lower: 'priceisovalue', index: 195, isBkr: false};
      this.rules[196] = {name: 'priceISOParameter', lower: 'priceisoparameter', index: 196, isBkr: false};
      this.rules[197] = {name: 'percentOffCode', lower: 'percentoffcode', index: 197, isBkr: false};
      this.rules[198] = {name: 'percentOffValue', lower: 'percentoffvalue', index: 198, isBkr: false};
      this.rules[199] = {name: 'percentOffParameter', lower: 'percentoffparameter', index: 199, isBkr: false};
      this.rules[200] = {name: 'orderNumberParameter', lower: 'ordernumberparameter', index: 200, isBkr: false};
      this.rules[201] = {name: 'routeParameter', lower: 'routeparameter', index: 201, isBkr: false};
      this.rules[202] = {name: 'shipToLocParameter', lower: 'shiptolocparameter', index: 202, isBkr: false};
      this.rules[203] = {name: 'billToParameter', lower: 'billtoparameter', index: 203, isBkr: false};
      this.rules[204] = {name: 'purchaseFromParameter', lower: 'purchasefromparameter', index: 204, isBkr: false};
      this.rules[205] = {name: 'shipForLocParameter', lower: 'shipforlocparameter', index: 205, isBkr: false};
      this.rules[206] = {name: 'prodServLocParameter', lower: 'prodservlocparameter', index: 206, isBkr: false};
      this.rules[207] = {name: 'shipToPostParameter', lower: 'shiptopostparameter', index: 207, isBkr: false};
      this.rules[208] = {name: 'shipToPostISOParameter', lower: 'shiptopostisoparameter', index: 208, isBkr: false};
      this.rules[209] = {name: 'originParameter', lower: 'originparameter', index: 209, isBkr: false};
      this.rules[210] = {name: 'countryProcessParameter', lower: 'countryprocessparameter', index: 210, isBkr: false};
      this.rules[211] = {name: 'countryFullProcessParameter', lower: 'countryfullprocessparameter', index: 211, isBkr: false};
      this.rules[212] = {name: 'countryInitialProcessParameter', lower: 'countryinitialprocessparameter', index: 212, isBkr: false};
      this.rules[213] = {name: 'countryDisassemblyParameter', lower: 'countrydisassemblyparameter', index: 213, isBkr: false};
      this.rules[214] = {name: 'originSubdivisionParameter', lower: 'originsubdivisionparameter', index: 214, isBkr: false};
      this.rules[215] = {name: 'nhrnPZNParameter', lower: 'nhrnpznparameter', index: 215, isBkr: false};
      this.rules[216] = {name: 'nhrnCIPParameter', lower: 'nhrncipparameter', index: 216, isBkr: false};
      this.rules[217] = {name: 'nhrnCNParameter', lower: 'nhrncnparameter', index: 217, isBkr: false};
      this.rules[218] = {name: 'nhrnDRNParameter', lower: 'nhrndrnparameter', index: 218, isBkr: false};
      this.rules[219] = {name: 'nhrnAIMParameter', lower: 'nhrnaimparameter', index: 219, isBkr: false};
      this.rules[220] = {name: 'nhrnUS-FDAParameter', lower: 'nhrnus-fdaparameter', index: 220, isBkr: false};
      this.rules[221] = {name: 'nsnParameter', lower: 'nsnparameter', index: 221, isBkr: false};
      this.rules[222] = {name: 'meatCutParameter', lower: 'meatcutparameter', index: 222, isBkr: false};
      this.rules[223] = {name: 'activePotencyParameter', lower: 'activepotencyparameter', index: 223, isBkr: false};
      this.rules[224] = {name: 'catchAreaParameter', lower: 'catchareaparameter', index: 224, isBkr: false};
      this.rules[225] = {name: 'aquaticSpeciesParameter', lower: 'aquaticspeciesparameter', index: 225, isBkr: false};
      this.rules[226] = {name: 'fishingGearTypeParameter', lower: 'fishinggeartypeparameter', index: 226, isBkr: false};
      this.rules[227] = {name: 'prodMethodParameter', lower: 'prodmethodparameter', index: 227, isBkr: false};
      this.rules[228] = {name: 'refurbLotParameter', lower: 'refurblotparameter', index: 228, isBkr: false};
      this.rules[229] = {name: 'funcStatParameter', lower: 'funcstatparameter', index: 229, isBkr: false};
      this.rules[230] = {name: 'revStatParameter', lower: 'revstatparameter', index: 230, isBkr: false};
      this.rules[231] = {name: 'giaiAssemblyParameter', lower: 'giaiassemblyparameter', index: 231, isBkr: false};
      this.rules[232] = {name: 'certificationRefCode', lower: 'certificationrefcode', index: 232, isBkr: false};
      this.rules[233] = {name: 'certificationRefValue', lower: 'certificationrefvalue', index: 233, isBkr: false};
      this.rules[234] = {name: 'certificationRefParameter', lower: 'certificationrefparameter', index: 234, isBkr: false};
      this.rules[235] = {name: 'dimensionsParameter', lower: 'dimensionsparameter', index: 235, isBkr: false};
      this.rules[236] = {name: 'cmtNoParameter', lower: 'cmtnoparameter', index: 236, isBkr: false};
      this.rules[237] = {name: 'ibanParameter', lower: 'ibanparameter', index: 237, isBkr: false};
      this.rules[238] = {name: 'prodTimeParameter', lower: 'prodtimeparameter', index: 238, isBkr: false};
      this.rules[239] = {name: 'opticalSensorParameter', lower: 'opticalsensorparameter', index: 239, isBkr: false};
      this.rules[240] = {name: 'versionParameter', lower: 'versionparameter', index: 240, isBkr: false};
      this.rules[241] = {name: 'refNoParameter', lower: 'refnoparameter', index: 241, isBkr: false};
      this.rules[242] = {name: 'itipContentParameter', lower: 'itipcontentparameter', index: 242, isBkr: false};
      this.rules[243] = {name: 'couponIDNAParameter', lower: 'couponidnaparameter', index: 243, isBkr: false};
      this.rules[244] = {name: 'pointsParameter', lower: 'pointsparameter', index: 244, isBkr: false};
      this.rules[245] = {name: 'paperlessCouponIDNAParameter', lower: 'paperlesscouponidnaparameter', index: 245, isBkr: false};
      this.rules[246] = {name: 'shipToCompParameter', lower: 'shiptocompparameter', index: 246, isBkr: false};
      this.rules[247] = {name: 'shipToNameParameter', lower: 'shiptonameparameter', index: 247, isBkr: false};
      this.rules[248] = {name: 'shipToAdd1Parameter', lower: 'shiptoadd1parameter', index: 248, isBkr: false};
      this.rules[249] = {name: 'shipToAdd2Parameter', lower: 'shiptoadd2parameter', index: 249, isBkr: false};
      this.rules[250] = {name: 'shipToSubParameter', lower: 'shiptosubparameter', index: 250, isBkr: false};
      this.rules[251] = {name: 'shipToLocalityParameter', lower: 'shiptolocalityparameter', index: 251, isBkr: false};
      this.rules[252] = {name: 'shipToRegParameter', lower: 'shiptoregparameter', index: 252, isBkr: false};
      this.rules[253] = {name: 'shipToCountryParameter', lower: 'shiptocountryparameter', index: 253, isBkr: false};
      this.rules[254] = {name: 'shipToPhoneParameter', lower: 'shiptophoneparameter', index: 254, isBkr: false};
      this.rules[255] = {name: 'rtnToCompParameter', lower: 'rtntocompparameter', index: 255, isBkr: false};
      this.rules[256] = {name: 'rtnToNameParameter', lower: 'rtntonameparameter', index: 256, isBkr: false};
      this.rules[257] = {name: 'rtnToAdd1Parameter', lower: 'rtntoadd1parameter', index: 257, isBkr: false};
      this.rules[258] = {name: 'rtnToAdd2Parameter', lower: 'rtntoadd2parameter', index: 258, isBkr: false};
      this.rules[259] = {name: 'rtnToSubParameter', lower: 'rtntosubparameter', index: 259, isBkr: false};
      this.rules[260] = {name: 'rtnToLocParameter', lower: 'rtntolocparameter', index: 260, isBkr: false};
      this.rules[261] = {name: 'rtnToRegParameter', lower: 'rtntoregparameter', index: 261, isBkr: false};
      this.rules[262] = {name: 'rtnToCountryParameter', lower: 'rtntocountryparameter', index: 262, isBkr: false};
      this.rules[263] = {name: 'rtnToPostParameter', lower: 'rtntopostparameter', index: 263, isBkr: false};
      this.rules[264] = {name: 'rtnToPhoneParameter', lower: 'rtntophoneparameter', index: 264, isBkr: false};
      this.rules[265] = {name: 'srvDescriptionParameter', lower: 'srvdescriptionparameter', index: 265, isBkr: false};
      this.rules[266] = {name: 'dangerousGoodsParameter', lower: 'dangerousgoodsparameter', index: 266, isBkr: false};
      this.rules[267] = {name: 'authToLeaveParameter', lower: 'authtoleaveparameter', index: 267, isBkr: false};
      this.rules[268] = {name: 'sigRequiredParameter', lower: 'sigrequiredparameter', index: 268, isBkr: false};
      this.rules[269] = {name: 'notBeforeDelDateParameter', lower: 'notbeforedeldateparameter', index: 269, isBkr: false};
      this.rules[270] = {name: 'notAfterDelDateParameter', lower: 'notafterdeldateparameter', index: 270, isBkr: false};
      this.rules[271] = {name: 'releaseDateParameter', lower: 'releasedateparameter', index: 271, isBkr: false};
      this.rules[272] = {name: 'amountPayPerUnitCode', lower: 'amountpayperunitcode', index: 272, isBkr: false};
      this.rules[273] = {name: 'amountPayPerUnitValue', lower: 'amountpayperunitvalue', index: 273, isBkr: false};
      this.rules[274] = {name: 'amountPayPerUnitParameter', lower: 'amountpayperunitparameter', index: 274, isBkr: false};
      this.rules[275] = {name: 'gtinParameter', lower: 'gtinparameter', index: 275, isBkr: false};
      this.rules[276] = {name: 'itipParameter', lower: 'itipparameter', index: 276, isBkr: false};
      this.rules[277] = {name: 'gmnParameter', lower: 'gmnparameter', index: 277, isBkr: false};
      this.rules[278] = {name: 'cpidParameter', lower: 'cpidparameter', index: 278, isBkr: false};
      this.rules[279] = {name: 'glnParameter', lower: 'glnparameter', index: 279, isBkr: false};
      this.rules[280] = {name: 'payToParameter', lower: 'paytoparameter', index: 280, isBkr: false};
      this.rules[281] = {name: 'partyGlnParameter', lower: 'partyglnparameter', index: 281, isBkr: false};
      this.rules[282] = {name: 'gsrnpParameter', lower: 'gsrnpparameter', index: 282, isBkr: false};
      this.rules[283] = {name: 'gsrnParameter', lower: 'gsrnparameter', index: 283, isBkr: false};
      this.rules[284] = {name: 'gcnParameter', lower: 'gcnparameter', index: 284, isBkr: false};
      this.rules[285] = {name: 'ssccParameter', lower: 'ssccparameter', index: 285, isBkr: false};
      this.rules[286] = {name: 'gdtiParameter', lower: 'gdtiparameter', index: 286, isBkr: false};
      this.rules[287] = {name: 'gincParameter', lower: 'gincparameter', index: 287, isBkr: false};
      this.rules[288] = {name: 'gsinParameter', lower: 'gsinparameter', index: 288, isBkr: false};
      this.rules[289] = {name: 'graiParameter', lower: 'graiparameter', index: 289, isBkr: false};
      this.rules[290] = {name: 'giaiParameter', lower: 'giaiparameter', index: 290, isBkr: false};
      this.rules[291] = {name: 'internalCode', lower: 'internalcode', index: 291, isBkr: false};
      this.rules[292] = {name: 'internalValue', lower: 'internalvalue', index: 292, isBkr: false};
      this.rules[293] = {name: 'internalParameter', lower: 'internalparameter', index: 293, isBkr: false};
      this.rules[294] = {name: 'LotParameter', lower: 'lotparameter', index: 294, isBkr: false};
      this.rules[295] = {name: 'expiryDateCode', lower: 'expirydatecode', index: 295, isBkr: false};
      this.rules[296] = {name: 'expiryDateValue', lower: 'expirydatevalue', index: 296, isBkr: false};
      this.rules[297] = {name: 'expiryDateParameter', lower: 'expirydateparameter', index: 297, isBkr: false};
      this.rules[298] = {name: 'expiryTimeCode', lower: 'expirytimecode', index: 298, isBkr: false};
      this.rules[299] = {name: 'expiryTimeValue', lower: 'expirytimevalue', index: 299, isBkr: false};
      this.rules[300] = {name: 'expiryTimeParameter', lower: 'expirytimeparameter', index: 300, isBkr: false};
      this.rules[301] = {name: 'extensionKey', lower: 'extensionkey', index: 301, isBkr: false};
      this.rules[302] = {name: 'extensionValue', lower: 'extensionvalue', index: 302, isBkr: false};
      this.rules[303] = {name: 'extensionParameter', lower: 'extensionparameter', index: 303, isBkr: false};
      this.rules[304] = {name: 'queryStringParam', lower: 'querystringparam', index: 304, isBkr: false};
      this.rules[305] = {name: 'scheme', lower: 'scheme', index: 305, isBkr: false};
      this.rules[306] = {name: 'unreserved', lower: 'unreserved', index: 306, isBkr: false};
      this.rules[307] = {name: 'reserved', lower: 'reserved', index: 307, isBkr: false};
      this.rules[308] = {name: 'pct-encoded', lower: 'pct-encoded', index: 308, isBkr: false};
      this.rules[309] = {name: 'gen-delims', lower: 'gen-delims', index: 309, isBkr: false};
      this.rules[310] = {name: 'sub-delims', lower: 'sub-delims', index: 310, isBkr: false};
      this.rules[311] = {name: 'sub-delims-without-equals', lower: 'sub-delims-without-equals', index: 311, isBkr: false};
      this.rules[312] = {name: 'everythingExceptDigitsAndEquals', lower: 'everythingexceptdigitsandequals', index: 312, isBkr: false};
      this.rules[313] = {name: 'pchar', lower: 'pchar', index: 313, isBkr: false};
      this.rules[314] = {name: 'segment', lower: 'segment', index: 314, isBkr: false};
      this.rules[315] = {name: 'reg-name', lower: 'reg-name', index: 315, isBkr: false};
      this.rules[316] = {name: 'dec-octet', lower: 'dec-octet', index: 316, isBkr: false};
      this.rules[317] = {name: 'IPv4address', lower: 'ipv4address', index: 317, isBkr: false};
      this.rules[318] = {name: 'IPv6address', lower: 'ipv6address', index: 318, isBkr: false};
      this.rules[319] = {name: 'ls32', lower: 'ls32', index: 319, isBkr: false};
      this.rules[320] = {name: 'h16', lower: 'h16', index: 320, isBkr: false};
      this.rules[321] = {name: 'IP-literal', lower: 'ip-literal', index: 321, isBkr: false};
      this.rules[322] = {name: 'IPvFuture', lower: 'ipvfuture', index: 322, isBkr: false};
      this.rules[323] = {name: 'host', lower: 'host', index: 323, isBkr: false};
      this.rules[324] = {name: 'port', lower: 'port', index: 324, isBkr: false};
      this.rules[325] = {name: 'hostname', lower: 'hostname', index: 325, isBkr: false};
      this.rules[326] = {name: 'queryStringDelim', lower: 'querystringdelim', index: 326, isBkr: false};
      this.rules[327] = {name: 'queryStringComp', lower: 'querystringcomp', index: 327, isBkr: false};
      this.rules[328] = {name: 'uncompressedGS1webURIPattern', lower: 'uncompressedgs1weburipattern', index: 328, isBkr: false};
      this.rules[329] = {name: 'referenceGS1webURI', lower: 'referencegs1weburi', index: 329, isBkr: false};
      this.rules[330] = {name: 'customURIstem', lower: 'customuristem', index: 330, isBkr: false};
      this.rules[331] = {name: 'uncompressedCustomGS1webURI', lower: 'uncompressedcustomgs1weburi', index: 331, isBkr: false};
  
      /* UDTS */
      this.udts = [];
  
      /* OPCODES */
      /* DIGIT */
      this.rules[0].opcodes = [];
      this.rules[0].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
      this.rules[0].opcodes[1] = {type: 7, string: [48]};// TLS
      this.rules[0].opcodes[2] = {type: 7, string: [49]};// TLS
      this.rules[0].opcodes[3] = {type: 7, string: [50]};// TLS
      this.rules[0].opcodes[4] = {type: 7, string: [51]};// TLS
      this.rules[0].opcodes[5] = {type: 7, string: [52]};// TLS
      this.rules[0].opcodes[6] = {type: 7, string: [53]};// TLS
      this.rules[0].opcodes[7] = {type: 7, string: [54]};// TLS
      this.rules[0].opcodes[8] = {type: 7, string: [55]};// TLS
      this.rules[0].opcodes[9] = {type: 7, string: [56]};// TLS
      this.rules[0].opcodes[10] = {type: 7, string: [57]};// TLS
  
      /* BOOLEAN */
      this.rules[1].opcodes = [];
      this.rules[1].opcodes[0] = {type: 1, children: [1,2]};// ALT
      this.rules[1].opcodes[1] = {type: 7, string: [48]};// TLS
      this.rules[1].opcodes[2] = {type: 7, string: [49]};// TLS
  
      /* UPPERALPHA */
      this.rules[2].opcodes = [];
      this.rules[2].opcodes[0] = {type: 5, min: 65, max: 90};// TRG
  
      /* LOWERALPHA */
      this.rules[3].opcodes = [];
      this.rules[3].opcodes[0] = {type: 5, min: 97, max: 122};// TRG
  
      /* ALPHA */
      this.rules[4].opcodes = [];
      this.rules[4].opcodes[0] = {type: 1, children: [1,2]};// ALT
      this.rules[4].opcodes[1] = {type: 4, index: 2};// RNM(UPPERALPHA)
      this.rules[4].opcodes[2] = {type: 4, index: 3};// RNM(LOWERALPHA)
  
      /* HEXDIG */
      this.rules[5].opcodes = [];
      this.rules[5].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7]};// ALT
      this.rules[5].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[5].opcodes[2] = {type: 7, string: [97]};// TLS
      this.rules[5].opcodes[3] = {type: 7, string: [98]};// TLS
      this.rules[5].opcodes[4] = {type: 7, string: [99]};// TLS
      this.rules[5].opcodes[5] = {type: 7, string: [100]};// TLS
      this.rules[5].opcodes[6] = {type: 7, string: [101]};// TLS
      this.rules[5].opcodes[7] = {type: 7, string: [102]};// TLS
  
      /* DoubleQuote */
      this.rules[6].opcodes = [];
      this.rules[6].opcodes[0] = {type: 6, string: [34]};// TBS
  
      /* Octothorpe */
      this.rules[7].opcodes = [];
      this.rules[7].opcodes[0] = {type: 7, string: [37,50,51]};// TLS
  
      /* ForwardSlash */
      this.rules[8].opcodes = [];
      this.rules[8].opcodes[0] = {type: 7, string: [37,50,102]};// TLS
  
      /* Percent */
      this.rules[9].opcodes = [];
      this.rules[9].opcodes[0] = {type: 7, string: [37,50,53]};// TLS
  
      /* Ampersand */
      this.rules[10].opcodes = [];
      this.rules[10].opcodes[0] = {type: 7, string: [37,50,54]};// TLS
  
      /* Plus */
      this.rules[11].opcodes = [];
      this.rules[11].opcodes[0] = {type: 7, string: [37,50,98]};// TLS
  
      /* Comma */
      this.rules[12].opcodes = [];
      this.rules[12].opcodes[0] = {type: 7, string: [37,50,99]};// TLS
  
      /* Exclamation */
      this.rules[13].opcodes = [];
      this.rules[13].opcodes[0] = {type: 7, string: [37,50,49]};// TLS
  
      /* LeftBracket */
      this.rules[14].opcodes = [];
      this.rules[14].opcodes[0] = {type: 7, string: [37,50,56]};// TLS
  
      /* RightBracket */
      this.rules[15].opcodes = [];
      this.rules[15].opcodes[0] = {type: 7, string: [37,50,57]};// TLS
  
      /* Asterisk */
      this.rules[16].opcodes = [];
      this.rules[16].opcodes[0] = {type: 7, string: [37,50,97]};// TLS
  
      /* Apostrophe */
      this.rules[17].opcodes = [];
      this.rules[17].opcodes[0] = {type: 7, string: [37,50,55]};// TLS
  
      /* Colon */
      this.rules[18].opcodes = [];
      this.rules[18].opcodes[0] = {type: 7, string: [37,51,97]};// TLS
  
      /* Semicolon */
      this.rules[19].opcodes = [];
      this.rules[19].opcodes[0] = {type: 7, string: [37,51,98]};// TLS
  
      /* LeftAngleBracket */
      this.rules[20].opcodes = [];
      this.rules[20].opcodes[0] = {type: 7, string: [37,51,99]};// TLS
  
      /* Equals */
      this.rules[21].opcodes = [];
      this.rules[21].opcodes[0] = {type: 7, string: [37,51,100]};// TLS
  
      /* RightAngleBracket */
      this.rules[22].opcodes = [];
      this.rules[22].opcodes[0] = {type: 7, string: [37,51,101]};// TLS
  
      /* QuestionMark */
      this.rules[23].opcodes = [];
      this.rules[23].opcodes[0] = {type: 7, string: [37,51,102]};// TLS
  
      /* XSYMBOL */
      this.rules[24].opcodes = [];
      this.rules[24].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]};// ALT
      this.rules[24].opcodes[1] = {type: 4, index: 6};// RNM(DoubleQuote)
      this.rules[24].opcodes[2] = {type: 7, string: [45]};// TLS
      this.rules[24].opcodes[3] = {type: 7, string: [46]};// TLS
      this.rules[24].opcodes[4] = {type: 7, string: [95]};// TLS
      this.rules[24].opcodes[5] = {type: 4, index: 13};// RNM(Exclamation)
      this.rules[24].opcodes[6] = {type: 4, index: 9};// RNM(Percent)
      this.rules[24].opcodes[7] = {type: 4, index: 10};// RNM(Ampersand)
      this.rules[24].opcodes[8] = {type: 4, index: 11};// RNM(Plus)
      this.rules[24].opcodes[9] = {type: 4, index: 12};// RNM(Comma)
      this.rules[24].opcodes[10] = {type: 4, index: 8};// RNM(ForwardSlash)
      this.rules[24].opcodes[11] = {type: 4, index: 16};// RNM(Asterisk)
      this.rules[24].opcodes[12] = {type: 4, index: 14};// RNM(LeftBracket)
      this.rules[24].opcodes[13] = {type: 4, index: 15};// RNM(RightBracket)
      this.rules[24].opcodes[14] = {type: 4, index: 17};// RNM(Apostrophe)
      this.rules[24].opcodes[15] = {type: 4, index: 19};// RNM(Semicolon)
      this.rules[24].opcodes[16] = {type: 4, index: 18};// RNM(Colon)
      this.rules[24].opcodes[17] = {type: 4, index: 20};// RNM(LeftAngleBracket)
      this.rules[24].opcodes[18] = {type: 4, index: 22};// RNM(RightAngleBracket)
      this.rules[24].opcodes[19] = {type: 4, index: 21};// RNM(Equals)
      this.rules[24].opcodes[20] = {type: 4, index: 23};// RNM(QuestionMark)
  
      /* YSYMBOL */
      this.rules[25].opcodes = [];
      this.rules[25].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
      this.rules[25].opcodes[1] = {type: 7, string: [45]};// TLS
      this.rules[25].opcodes[2] = {type: 4, index: 7};// RNM(Octothorpe)
      this.rules[25].opcodes[3] = {type: 4, index: 8};// RNM(ForwardSlash)
  
      /* XCHAR */
      this.rules[26].opcodes = [];
      this.rules[26].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
      this.rules[26].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[26].opcodes[2] = {type: 4, index: 2};// RNM(UPPERALPHA)
      this.rules[26].opcodes[3] = {type: 4, index: 3};// RNM(LOWERALPHA)
      this.rules[26].opcodes[4] = {type: 4, index: 24};// RNM(XSYMBOL)
  
      /* YCHAR */
      this.rules[27].opcodes = [];
      this.rules[27].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
      this.rules[27].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[27].opcodes[2] = {type: 4, index: 2};// RNM(UPPERALPHA)
      this.rules[27].opcodes[3] = {type: 4, index: 25};// RNM(YSYMBOL)
  
      /* gtin-code */
      this.rules[28].opcodes = [];
      this.rules[28].opcodes[0] = {type: 7, string: [48,49]};// TLS
  
      /* itip-code */
      this.rules[29].opcodes = [];
      this.rules[29].opcodes[0] = {type: 7, string: [56,48,48,54]};// TLS
  
      /* gmn-code */
      this.rules[30].opcodes = [];
      this.rules[30].opcodes[0] = {type: 7, string: [56,48,49,51]};// TLS
  
      /* cpid-code */
      this.rules[31].opcodes = [];
      this.rules[31].opcodes[0] = {type: 7, string: [56,48,49,48]};// TLS
  
      /* gln-code */
      this.rules[32].opcodes = [];
      this.rules[32].opcodes[0] = {type: 7, string: [52,49,52]};// TLS
  
      /* payTo-code */
      this.rules[33].opcodes = [];
      this.rules[33].opcodes[0] = {type: 7, string: [52,49,53]};// TLS
  
      /* partyGln-code */
      this.rules[34].opcodes = [];
      this.rules[34].opcodes[0] = {type: 7, string: [52,49,55]};// TLS
  
      /* gsrnp-code */
      this.rules[35].opcodes = [];
      this.rules[35].opcodes[0] = {type: 7, string: [56,48,49,55]};// TLS
  
      /* gsrn-code */
      this.rules[36].opcodes = [];
      this.rules[36].opcodes[0] = {type: 7, string: [56,48,49,56]};// TLS
  
      /* gcn-code */
      this.rules[37].opcodes = [];
      this.rules[37].opcodes[0] = {type: 7, string: [50,53,53]};// TLS
  
      /* sscc-code */
      this.rules[38].opcodes = [];
      this.rules[38].opcodes[0] = {type: 7, string: [48,48]};// TLS
  
      /* gdti-code */
      this.rules[39].opcodes = [];
      this.rules[39].opcodes[0] = {type: 7, string: [50,53,51]};// TLS
  
      /* ginc-code */
      this.rules[40].opcodes = [];
      this.rules[40].opcodes[0] = {type: 7, string: [52,48,49]};// TLS
  
      /* gsin-code */
      this.rules[41].opcodes = [];
      this.rules[41].opcodes[0] = {type: 7, string: [52,48,50]};// TLS
  
      /* grai-code */
      this.rules[42].opcodes = [];
      this.rules[42].opcodes[0] = {type: 7, string: [56,48,48,51]};// TLS
  
      /* giai-code */
      this.rules[43].opcodes = [];
      this.rules[43].opcodes[0] = {type: 7, string: [56,48,48,52]};// TLS
  
      /* cpv-code */
      this.rules[44].opcodes = [];
      this.rules[44].opcodes[0] = {type: 7, string: [50,50]};// TLS
  
      /* lot-code */
      this.rules[45].opcodes = [];
      this.rules[45].opcodes[0] = {type: 7, string: [49,48]};// TLS
  
      /* ser-code */
      this.rules[46].opcodes = [];
      this.rules[46].opcodes[0] = {type: 7, string: [50,49]};// TLS
  
      /* cpsn-code */
      this.rules[47].opcodes = [];
      this.rules[47].opcodes[0] = {type: 7, string: [56,48,49,49]};// TLS
  
      /* glnx-code */
      this.rules[48].opcodes = [];
      this.rules[48].opcodes[0] = {type: 7, string: [50,53,52]};// TLS
  
      /* refno-code */
      this.rules[49].opcodes = [];
      this.rules[49].opcodes[0] = {type: 7, string: [56,48,50,48]};// TLS
  
      /* srin-code */
      this.rules[50].opcodes = [];
      this.rules[50].opcodes[0] = {type: 7, string: [56,48,49,57]};// TLS
  
      /* tpx-code */
      this.rules[51].opcodes = [];
      this.rules[51].opcodes[0] = {type: 7, string: [50,51,53]};// TLS
  
      /* uic-ext-code */
      this.rules[52].opcodes = [];
      this.rules[52].opcodes[0] = {type: 7, string: [55,48,52,48]};// TLS
  
      /* gtin-value */
      this.rules[53].opcodes = [];
      this.rules[53].opcodes[0] = {type: 3, min: 14, max: 14};// REP
      this.rules[53].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* itip-value */
      this.rules[54].opcodes = [];
      this.rules[54].opcodes[0] = {type: 2, children: [1,3,5]};// CAT
      this.rules[54].opcodes[1] = {type: 3, min: 14, max: 14};// REP
      this.rules[54].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[54].opcodes[3] = {type: 3, min: 2, max: 2};// REP
      this.rules[54].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[54].opcodes[5] = {type: 3, min: 2, max: 2};// REP
      this.rules[54].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* gmn-value */
      this.rules[55].opcodes = [];
      this.rules[55].opcodes[0] = {type: 3, min: 1, max: 25};// REP
      this.rules[55].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* cpid-value */
      this.rules[56].opcodes = [];
      this.rules[56].opcodes[0] = {type: 3, min: 1, max: 30};// REP
      this.rules[56].opcodes[1] = {type: 4, index: 27};// RNM(YCHAR)
  
      /* gln-value */
      this.rules[57].opcodes = [];
      this.rules[57].opcodes[0] = {type: 3, min: 13, max: 13};// REP
      this.rules[57].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* payTo-value */
      this.rules[58].opcodes = [];
      this.rules[58].opcodes[0] = {type: 3, min: 13, max: 13};// REP
      this.rules[58].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* partyGln-value */
      this.rules[59].opcodes = [];
      this.rules[59].opcodes[0] = {type: 3, min: 13, max: 13};// REP
      this.rules[59].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* gsrnp-value */
      this.rules[60].opcodes = [];
      this.rules[60].opcodes[0] = {type: 3, min: 18, max: 18};// REP
      this.rules[60].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* gsrn-value */
      this.rules[61].opcodes = [];
      this.rules[61].opcodes[0] = {type: 3, min: 18, max: 18};// REP
      this.rules[61].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* gcn-value */
      this.rules[62].opcodes = [];
      this.rules[62].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[62].opcodes[1] = {type: 3, min: 13, max: 13};// REP
      this.rules[62].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[62].opcodes[3] = {type: 3, min: 0, max: 1};// REP
      this.rules[62].opcodes[4] = {type: 3, min: 1, max: 12};// REP
      this.rules[62].opcodes[5] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* sscc-value */
      this.rules[63].opcodes = [];
      this.rules[63].opcodes[0] = {type: 3, min: 18, max: 18};// REP
      this.rules[63].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* gdti-value */
      this.rules[64].opcodes = [];
      this.rules[64].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[64].opcodes[1] = {type: 3, min: 13, max: 13};// REP
      this.rules[64].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[64].opcodes[3] = {type: 3, min: 0, max: 1};// REP
      this.rules[64].opcodes[4] = {type: 3, min: 1, max: 17};// REP
      this.rules[64].opcodes[5] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* ginc-value */
      this.rules[65].opcodes = [];
      this.rules[65].opcodes[0] = {type: 3, min: 1, max: 30};// REP
      this.rules[65].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* gsin-value */
      this.rules[66].opcodes = [];
      this.rules[66].opcodes[0] = {type: 3, min: 17, max: 17};// REP
      this.rules[66].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* grai-value */
      this.rules[67].opcodes = [];
      this.rules[67].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[67].opcodes[1] = {type: 3, min: 14, max: 14};// REP
      this.rules[67].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[67].opcodes[3] = {type: 3, min: 0, max: 1};// REP
      this.rules[67].opcodes[4] = {type: 3, min: 1, max: 16};// REP
      this.rules[67].opcodes[5] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* giai-value */
      this.rules[68].opcodes = [];
      this.rules[68].opcodes[0] = {type: 3, min: 1, max: 30};// REP
      this.rules[68].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* cpv-value */
      this.rules[69].opcodes = [];
      this.rules[69].opcodes[0] = {type: 3, min: 1, max: 20};// REP
      this.rules[69].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* lot-value */
      this.rules[70].opcodes = [];
      this.rules[70].opcodes[0] = {type: 3, min: 1, max: 20};// REP
      this.rules[70].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* ser-value */
      this.rules[71].opcodes = [];
      this.rules[71].opcodes[0] = {type: 3, min: 1, max: 20};// REP
      this.rules[71].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* cpsn-value */
      this.rules[72].opcodes = [];
      this.rules[72].opcodes[0] = {type: 3, min: 1, max: 12};// REP
      this.rules[72].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* glnx-value */
      this.rules[73].opcodes = [];
      this.rules[73].opcodes[0] = {type: 3, min: 1, max: 20};// REP
      this.rules[73].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* refno-value */
      this.rules[74].opcodes = [];
      this.rules[74].opcodes[0] = {type: 3, min: 1, max: 25};// REP
      this.rules[74].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* srin-value */
      this.rules[75].opcodes = [];
      this.rules[75].opcodes[0] = {type: 3, min: 1, max: 10};// REP
      this.rules[75].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* tpx-value */
      this.rules[76].opcodes = [];
      this.rules[76].opcodes[0] = {type: 3, min: 1, max: 28};// REP
      this.rules[76].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* uic-ext-value */
      this.rules[77].opcodes = [];
      this.rules[77].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[77].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[77].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[77].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* gtin-comp */
      this.rules[78].opcodes = [];
      this.rules[78].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[78].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[78].opcodes[2] = {type: 4, index: 28};// RNM(gtin-code)
      this.rules[78].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[78].opcodes[4] = {type: 4, index: 53};// RNM(gtin-value)
  
      /* itip-comp */
      this.rules[79].opcodes = [];
      this.rules[79].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[79].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[79].opcodes[2] = {type: 4, index: 29};// RNM(itip-code)
      this.rules[79].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[79].opcodes[4] = {type: 4, index: 54};// RNM(itip-value)
  
      /* gmn-comp */
      this.rules[80].opcodes = [];
      this.rules[80].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[80].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[80].opcodes[2] = {type: 4, index: 30};// RNM(gmn-code)
      this.rules[80].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[80].opcodes[4] = {type: 4, index: 55};// RNM(gmn-value)
  
      /* cpid-comp */
      this.rules[81].opcodes = [];
      this.rules[81].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[81].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[81].opcodes[2] = {type: 4, index: 31};// RNM(cpid-code)
      this.rules[81].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[81].opcodes[4] = {type: 4, index: 56};// RNM(cpid-value)
  
      /* gln-comp */
      this.rules[82].opcodes = [];
      this.rules[82].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[82].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[82].opcodes[2] = {type: 4, index: 32};// RNM(gln-code)
      this.rules[82].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[82].opcodes[4] = {type: 4, index: 57};// RNM(gln-value)
  
      /* payTo-comp */
      this.rules[83].opcodes = [];
      this.rules[83].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[83].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[83].opcodes[2] = {type: 4, index: 33};// RNM(payTo-code)
      this.rules[83].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[83].opcodes[4] = {type: 4, index: 58};// RNM(payTo-value)
  
      /* partyGln-comp */
      this.rules[84].opcodes = [];
      this.rules[84].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[84].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[84].opcodes[2] = {type: 4, index: 34};// RNM(partyGln-code)
      this.rules[84].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[84].opcodes[4] = {type: 4, index: 59};// RNM(partyGln-value)
  
      /* gsrnp-comp */
      this.rules[85].opcodes = [];
      this.rules[85].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[85].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[85].opcodes[2] = {type: 4, index: 35};// RNM(gsrnp-code)
      this.rules[85].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[85].opcodes[4] = {type: 4, index: 60};// RNM(gsrnp-value)
  
      /* gsrn-comp */
      this.rules[86].opcodes = [];
      this.rules[86].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[86].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[86].opcodes[2] = {type: 4, index: 36};// RNM(gsrn-code)
      this.rules[86].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[86].opcodes[4] = {type: 4, index: 61};// RNM(gsrn-value)
  
      /* gcn-comp */
      this.rules[87].opcodes = [];
      this.rules[87].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[87].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[87].opcodes[2] = {type: 4, index: 37};// RNM(gcn-code)
      this.rules[87].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[87].opcodes[4] = {type: 4, index: 62};// RNM(gcn-value)
  
      /* sscc-comp */
      this.rules[88].opcodes = [];
      this.rules[88].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[88].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[88].opcodes[2] = {type: 4, index: 38};// RNM(sscc-code)
      this.rules[88].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[88].opcodes[4] = {type: 4, index: 63};// RNM(sscc-value)
  
      /* gdti-comp */
      this.rules[89].opcodes = [];
      this.rules[89].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[89].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[89].opcodes[2] = {type: 4, index: 39};// RNM(gdti-code)
      this.rules[89].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[89].opcodes[4] = {type: 4, index: 64};// RNM(gdti-value)
  
      /* ginc-comp */
      this.rules[90].opcodes = [];
      this.rules[90].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[90].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[90].opcodes[2] = {type: 4, index: 40};// RNM(ginc-code)
      this.rules[90].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[90].opcodes[4] = {type: 4, index: 65};// RNM(ginc-value)
  
      /* gsin-comp */
      this.rules[91].opcodes = [];
      this.rules[91].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[91].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[91].opcodes[2] = {type: 4, index: 41};// RNM(gsin-code)
      this.rules[91].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[91].opcodes[4] = {type: 4, index: 66};// RNM(gsin-value)
  
      /* grai-comp */
      this.rules[92].opcodes = [];
      this.rules[92].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[92].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[92].opcodes[2] = {type: 4, index: 42};// RNM(grai-code)
      this.rules[92].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[92].opcodes[4] = {type: 4, index: 67};// RNM(grai-value)
  
      /* giai-comp */
      this.rules[93].opcodes = [];
      this.rules[93].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[93].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[93].opcodes[2] = {type: 4, index: 43};// RNM(giai-code)
      this.rules[93].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[93].opcodes[4] = {type: 4, index: 68};// RNM(giai-value)
  
      /* cpv-comp */
      this.rules[94].opcodes = [];
      this.rules[94].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[94].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[94].opcodes[2] = {type: 4, index: 44};// RNM(cpv-code)
      this.rules[94].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[94].opcodes[4] = {type: 4, index: 69};// RNM(cpv-value)
  
      /* lot-comp */
      this.rules[95].opcodes = [];
      this.rules[95].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[95].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[95].opcodes[2] = {type: 4, index: 45};// RNM(lot-code)
      this.rules[95].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[95].opcodes[4] = {type: 4, index: 70};// RNM(lot-value)
  
      /* ser-comp */
      this.rules[96].opcodes = [];
      this.rules[96].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[96].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[96].opcodes[2] = {type: 4, index: 46};// RNM(ser-code)
      this.rules[96].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[96].opcodes[4] = {type: 4, index: 71};// RNM(ser-value)
  
      /* cpsn-comp */
      this.rules[97].opcodes = [];
      this.rules[97].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[97].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[97].opcodes[2] = {type: 4, index: 47};// RNM(cpsn-code)
      this.rules[97].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[97].opcodes[4] = {type: 4, index: 72};// RNM(cpsn-value)
  
      /* glnx-comp */
      this.rules[98].opcodes = [];
      this.rules[98].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[98].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[98].opcodes[2] = {type: 4, index: 48};// RNM(glnx-code)
      this.rules[98].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[98].opcodes[4] = {type: 4, index: 73};// RNM(glnx-value)
  
      /* refno-comp */
      this.rules[99].opcodes = [];
      this.rules[99].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[99].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[99].opcodes[2] = {type: 4, index: 49};// RNM(refno-code)
      this.rules[99].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[99].opcodes[4] = {type: 4, index: 74};// RNM(refno-value)
  
      /* srin-comp */
      this.rules[100].opcodes = [];
      this.rules[100].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[100].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[100].opcodes[2] = {type: 4, index: 50};// RNM(srin-code)
      this.rules[100].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[100].opcodes[4] = {type: 4, index: 75};// RNM(srin-value)
  
      /* tpx-comp */
      this.rules[101].opcodes = [];
      this.rules[101].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[101].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[101].opcodes[2] = {type: 4, index: 51};// RNM(tpx-code)
      this.rules[101].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[101].opcodes[4] = {type: 4, index: 76};// RNM(tpx-value)
  
      /* uic-ext-comp */
      this.rules[102].opcodes = [];
      this.rules[102].opcodes[0] = {type: 2, children: [1,2,3,4]};// CAT
      this.rules[102].opcodes[1] = {type: 7, string: [47]};// TLS
      this.rules[102].opcodes[2] = {type: 4, index: 52};// RNM(uic-ext-code)
      this.rules[102].opcodes[3] = {type: 7, string: [47]};// TLS
      this.rules[102].opcodes[4] = {type: 4, index: 77};// RNM(uic-ext-value)
  
      /* gtin-path */
      this.rules[103].opcodes = [];
      this.rules[103].opcodes[0] = {type: 2, children: [1,2,4,6]};// CAT
      this.rules[103].opcodes[1] = {type: 4, index: 78};// RNM(gtin-comp)
      this.rules[103].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[103].opcodes[3] = {type: 4, index: 94};// RNM(cpv-comp)
      this.rules[103].opcodes[4] = {type: 3, min: 0, max: 1};// REP
      this.rules[103].opcodes[5] = {type: 4, index: 95};// RNM(lot-comp)
      this.rules[103].opcodes[6] = {type: 3, min: 0, max: 1};// REP
      this.rules[103].opcodes[7] = {type: 4, index: 96};// RNM(ser-comp)
  
      /* itip-path */
      this.rules[104].opcodes = [];
      this.rules[104].opcodes[0] = {type: 2, children: [1,2,4,6]};// CAT
      this.rules[104].opcodes[1] = {type: 4, index: 79};// RNM(itip-comp)
      this.rules[104].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[104].opcodes[3] = {type: 4, index: 94};// RNM(cpv-comp)
      this.rules[104].opcodes[4] = {type: 3, min: 0, max: 1};// REP
      this.rules[104].opcodes[5] = {type: 4, index: 95};// RNM(lot-comp)
      this.rules[104].opcodes[6] = {type: 3, min: 0, max: 1};// REP
      this.rules[104].opcodes[7] = {type: 4, index: 96};// RNM(ser-comp)
  
      /* gmn-path */
      this.rules[105].opcodes = [];
      this.rules[105].opcodes[0] = {type: 4, index: 80};// RNM(gmn-comp)
  
      /* cpid-path */
      this.rules[106].opcodes = [];
      this.rules[106].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[106].opcodes[1] = {type: 4, index: 81};// RNM(cpid-comp)
      this.rules[106].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[106].opcodes[3] = {type: 4, index: 97};// RNM(cpsn-comp)
  
      /* gln-path */
      this.rules[107].opcodes = [];
      this.rules[107].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[107].opcodes[1] = {type: 4, index: 82};// RNM(gln-comp)
      this.rules[107].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[107].opcodes[3] = {type: 4, index: 98};// RNM(glnx-comp)
  
      /* payTo-path */
      this.rules[108].opcodes = [];
      this.rules[108].opcodes[0] = {type: 4, index: 83};// RNM(payTo-comp)
  
      /* partyGln-path */
      this.rules[109].opcodes = [];
      this.rules[109].opcodes[0] = {type: 4, index: 84};// RNM(partyGln-comp)
  
      /* gsrnp-path */
      this.rules[110].opcodes = [];
      this.rules[110].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[110].opcodes[1] = {type: 4, index: 85};// RNM(gsrnp-comp)
      this.rules[110].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[110].opcodes[3] = {type: 4, index: 100};// RNM(srin-comp)
  
      /* gsrn-path */
      this.rules[111].opcodes = [];
      this.rules[111].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[111].opcodes[1] = {type: 4, index: 86};// RNM(gsrn-comp)
      this.rules[111].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[111].opcodes[3] = {type: 4, index: 100};// RNM(srin-comp)
  
      /* gcn-path */
      this.rules[112].opcodes = [];
      this.rules[112].opcodes[0] = {type: 4, index: 87};// RNM(gcn-comp)
  
      /* sscc-path */
      this.rules[113].opcodes = [];
      this.rules[113].opcodes[0] = {type: 4, index: 88};// RNM(sscc-comp)
  
      /* gdti-path */
      this.rules[114].opcodes = [];
      this.rules[114].opcodes[0] = {type: 4, index: 89};// RNM(gdti-comp)
  
      /* ginc-path */
      this.rules[115].opcodes = [];
      this.rules[115].opcodes[0] = {type: 4, index: 90};// RNM(ginc-comp)
  
      /* gsin-path */
      this.rules[116].opcodes = [];
      this.rules[116].opcodes[0] = {type: 4, index: 91};// RNM(gsin-comp)
  
      /* grai-path */
      this.rules[117].opcodes = [];
      this.rules[117].opcodes[0] = {type: 4, index: 92};// RNM(grai-comp)
  
      /* giai-path */
      this.rules[118].opcodes = [];
      this.rules[118].opcodes[0] = {type: 4, index: 93};// RNM(giai-comp)
  
      /* upui-path */
      this.rules[119].opcodes = [];
      this.rules[119].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[119].opcodes[1] = {type: 4, index: 78};// RNM(gtin-comp)
      this.rules[119].opcodes[2] = {type: 4, index: 101};// RNM(tpx-comp)
  
      /* eoid-path */
      this.rules[120].opcodes = [];
      this.rules[120].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[120].opcodes[1] = {type: 4, index: 84};// RNM(partyGln-comp)
      this.rules[120].opcodes[2] = {type: 4, index: 102};// RNM(uic-ext-comp)
  
      /* fid-path */
      this.rules[121].opcodes = [];
      this.rules[121].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[121].opcodes[1] = {type: 4, index: 82};// RNM(gln-comp)
      this.rules[121].opcodes[2] = {type: 4, index: 102};// RNM(uic-ext-comp)
  
      /* mid-path */
      this.rules[122].opcodes = [];
      this.rules[122].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[122].opcodes[1] = {type: 4, index: 93};// RNM(giai-comp)
      this.rules[122].opcodes[2] = {type: 4, index: 102};// RNM(uic-ext-comp)
  
      /* gs1path */
      this.rules[123].opcodes = [];
      this.rules[123].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19]};// ALT
      this.rules[123].opcodes[1] = {type: 4, index: 103};// RNM(gtin-path)
      this.rules[123].opcodes[2] = {type: 4, index: 104};// RNM(itip-path)
      this.rules[123].opcodes[3] = {type: 4, index: 105};// RNM(gmn-path)
      this.rules[123].opcodes[4] = {type: 4, index: 106};// RNM(cpid-path)
      this.rules[123].opcodes[5] = {type: 4, index: 107};// RNM(gln-path)
      this.rules[123].opcodes[6] = {type: 4, index: 109};// RNM(partyGln-path)
      this.rules[123].opcodes[7] = {type: 4, index: 110};// RNM(gsrnp-path)
      this.rules[123].opcodes[8] = {type: 4, index: 111};// RNM(gsrn-path)
      this.rules[123].opcodes[9] = {type: 4, index: 112};// RNM(gcn-path)
      this.rules[123].opcodes[10] = {type: 4, index: 113};// RNM(sscc-path)
      this.rules[123].opcodes[11] = {type: 4, index: 114};// RNM(gdti-path)
      this.rules[123].opcodes[12] = {type: 4, index: 115};// RNM(ginc-path)
      this.rules[123].opcodes[13] = {type: 4, index: 116};// RNM(gsin-path)
      this.rules[123].opcodes[14] = {type: 4, index: 117};// RNM(grai-path)
      this.rules[123].opcodes[15] = {type: 4, index: 118};// RNM(giai-path)
      this.rules[123].opcodes[16] = {type: 4, index: 119};// RNM(upui-path)
      this.rules[123].opcodes[17] = {type: 4, index: 120};// RNM(eoid-path)
      this.rules[123].opcodes[18] = {type: 4, index: 121};// RNM(fid-path)
      this.rules[123].opcodes[19] = {type: 4, index: 122};// RNM(mid-path)
  
      /* netWeightVMTICode */
      this.rules[124].opcodes = [];
      this.rules[124].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[124].opcodes[1] = {type: 7, string: [51,49,48,48]};// TLS
      this.rules[124].opcodes[2] = {type: 7, string: [51,49,48,49]};// TLS
      this.rules[124].opcodes[3] = {type: 7, string: [51,49,48,50]};// TLS
      this.rules[124].opcodes[4] = {type: 7, string: [51,49,48,51]};// TLS
      this.rules[124].opcodes[5] = {type: 7, string: [51,49,48,52]};// TLS
      this.rules[124].opcodes[6] = {type: 7, string: [51,49,48,53]};// TLS
      this.rules[124].opcodes[7] = {type: 7, string: [51,50,48,48]};// TLS
      this.rules[124].opcodes[8] = {type: 7, string: [51,50,48,49]};// TLS
      this.rules[124].opcodes[9] = {type: 7, string: [51,50,48,50]};// TLS
      this.rules[124].opcodes[10] = {type: 7, string: [51,50,48,51]};// TLS
      this.rules[124].opcodes[11] = {type: 7, string: [51,50,48,52]};// TLS
      this.rules[124].opcodes[12] = {type: 7, string: [51,50,48,53]};// TLS
      this.rules[124].opcodes[13] = {type: 7, string: [51,53,54,48]};// TLS
      this.rules[124].opcodes[14] = {type: 7, string: [51,53,54,49]};// TLS
      this.rules[124].opcodes[15] = {type: 7, string: [51,53,54,50]};// TLS
      this.rules[124].opcodes[16] = {type: 7, string: [51,53,54,51]};// TLS
      this.rules[124].opcodes[17] = {type: 7, string: [51,53,54,52]};// TLS
      this.rules[124].opcodes[18] = {type: 7, string: [51,53,54,53]};// TLS
      this.rules[124].opcodes[19] = {type: 7, string: [51,53,55,48]};// TLS
      this.rules[124].opcodes[20] = {type: 7, string: [51,53,55,49]};// TLS
      this.rules[124].opcodes[21] = {type: 7, string: [51,53,55,50]};// TLS
      this.rules[124].opcodes[22] = {type: 7, string: [51,53,55,51]};// TLS
      this.rules[124].opcodes[23] = {type: 7, string: [51,53,55,52]};// TLS
      this.rules[124].opcodes[24] = {type: 7, string: [51,53,55,53]};// TLS
  
      /* netWeightVMTIValue */
      this.rules[125].opcodes = [];
      this.rules[125].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[125].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* netWeightVMTIParameter */
      this.rules[126].opcodes = [];
      this.rules[126].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[126].opcodes[1] = {type: 4, index: 124};// RNM(netWeightVMTICode)
      this.rules[126].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[126].opcodes[3] = {type: 4, index: 125};// RNM(netWeightVMTIValue)
  
      /* lengthVMTICode */
      this.rules[127].opcodes = [];
      this.rules[127].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[127].opcodes[1] = {type: 7, string: [51,49,49,48]};// TLS
      this.rules[127].opcodes[2] = {type: 7, string: [51,49,49,49]};// TLS
      this.rules[127].opcodes[3] = {type: 7, string: [51,49,49,50]};// TLS
      this.rules[127].opcodes[4] = {type: 7, string: [51,49,49,51]};// TLS
      this.rules[127].opcodes[5] = {type: 7, string: [51,49,49,52]};// TLS
      this.rules[127].opcodes[6] = {type: 7, string: [51,49,49,53]};// TLS
      this.rules[127].opcodes[7] = {type: 7, string: [51,50,49,48]};// TLS
      this.rules[127].opcodes[8] = {type: 7, string: [51,50,49,49]};// TLS
      this.rules[127].opcodes[9] = {type: 7, string: [51,50,49,50]};// TLS
      this.rules[127].opcodes[10] = {type: 7, string: [51,50,49,51]};// TLS
      this.rules[127].opcodes[11] = {type: 7, string: [51,50,49,52]};// TLS
      this.rules[127].opcodes[12] = {type: 7, string: [51,50,49,53]};// TLS
      this.rules[127].opcodes[13] = {type: 7, string: [51,50,50,48]};// TLS
      this.rules[127].opcodes[14] = {type: 7, string: [51,50,50,49]};// TLS
      this.rules[127].opcodes[15] = {type: 7, string: [51,50,50,50]};// TLS
      this.rules[127].opcodes[16] = {type: 7, string: [51,50,50,51]};// TLS
      this.rules[127].opcodes[17] = {type: 7, string: [51,50,50,52]};// TLS
      this.rules[127].opcodes[18] = {type: 7, string: [51,50,50,53]};// TLS
      this.rules[127].opcodes[19] = {type: 7, string: [51,50,51,48]};// TLS
      this.rules[127].opcodes[20] = {type: 7, string: [51,50,51,49]};// TLS
      this.rules[127].opcodes[21] = {type: 7, string: [51,50,51,50]};// TLS
      this.rules[127].opcodes[22] = {type: 7, string: [51,50,51,51]};// TLS
      this.rules[127].opcodes[23] = {type: 7, string: [51,50,51,52]};// TLS
      this.rules[127].opcodes[24] = {type: 7, string: [51,50,51,53]};// TLS
  
      /* lengthVMTIValue */
      this.rules[128].opcodes = [];
      this.rules[128].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[128].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* lengthVMTIParameter */
      this.rules[129].opcodes = [];
      this.rules[129].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[129].opcodes[1] = {type: 4, index: 127};// RNM(lengthVMTICode)
      this.rules[129].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[129].opcodes[3] = {type: 4, index: 128};// RNM(lengthVMTIValue)
  
      /* widthVMTICode */
      this.rules[130].opcodes = [];
      this.rules[130].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[130].opcodes[1] = {type: 7, string: [51,49,50,48]};// TLS
      this.rules[130].opcodes[2] = {type: 7, string: [51,49,50,49]};// TLS
      this.rules[130].opcodes[3] = {type: 7, string: [51,49,50,50]};// TLS
      this.rules[130].opcodes[4] = {type: 7, string: [51,49,50,51]};// TLS
      this.rules[130].opcodes[5] = {type: 7, string: [51,49,50,52]};// TLS
      this.rules[130].opcodes[6] = {type: 7, string: [51,49,50,53]};// TLS
      this.rules[130].opcodes[7] = {type: 7, string: [51,50,52,48]};// TLS
      this.rules[130].opcodes[8] = {type: 7, string: [51,50,52,49]};// TLS
      this.rules[130].opcodes[9] = {type: 7, string: [51,50,52,50]};// TLS
      this.rules[130].opcodes[10] = {type: 7, string: [51,50,52,51]};// TLS
      this.rules[130].opcodes[11] = {type: 7, string: [51,50,52,52]};// TLS
      this.rules[130].opcodes[12] = {type: 7, string: [51,50,52,53]};// TLS
      this.rules[130].opcodes[13] = {type: 7, string: [51,50,53,48]};// TLS
      this.rules[130].opcodes[14] = {type: 7, string: [51,50,53,49]};// TLS
      this.rules[130].opcodes[15] = {type: 7, string: [51,50,53,50]};// TLS
      this.rules[130].opcodes[16] = {type: 7, string: [51,50,53,51]};// TLS
      this.rules[130].opcodes[17] = {type: 7, string: [51,50,53,52]};// TLS
      this.rules[130].opcodes[18] = {type: 7, string: [51,50,53,53]};// TLS
      this.rules[130].opcodes[19] = {type: 7, string: [51,50,54,48]};// TLS
      this.rules[130].opcodes[20] = {type: 7, string: [51,50,54,49]};// TLS
      this.rules[130].opcodes[21] = {type: 7, string: [51,50,54,50]};// TLS
      this.rules[130].opcodes[22] = {type: 7, string: [51,50,54,51]};// TLS
      this.rules[130].opcodes[23] = {type: 7, string: [51,50,54,52]};// TLS
      this.rules[130].opcodes[24] = {type: 7, string: [51,50,54,53]};// TLS
  
      /* widthVMTIValue */
      this.rules[131].opcodes = [];
      this.rules[131].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[131].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* widthVMTIParameter */
      this.rules[132].opcodes = [];
      this.rules[132].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[132].opcodes[1] = {type: 4, index: 130};// RNM(widthVMTICode)
      this.rules[132].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[132].opcodes[3] = {type: 4, index: 131};// RNM(widthVMTIValue)
  
      /* depthVMTICode */
      this.rules[133].opcodes = [];
      this.rules[133].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[133].opcodes[1] = {type: 7, string: [51,49,51,48]};// TLS
      this.rules[133].opcodes[2] = {type: 7, string: [51,49,51,49]};// TLS
      this.rules[133].opcodes[3] = {type: 7, string: [51,49,51,50]};// TLS
      this.rules[133].opcodes[4] = {type: 7, string: [51,49,51,51]};// TLS
      this.rules[133].opcodes[5] = {type: 7, string: [51,49,51,52]};// TLS
      this.rules[133].opcodes[6] = {type: 7, string: [51,49,51,53]};// TLS
      this.rules[133].opcodes[7] = {type: 7, string: [51,50,55,48]};// TLS
      this.rules[133].opcodes[8] = {type: 7, string: [51,50,55,49]};// TLS
      this.rules[133].opcodes[9] = {type: 7, string: [51,50,55,50]};// TLS
      this.rules[133].opcodes[10] = {type: 7, string: [51,50,55,51]};// TLS
      this.rules[133].opcodes[11] = {type: 7, string: [51,50,55,52]};// TLS
      this.rules[133].opcodes[12] = {type: 7, string: [51,50,55,53]};// TLS
      this.rules[133].opcodes[13] = {type: 7, string: [51,50,56,48]};// TLS
      this.rules[133].opcodes[14] = {type: 7, string: [51,50,56,49]};// TLS
      this.rules[133].opcodes[15] = {type: 7, string: [51,50,56,50]};// TLS
      this.rules[133].opcodes[16] = {type: 7, string: [51,50,56,51]};// TLS
      this.rules[133].opcodes[17] = {type: 7, string: [51,50,56,52]};// TLS
      this.rules[133].opcodes[18] = {type: 7, string: [51,50,56,53]};// TLS
      this.rules[133].opcodes[19] = {type: 7, string: [51,50,57,48]};// TLS
      this.rules[133].opcodes[20] = {type: 7, string: [51,50,57,49]};// TLS
      this.rules[133].opcodes[21] = {type: 7, string: [51,50,57,50]};// TLS
      this.rules[133].opcodes[22] = {type: 7, string: [51,50,57,51]};// TLS
      this.rules[133].opcodes[23] = {type: 7, string: [51,50,57,52]};// TLS
      this.rules[133].opcodes[24] = {type: 7, string: [51,50,57,53]};// TLS
  
      /* depthVMTIValue */
      this.rules[134].opcodes = [];
      this.rules[134].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[134].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* depthVMTIParameter */
      this.rules[135].opcodes = [];
      this.rules[135].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[135].opcodes[1] = {type: 4, index: 133};// RNM(depthVMTICode)
      this.rules[135].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[135].opcodes[3] = {type: 4, index: 134};// RNM(depthVMTIValue)
  
      /* areaVMTICode */
      this.rules[136].opcodes = [];
      this.rules[136].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[136].opcodes[1] = {type: 7, string: [51,49,52,48]};// TLS
      this.rules[136].opcodes[2] = {type: 7, string: [51,49,52,49]};// TLS
      this.rules[136].opcodes[3] = {type: 7, string: [51,49,52,50]};// TLS
      this.rules[136].opcodes[4] = {type: 7, string: [51,49,52,51]};// TLS
      this.rules[136].opcodes[5] = {type: 7, string: [51,49,52,52]};// TLS
      this.rules[136].opcodes[6] = {type: 7, string: [51,49,52,53]};// TLS
      this.rules[136].opcodes[7] = {type: 7, string: [51,53,48,48]};// TLS
      this.rules[136].opcodes[8] = {type: 7, string: [51,53,48,49]};// TLS
      this.rules[136].opcodes[9] = {type: 7, string: [51,53,48,50]};// TLS
      this.rules[136].opcodes[10] = {type: 7, string: [51,53,48,51]};// TLS
      this.rules[136].opcodes[11] = {type: 7, string: [51,53,48,52]};// TLS
      this.rules[136].opcodes[12] = {type: 7, string: [51,53,48,53]};// TLS
      this.rules[136].opcodes[13] = {type: 7, string: [51,53,49,48]};// TLS
      this.rules[136].opcodes[14] = {type: 7, string: [51,53,49,49]};// TLS
      this.rules[136].opcodes[15] = {type: 7, string: [51,53,49,50]};// TLS
      this.rules[136].opcodes[16] = {type: 7, string: [51,53,49,51]};// TLS
      this.rules[136].opcodes[17] = {type: 7, string: [51,53,49,52]};// TLS
      this.rules[136].opcodes[18] = {type: 7, string: [51,53,49,53]};// TLS
      this.rules[136].opcodes[19] = {type: 7, string: [51,53,50,48]};// TLS
      this.rules[136].opcodes[20] = {type: 7, string: [51,53,50,49]};// TLS
      this.rules[136].opcodes[21] = {type: 7, string: [51,53,50,50]};// TLS
      this.rules[136].opcodes[22] = {type: 7, string: [51,53,50,51]};// TLS
      this.rules[136].opcodes[23] = {type: 7, string: [51,53,50,52]};// TLS
      this.rules[136].opcodes[24] = {type: 7, string: [51,53,50,53]};// TLS
  
      /* areaVMTIValue */
      this.rules[137].opcodes = [];
      this.rules[137].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[137].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* areaVMTIParameter */
      this.rules[138].opcodes = [];
      this.rules[138].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[138].opcodes[1] = {type: 4, index: 136};// RNM(areaVMTICode)
      this.rules[138].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[138].opcodes[3] = {type: 4, index: 137};// RNM(areaVMTIValue)
  
      /* netVolumeVMTICode */
      this.rules[139].opcodes = [];
      this.rules[139].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42]};// ALT
      this.rules[139].opcodes[1] = {type: 7, string: [51,49,53,48]};// TLS
      this.rules[139].opcodes[2] = {type: 7, string: [51,49,53,49]};// TLS
      this.rules[139].opcodes[3] = {type: 7, string: [51,49,53,50]};// TLS
      this.rules[139].opcodes[4] = {type: 7, string: [51,49,53,51]};// TLS
      this.rules[139].opcodes[5] = {type: 7, string: [51,49,53,52]};// TLS
      this.rules[139].opcodes[6] = {type: 7, string: [51,49,53,53]};// TLS
      this.rules[139].opcodes[7] = {type: 7, string: [51,49,54,48]};// TLS
      this.rules[139].opcodes[8] = {type: 7, string: [51,49,54,49]};// TLS
      this.rules[139].opcodes[9] = {type: 7, string: [51,49,54,50]};// TLS
      this.rules[139].opcodes[10] = {type: 7, string: [51,49,54,51]};// TLS
      this.rules[139].opcodes[11] = {type: 7, string: [51,49,54,52]};// TLS
      this.rules[139].opcodes[12] = {type: 7, string: [51,49,54,53]};// TLS
      this.rules[139].opcodes[13] = {type: 7, string: [51,54,48,48]};// TLS
      this.rules[139].opcodes[14] = {type: 7, string: [51,54,48,49]};// TLS
      this.rules[139].opcodes[15] = {type: 7, string: [51,54,48,50]};// TLS
      this.rules[139].opcodes[16] = {type: 7, string: [51,54,48,51]};// TLS
      this.rules[139].opcodes[17] = {type: 7, string: [51,54,48,52]};// TLS
      this.rules[139].opcodes[18] = {type: 7, string: [51,54,48,53]};// TLS
      this.rules[139].opcodes[19] = {type: 7, string: [51,54,49,48]};// TLS
      this.rules[139].opcodes[20] = {type: 7, string: [51,54,49,49]};// TLS
      this.rules[139].opcodes[21] = {type: 7, string: [51,54,49,50]};// TLS
      this.rules[139].opcodes[22] = {type: 7, string: [51,54,49,51]};// TLS
      this.rules[139].opcodes[23] = {type: 7, string: [51,54,49,52]};// TLS
      this.rules[139].opcodes[24] = {type: 7, string: [51,54,49,53]};// TLS
      this.rules[139].opcodes[25] = {type: 7, string: [51,54,52,48]};// TLS
      this.rules[139].opcodes[26] = {type: 7, string: [51,54,52,49]};// TLS
      this.rules[139].opcodes[27] = {type: 7, string: [51,54,52,50]};// TLS
      this.rules[139].opcodes[28] = {type: 7, string: [51,54,52,51]};// TLS
      this.rules[139].opcodes[29] = {type: 7, string: [51,54,52,52]};// TLS
      this.rules[139].opcodes[30] = {type: 7, string: [51,54,52,53]};// TLS
      this.rules[139].opcodes[31] = {type: 7, string: [51,54,53,48]};// TLS
      this.rules[139].opcodes[32] = {type: 7, string: [51,54,53,49]};// TLS
      this.rules[139].opcodes[33] = {type: 7, string: [51,54,53,50]};// TLS
      this.rules[139].opcodes[34] = {type: 7, string: [51,54,53,51]};// TLS
      this.rules[139].opcodes[35] = {type: 7, string: [51,54,53,52]};// TLS
      this.rules[139].opcodes[36] = {type: 7, string: [51,54,53,53]};// TLS
      this.rules[139].opcodes[37] = {type: 7, string: [51,54,54,48]};// TLS
      this.rules[139].opcodes[38] = {type: 7, string: [51,54,54,49]};// TLS
      this.rules[139].opcodes[39] = {type: 7, string: [51,54,54,50]};// TLS
      this.rules[139].opcodes[40] = {type: 7, string: [51,54,54,51]};// TLS
      this.rules[139].opcodes[41] = {type: 7, string: [51,54,54,52]};// TLS
      this.rules[139].opcodes[42] = {type: 7, string: [51,54,54,53]};// TLS
  
      /* netVolumeVMTIValue */
      this.rules[140].opcodes = [];
      this.rules[140].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[140].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* netVolumeVMTIParameter */
      this.rules[141].opcodes = [];
      this.rules[141].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[141].opcodes[1] = {type: 4, index: 139};// RNM(netVolumeVMTICode)
      this.rules[141].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[141].opcodes[3] = {type: 4, index: 140};// RNM(netVolumeVMTIValue)
  
      /* massPerUnitAreaVMTICode */
      this.rules[142].opcodes = [];
      this.rules[142].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[142].opcodes[1] = {type: 7, string: [51,51,55,48]};// TLS
      this.rules[142].opcodes[2] = {type: 7, string: [51,51,55,49]};// TLS
      this.rules[142].opcodes[3] = {type: 7, string: [51,51,55,50]};// TLS
      this.rules[142].opcodes[4] = {type: 7, string: [51,51,55,51]};// TLS
      this.rules[142].opcodes[5] = {type: 7, string: [51,51,55,52]};// TLS
      this.rules[142].opcodes[6] = {type: 7, string: [51,51,55,53]};// TLS
  
      /* massPerUnitAreaVMTIValue */
      this.rules[143].opcodes = [];
      this.rules[143].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[143].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* massPerUnitAreaVMTIParameter */
      this.rules[144].opcodes = [];
      this.rules[144].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[144].opcodes[1] = {type: 4, index: 142};// RNM(massPerUnitAreaVMTICode)
      this.rules[144].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[144].opcodes[3] = {type: 4, index: 143};// RNM(massPerUnitAreaVMTIValue)
  
      /* grossWeightCode */
      this.rules[145].opcodes = [];
      this.rules[145].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12]};// ALT
      this.rules[145].opcodes[1] = {type: 7, string: [51,51,48,48]};// TLS
      this.rules[145].opcodes[2] = {type: 7, string: [51,51,48,49]};// TLS
      this.rules[145].opcodes[3] = {type: 7, string: [51,51,48,50]};// TLS
      this.rules[145].opcodes[4] = {type: 7, string: [51,51,48,51]};// TLS
      this.rules[145].opcodes[5] = {type: 7, string: [51,51,48,52]};// TLS
      this.rules[145].opcodes[6] = {type: 7, string: [51,51,48,53]};// TLS
      this.rules[145].opcodes[7] = {type: 7, string: [51,52,48,48]};// TLS
      this.rules[145].opcodes[8] = {type: 7, string: [51,52,48,49]};// TLS
      this.rules[145].opcodes[9] = {type: 7, string: [51,52,48,50]};// TLS
      this.rules[145].opcodes[10] = {type: 7, string: [51,52,48,51]};// TLS
      this.rules[145].opcodes[11] = {type: 7, string: [51,52,48,52]};// TLS
      this.rules[145].opcodes[12] = {type: 7, string: [51,52,48,53]};// TLS
  
      /* grossWeightValue */
      this.rules[146].opcodes = [];
      this.rules[146].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[146].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* grossWeightParameter */
      this.rules[147].opcodes = [];
      this.rules[147].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[147].opcodes[1] = {type: 4, index: 145};// RNM(grossWeightCode)
      this.rules[147].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[147].opcodes[3] = {type: 4, index: 146};// RNM(grossWeightValue)
  
      /* logisticLengthCode */
      this.rules[148].opcodes = [];
      this.rules[148].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[148].opcodes[1] = {type: 7, string: [51,51,49,48]};// TLS
      this.rules[148].opcodes[2] = {type: 7, string: [51,51,49,49]};// TLS
      this.rules[148].opcodes[3] = {type: 7, string: [51,51,49,50]};// TLS
      this.rules[148].opcodes[4] = {type: 7, string: [51,51,49,51]};// TLS
      this.rules[148].opcodes[5] = {type: 7, string: [51,51,49,52]};// TLS
      this.rules[148].opcodes[6] = {type: 7, string: [51,51,49,53]};// TLS
      this.rules[148].opcodes[7] = {type: 7, string: [51,52,49,48]};// TLS
      this.rules[148].opcodes[8] = {type: 7, string: [51,52,49,49]};// TLS
      this.rules[148].opcodes[9] = {type: 7, string: [51,52,49,50]};// TLS
      this.rules[148].opcodes[10] = {type: 7, string: [51,52,49,51]};// TLS
      this.rules[148].opcodes[11] = {type: 7, string: [51,52,49,52]};// TLS
      this.rules[148].opcodes[12] = {type: 7, string: [51,52,49,53]};// TLS
      this.rules[148].opcodes[13] = {type: 7, string: [51,52,50,48]};// TLS
      this.rules[148].opcodes[14] = {type: 7, string: [51,52,50,49]};// TLS
      this.rules[148].opcodes[15] = {type: 7, string: [51,52,50,50]};// TLS
      this.rules[148].opcodes[16] = {type: 7, string: [51,52,50,51]};// TLS
      this.rules[148].opcodes[17] = {type: 7, string: [51,52,50,52]};// TLS
      this.rules[148].opcodes[18] = {type: 7, string: [51,52,50,53]};// TLS
      this.rules[148].opcodes[19] = {type: 7, string: [51,52,51,48]};// TLS
      this.rules[148].opcodes[20] = {type: 7, string: [51,52,51,49]};// TLS
      this.rules[148].opcodes[21] = {type: 7, string: [51,52,51,50]};// TLS
      this.rules[148].opcodes[22] = {type: 7, string: [51,52,51,51]};// TLS
      this.rules[148].opcodes[23] = {type: 7, string: [51,52,51,52]};// TLS
      this.rules[148].opcodes[24] = {type: 7, string: [51,52,51,53]};// TLS
  
      /* logisticLengthValue */
      this.rules[149].opcodes = [];
      this.rules[149].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[149].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* logisticLengthParameter */
      this.rules[150].opcodes = [];
      this.rules[150].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[150].opcodes[1] = {type: 4, index: 148};// RNM(logisticLengthCode)
      this.rules[150].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[150].opcodes[3] = {type: 4, index: 149};// RNM(logisticLengthValue)
  
      /* logisticWidthCode */
      this.rules[151].opcodes = [];
      this.rules[151].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[151].opcodes[1] = {type: 7, string: [51,51,50,48]};// TLS
      this.rules[151].opcodes[2] = {type: 7, string: [51,51,50,49]};// TLS
      this.rules[151].opcodes[3] = {type: 7, string: [51,51,50,50]};// TLS
      this.rules[151].opcodes[4] = {type: 7, string: [51,51,50,51]};// TLS
      this.rules[151].opcodes[5] = {type: 7, string: [51,51,50,52]};// TLS
      this.rules[151].opcodes[6] = {type: 7, string: [51,51,50,53]};// TLS
      this.rules[151].opcodes[7] = {type: 7, string: [51,52,52,48]};// TLS
      this.rules[151].opcodes[8] = {type: 7, string: [51,52,52,49]};// TLS
      this.rules[151].opcodes[9] = {type: 7, string: [51,52,52,50]};// TLS
      this.rules[151].opcodes[10] = {type: 7, string: [51,52,52,51]};// TLS
      this.rules[151].opcodes[11] = {type: 7, string: [51,52,52,52]};// TLS
      this.rules[151].opcodes[12] = {type: 7, string: [51,52,52,53]};// TLS
      this.rules[151].opcodes[13] = {type: 7, string: [51,52,53,48]};// TLS
      this.rules[151].opcodes[14] = {type: 7, string: [51,52,53,49]};// TLS
      this.rules[151].opcodes[15] = {type: 7, string: [51,52,53,50]};// TLS
      this.rules[151].opcodes[16] = {type: 7, string: [51,52,53,51]};// TLS
      this.rules[151].opcodes[17] = {type: 7, string: [51,52,53,52]};// TLS
      this.rules[151].opcodes[18] = {type: 7, string: [51,52,53,53]};// TLS
      this.rules[151].opcodes[19] = {type: 7, string: [51,52,54,48]};// TLS
      this.rules[151].opcodes[20] = {type: 7, string: [51,52,54,49]};// TLS
      this.rules[151].opcodes[21] = {type: 7, string: [51,52,54,50]};// TLS
      this.rules[151].opcodes[22] = {type: 7, string: [51,52,54,51]};// TLS
      this.rules[151].opcodes[23] = {type: 7, string: [51,52,54,52]};// TLS
      this.rules[151].opcodes[24] = {type: 7, string: [51,52,54,53]};// TLS
  
      /* logisticWidthValue */
      this.rules[152].opcodes = [];
      this.rules[152].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[152].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* logisticWidthParameter */
      this.rules[153].opcodes = [];
      this.rules[153].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[153].opcodes[1] = {type: 4, index: 151};// RNM(logisticWidthCode)
      this.rules[153].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[153].opcodes[3] = {type: 4, index: 152};// RNM(logisticWidthValue)
  
      /* logisticDepthCode */
      this.rules[154].opcodes = [];
      this.rules[154].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[154].opcodes[1] = {type: 7, string: [51,51,51,48]};// TLS
      this.rules[154].opcodes[2] = {type: 7, string: [51,51,51,49]};// TLS
      this.rules[154].opcodes[3] = {type: 7, string: [51,51,51,50]};// TLS
      this.rules[154].opcodes[4] = {type: 7, string: [51,51,51,51]};// TLS
      this.rules[154].opcodes[5] = {type: 7, string: [51,51,51,52]};// TLS
      this.rules[154].opcodes[6] = {type: 7, string: [51,51,51,53]};// TLS
      this.rules[154].opcodes[7] = {type: 7, string: [51,52,55,48]};// TLS
      this.rules[154].opcodes[8] = {type: 7, string: [51,52,55,49]};// TLS
      this.rules[154].opcodes[9] = {type: 7, string: [51,52,55,50]};// TLS
      this.rules[154].opcodes[10] = {type: 7, string: [51,52,55,51]};// TLS
      this.rules[154].opcodes[11] = {type: 7, string: [51,52,55,52]};// TLS
      this.rules[154].opcodes[12] = {type: 7, string: [51,52,55,53]};// TLS
      this.rules[154].opcodes[13] = {type: 7, string: [51,52,56,48]};// TLS
      this.rules[154].opcodes[14] = {type: 7, string: [51,52,56,49]};// TLS
      this.rules[154].opcodes[15] = {type: 7, string: [51,52,56,50]};// TLS
      this.rules[154].opcodes[16] = {type: 7, string: [51,52,56,51]};// TLS
      this.rules[154].opcodes[17] = {type: 7, string: [51,52,56,52]};// TLS
      this.rules[154].opcodes[18] = {type: 7, string: [51,52,56,53]};// TLS
      this.rules[154].opcodes[19] = {type: 7, string: [51,52,57,48]};// TLS
      this.rules[154].opcodes[20] = {type: 7, string: [51,52,57,49]};// TLS
      this.rules[154].opcodes[21] = {type: 7, string: [51,52,57,50]};// TLS
      this.rules[154].opcodes[22] = {type: 7, string: [51,52,57,51]};// TLS
      this.rules[154].opcodes[23] = {type: 7, string: [51,52,57,52]};// TLS
      this.rules[154].opcodes[24] = {type: 7, string: [51,52,57,53]};// TLS
  
      /* logisticDepthValue */
      this.rules[155].opcodes = [];
      this.rules[155].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[155].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* logisticDepthParameter */
      this.rules[156].opcodes = [];
      this.rules[156].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[156].opcodes[1] = {type: 4, index: 154};// RNM(logisticDepthCode)
      this.rules[156].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[156].opcodes[3] = {type: 4, index: 155};// RNM(logisticDepthValue)
  
      /* logisticAreaCode */
      this.rules[157].opcodes = [];
      this.rules[157].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]};// ALT
      this.rules[157].opcodes[1] = {type: 7, string: [51,51,52,48]};// TLS
      this.rules[157].opcodes[2] = {type: 7, string: [51,51,52,49]};// TLS
      this.rules[157].opcodes[3] = {type: 7, string: [51,51,52,50]};// TLS
      this.rules[157].opcodes[4] = {type: 7, string: [51,51,52,51]};// TLS
      this.rules[157].opcodes[5] = {type: 7, string: [51,51,52,52]};// TLS
      this.rules[157].opcodes[6] = {type: 7, string: [51,51,52,53]};// TLS
      this.rules[157].opcodes[7] = {type: 7, string: [51,53,51,48]};// TLS
      this.rules[157].opcodes[8] = {type: 7, string: [51,53,51,49]};// TLS
      this.rules[157].opcodes[9] = {type: 7, string: [51,53,51,50]};// TLS
      this.rules[157].opcodes[10] = {type: 7, string: [51,53,51,51]};// TLS
      this.rules[157].opcodes[11] = {type: 7, string: [51,53,51,52]};// TLS
      this.rules[157].opcodes[12] = {type: 7, string: [51,53,51,53]};// TLS
      this.rules[157].opcodes[13] = {type: 7, string: [51,53,52,48]};// TLS
      this.rules[157].opcodes[14] = {type: 7, string: [51,53,52,49]};// TLS
      this.rules[157].opcodes[15] = {type: 7, string: [51,53,52,50]};// TLS
      this.rules[157].opcodes[16] = {type: 7, string: [51,53,52,51]};// TLS
      this.rules[157].opcodes[17] = {type: 7, string: [51,53,52,52]};// TLS
      this.rules[157].opcodes[18] = {type: 7, string: [51,53,52,53]};// TLS
      this.rules[157].opcodes[19] = {type: 7, string: [51,53,53,48]};// TLS
      this.rules[157].opcodes[20] = {type: 7, string: [51,53,53,49]};// TLS
      this.rules[157].opcodes[21] = {type: 7, string: [51,53,53,50]};// TLS
      this.rules[157].opcodes[22] = {type: 7, string: [51,53,53,51]};// TLS
      this.rules[157].opcodes[23] = {type: 7, string: [51,53,53,52]};// TLS
      this.rules[157].opcodes[24] = {type: 7, string: [51,53,53,53]};// TLS
  
      /* logisticAreaValue */
      this.rules[158].opcodes = [];
      this.rules[158].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[158].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* logisticAreaParameter */
      this.rules[159].opcodes = [];
      this.rules[159].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[159].opcodes[1] = {type: 4, index: 157};// RNM(logisticAreaCode)
      this.rules[159].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[159].opcodes[3] = {type: 4, index: 158};// RNM(logisticAreaValue)
  
      /* logisticVolumeCode */
      this.rules[160].opcodes = [];
      this.rules[160].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42]};// ALT
      this.rules[160].opcodes[1] = {type: 7, string: [51,51,53,48]};// TLS
      this.rules[160].opcodes[2] = {type: 7, string: [51,51,53,49]};// TLS
      this.rules[160].opcodes[3] = {type: 7, string: [51,51,53,50]};// TLS
      this.rules[160].opcodes[4] = {type: 7, string: [51,51,53,51]};// TLS
      this.rules[160].opcodes[5] = {type: 7, string: [51,51,53,52]};// TLS
      this.rules[160].opcodes[6] = {type: 7, string: [51,51,53,53]};// TLS
      this.rules[160].opcodes[7] = {type: 7, string: [51,51,54,48]};// TLS
      this.rules[160].opcodes[8] = {type: 7, string: [51,51,54,49]};// TLS
      this.rules[160].opcodes[9] = {type: 7, string: [51,51,54,50]};// TLS
      this.rules[160].opcodes[10] = {type: 7, string: [51,51,54,51]};// TLS
      this.rules[160].opcodes[11] = {type: 7, string: [51,51,54,52]};// TLS
      this.rules[160].opcodes[12] = {type: 7, string: [51,51,54,53]};// TLS
      this.rules[160].opcodes[13] = {type: 7, string: [51,54,50,48]};// TLS
      this.rules[160].opcodes[14] = {type: 7, string: [51,54,50,49]};// TLS
      this.rules[160].opcodes[15] = {type: 7, string: [51,54,50,50]};// TLS
      this.rules[160].opcodes[16] = {type: 7, string: [51,54,50,51]};// TLS
      this.rules[160].opcodes[17] = {type: 7, string: [51,54,50,52]};// TLS
      this.rules[160].opcodes[18] = {type: 7, string: [51,54,50,53]};// TLS
      this.rules[160].opcodes[19] = {type: 7, string: [51,54,51,48]};// TLS
      this.rules[160].opcodes[20] = {type: 7, string: [51,54,51,49]};// TLS
      this.rules[160].opcodes[21] = {type: 7, string: [51,54,51,50]};// TLS
      this.rules[160].opcodes[22] = {type: 7, string: [51,54,51,51]};// TLS
      this.rules[160].opcodes[23] = {type: 7, string: [51,54,51,52]};// TLS
      this.rules[160].opcodes[24] = {type: 7, string: [51,54,51,53]};// TLS
      this.rules[160].opcodes[25] = {type: 7, string: [51,54,55,48]};// TLS
      this.rules[160].opcodes[26] = {type: 7, string: [51,54,55,49]};// TLS
      this.rules[160].opcodes[27] = {type: 7, string: [51,54,55,50]};// TLS
      this.rules[160].opcodes[28] = {type: 7, string: [51,54,55,51]};// TLS
      this.rules[160].opcodes[29] = {type: 7, string: [51,54,55,52]};// TLS
      this.rules[160].opcodes[30] = {type: 7, string: [51,54,55,53]};// TLS
      this.rules[160].opcodes[31] = {type: 7, string: [51,54,56,48]};// TLS
      this.rules[160].opcodes[32] = {type: 7, string: [51,54,56,49]};// TLS
      this.rules[160].opcodes[33] = {type: 7, string: [51,54,56,50]};// TLS
      this.rules[160].opcodes[34] = {type: 7, string: [51,54,56,51]};// TLS
      this.rules[160].opcodes[35] = {type: 7, string: [51,54,56,52]};// TLS
      this.rules[160].opcodes[36] = {type: 7, string: [51,54,56,53]};// TLS
      this.rules[160].opcodes[37] = {type: 7, string: [51,54,57,48]};// TLS
      this.rules[160].opcodes[38] = {type: 7, string: [51,54,57,49]};// TLS
      this.rules[160].opcodes[39] = {type: 7, string: [51,54,57,50]};// TLS
      this.rules[160].opcodes[40] = {type: 7, string: [51,54,57,51]};// TLS
      this.rules[160].opcodes[41] = {type: 7, string: [51,54,57,52]};// TLS
      this.rules[160].opcodes[42] = {type: 7, string: [51,54,57,53]};// TLS
  
      /* logisticVolumeValue */
      this.rules[161].opcodes = [];
      this.rules[161].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[161].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* logisticVolumeParameter */
      this.rules[162].opcodes = [];
      this.rules[162].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[162].opcodes[1] = {type: 4, index: 160};// RNM(logisticVolumeCode)
      this.rules[162].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[162].opcodes[3] = {type: 4, index: 161};// RNM(logisticVolumeValue)
  
      /* processorCode */
      this.rules[163].opcodes = [];
      this.rules[163].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
      this.rules[163].opcodes[1] = {type: 7, string: [55,48,51,48]};// TLS
      this.rules[163].opcodes[2] = {type: 7, string: [55,48,51,49]};// TLS
      this.rules[163].opcodes[3] = {type: 7, string: [55,48,51,50]};// TLS
      this.rules[163].opcodes[4] = {type: 7, string: [55,48,51,51]};// TLS
      this.rules[163].opcodes[5] = {type: 7, string: [55,48,51,52]};// TLS
      this.rules[163].opcodes[6] = {type: 7, string: [55,48,51,53]};// TLS
      this.rules[163].opcodes[7] = {type: 7, string: [55,48,51,54]};// TLS
      this.rules[163].opcodes[8] = {type: 7, string: [55,48,51,55]};// TLS
      this.rules[163].opcodes[9] = {type: 7, string: [55,48,51,56]};// TLS
      this.rules[163].opcodes[10] = {type: 7, string: [55,48,51,57]};// TLS
  
      /* processorValue */
      this.rules[164].opcodes = [];
      this.rules[164].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[164].opcodes[1] = {type: 3, min: 3, max: 3};// REP
      this.rules[164].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[164].opcodes[3] = {type: 3, min: 1, max: 27};// REP
      this.rules[164].opcodes[4] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* processorParameter */
      this.rules[165].opcodes = [];
      this.rules[165].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[165].opcodes[1] = {type: 4, index: 163};// RNM(processorCode)
      this.rules[165].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[165].opcodes[3] = {type: 4, index: 164};// RNM(processorValue)
  
      /* contentParameter */
      this.rules[166].opcodes = [];
      this.rules[166].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[166].opcodes[1] = {type: 7, string: [48,50,61]};// TLS
      this.rules[166].opcodes[2] = {type: 3, min: 14, max: 14};// REP
      this.rules[166].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* prodDateParameter */
      this.rules[167].opcodes = [];
      this.rules[167].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[167].opcodes[1] = {type: 7, string: [49,49,61]};// TLS
      this.rules[167].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[167].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* dueDateParameter */
      this.rules[168].opcodes = [];
      this.rules[168].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[168].opcodes[1] = {type: 7, string: [49,50,61]};// TLS
      this.rules[168].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[168].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* packDateParameter */
      this.rules[169].opcodes = [];
      this.rules[169].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[169].opcodes[1] = {type: 7, string: [49,51,61]};// TLS
      this.rules[169].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[169].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* bestBeforeDateParameter */
      this.rules[170].opcodes = [];
      this.rules[170].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[170].opcodes[1] = {type: 7, string: [49,53,61]};// TLS
      this.rules[170].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[170].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* sellByDateParameter */
      this.rules[171].opcodes = [];
      this.rules[171].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[171].opcodes[1] = {type: 7, string: [49,54,61]};// TLS
      this.rules[171].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[171].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* firstFreezeDateParameter */
      this.rules[172].opcodes = [];
      this.rules[172].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[172].opcodes[1] = {type: 7, string: [55,48,48,54,61]};// TLS
      this.rules[172].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[172].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* harvestDateParameter */
      this.rules[173].opcodes = [];
      this.rules[173].opcodes[0] = {type: 2, children: [1,2,4]};// CAT
      this.rules[173].opcodes[1] = {type: 7, string: [55,48,48,55,61]};// TLS
      this.rules[173].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[173].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[173].opcodes[4] = {type: 3, min: 0, max: 1};// REP
      this.rules[173].opcodes[5] = {type: 3, min: 6, max: 6};// REP
      this.rules[173].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* pricePerUnitParameter */
      this.rules[174].opcodes = [];
      this.rules[174].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[174].opcodes[1] = {type: 7, string: [56,48,48,53,61]};// TLS
      this.rules[174].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[174].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* variantParameter */
      this.rules[175].opcodes = [];
      this.rules[175].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[175].opcodes[1] = {type: 7, string: [50,48,61]};// TLS
      this.rules[175].opcodes[2] = {type: 3, min: 2, max: 2};// REP
      this.rules[175].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* varCountParameter */
      this.rules[176].opcodes = [];
      this.rules[176].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[176].opcodes[1] = {type: 7, string: [51,48,61]};// TLS
      this.rules[176].opcodes[2] = {type: 3, min: 1, max: 8};// REP
      this.rules[176].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* countParameter */
      this.rules[177].opcodes = [];
      this.rules[177].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[177].opcodes[1] = {type: 7, string: [51,55,61]};// TLS
      this.rules[177].opcodes[2] = {type: 3, min: 1, max: 8};// REP
      this.rules[177].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* mutualParameter */
      this.rules[178].opcodes = [];
      this.rules[178].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[178].opcodes[1] = {type: 7, string: [57,48,61]};// TLS
      this.rules[178].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[178].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* additionalIdParameter */
      this.rules[179].opcodes = [];
      this.rules[179].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[179].opcodes[1] = {type: 7, string: [50,52,48,61]};// TLS
      this.rules[179].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[179].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* custPartNoParameter */
      this.rules[180].opcodes = [];
      this.rules[180].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[180].opcodes[1] = {type: 7, string: [50,52,49,61]};// TLS
      this.rules[180].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[180].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* mtoVariantParameter */
      this.rules[181].opcodes = [];
      this.rules[181].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[181].opcodes[1] = {type: 7, string: [50,52,50,61]};// TLS
      this.rules[181].opcodes[2] = {type: 3, min: 1, max: 6};// REP
      this.rules[181].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* pcnParameter */
      this.rules[182].opcodes = [];
      this.rules[182].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[182].opcodes[1] = {type: 7, string: [50,52,51,61]};// TLS
      this.rules[182].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[182].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* secondarySerialParameter */
      this.rules[183].opcodes = [];
      this.rules[183].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[183].opcodes[1] = {type: 7, string: [50,53,48,61]};// TLS
      this.rules[183].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[183].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* refToSourceParameter */
      this.rules[184].opcodes = [];
      this.rules[184].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[184].opcodes[1] = {type: 7, string: [50,53,49,61]};// TLS
      this.rules[184].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[184].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* amountCode */
      this.rules[185].opcodes = [];
      this.rules[185].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[185].opcodes[1] = {type: 7, string: [51,57,48,48]};// TLS
      this.rules[185].opcodes[2] = {type: 7, string: [51,57,48,49]};// TLS
      this.rules[185].opcodes[3] = {type: 7, string: [51,57,48,50]};// TLS
      this.rules[185].opcodes[4] = {type: 7, string: [51,57,48,51]};// TLS
      this.rules[185].opcodes[5] = {type: 7, string: [51,57,48,52]};// TLS
      this.rules[185].opcodes[6] = {type: 7, string: [51,57,48,53]};// TLS
  
      /* amountValue */
      this.rules[186].opcodes = [];
      this.rules[186].opcodes[0] = {type: 3, min: 1, max: 15};// REP
      this.rules[186].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* amountParameter */
      this.rules[187].opcodes = [];
      this.rules[187].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[187].opcodes[1] = {type: 4, index: 185};// RNM(amountCode)
      this.rules[187].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[187].opcodes[3] = {type: 4, index: 186};// RNM(amountValue)
  
      /* amountISOCode */
      this.rules[188].opcodes = [];
      this.rules[188].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[188].opcodes[1] = {type: 7, string: [51,57,49,48]};// TLS
      this.rules[188].opcodes[2] = {type: 7, string: [51,57,49,49]};// TLS
      this.rules[188].opcodes[3] = {type: 7, string: [51,57,49,50]};// TLS
      this.rules[188].opcodes[4] = {type: 7, string: [51,57,49,51]};// TLS
      this.rules[188].opcodes[5] = {type: 7, string: [51,57,49,52]};// TLS
      this.rules[188].opcodes[6] = {type: 7, string: [51,57,49,53]};// TLS
  
      /* amountISOValue */
      this.rules[189].opcodes = [];
      this.rules[189].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[189].opcodes[1] = {type: 3, min: 3, max: 3};// REP
      this.rules[189].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[189].opcodes[3] = {type: 3, min: 1, max: 15};// REP
      this.rules[189].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* amountISOParameter */
      this.rules[190].opcodes = [];
      this.rules[190].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[190].opcodes[1] = {type: 4, index: 188};// RNM(amountISOCode)
      this.rules[190].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[190].opcodes[3] = {type: 4, index: 189};// RNM(amountISOValue)
  
      /* priceCode */
      this.rules[191].opcodes = [];
      this.rules[191].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[191].opcodes[1] = {type: 7, string: [51,57,50,48]};// TLS
      this.rules[191].opcodes[2] = {type: 7, string: [51,57,50,49]};// TLS
      this.rules[191].opcodes[3] = {type: 7, string: [51,57,50,50]};// TLS
      this.rules[191].opcodes[4] = {type: 7, string: [51,57,50,51]};// TLS
      this.rules[191].opcodes[5] = {type: 7, string: [51,57,50,52]};// TLS
      this.rules[191].opcodes[6] = {type: 7, string: [51,57,50,53]};// TLS
  
      /* priceValue */
      this.rules[192].opcodes = [];
      this.rules[192].opcodes[0] = {type: 3, min: 1, max: 15};// REP
      this.rules[192].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* priceParameter */
      this.rules[193].opcodes = [];
      this.rules[193].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[193].opcodes[1] = {type: 4, index: 191};// RNM(priceCode)
      this.rules[193].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[193].opcodes[3] = {type: 4, index: 192};// RNM(priceValue)
  
      /* priceISOCode */
      this.rules[194].opcodes = [];
      this.rules[194].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[194].opcodes[1] = {type: 7, string: [51,57,51,48]};// TLS
      this.rules[194].opcodes[2] = {type: 7, string: [51,57,51,49]};// TLS
      this.rules[194].opcodes[3] = {type: 7, string: [51,57,51,50]};// TLS
      this.rules[194].opcodes[4] = {type: 7, string: [51,57,51,51]};// TLS
      this.rules[194].opcodes[5] = {type: 7, string: [51,57,51,52]};// TLS
      this.rules[194].opcodes[6] = {type: 7, string: [51,57,51,53]};// TLS
  
      /* priceISOValue */
      this.rules[195].opcodes = [];
      this.rules[195].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[195].opcodes[1] = {type: 3, min: 3, max: 3};// REP
      this.rules[195].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[195].opcodes[3] = {type: 3, min: 1, max: 15};// REP
      this.rules[195].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* priceISOParameter */
      this.rules[196].opcodes = [];
      this.rules[196].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[196].opcodes[1] = {type: 4, index: 194};// RNM(priceISOCode)
      this.rules[196].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[196].opcodes[3] = {type: 4, index: 195};// RNM(priceISOValue)
  
      /* percentOffCode */
      this.rules[197].opcodes = [];
      this.rules[197].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[197].opcodes[1] = {type: 7, string: [51,57,52,48]};// TLS
      this.rules[197].opcodes[2] = {type: 7, string: [51,57,52,49]};// TLS
      this.rules[197].opcodes[3] = {type: 7, string: [51,57,52,50]};// TLS
      this.rules[197].opcodes[4] = {type: 7, string: [51,57,52,51]};// TLS
      this.rules[197].opcodes[5] = {type: 7, string: [51,57,52,52]};// TLS
      this.rules[197].opcodes[6] = {type: 7, string: [51,57,52,53]};// TLS
  
      /* percentOffValue */
      this.rules[198].opcodes = [];
      this.rules[198].opcodes[0] = {type: 3, min: 4, max: 4};// REP
      this.rules[198].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* percentOffParameter */
      this.rules[199].opcodes = [];
      this.rules[199].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[199].opcodes[1] = {type: 4, index: 197};// RNM(percentOffCode)
      this.rules[199].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[199].opcodes[3] = {type: 4, index: 198};// RNM(percentOffValue)
  
      /* orderNumberParameter */
      this.rules[200].opcodes = [];
      this.rules[200].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[200].opcodes[1] = {type: 7, string: [52,48,48,61]};// TLS
      this.rules[200].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[200].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* routeParameter */
      this.rules[201].opcodes = [];
      this.rules[201].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[201].opcodes[1] = {type: 7, string: [52,48,51,61]};// TLS
      this.rules[201].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[201].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToLocParameter */
      this.rules[202].opcodes = [];
      this.rules[202].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[202].opcodes[1] = {type: 7, string: [52,49,48,61]};// TLS
      this.rules[202].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[202].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* billToParameter */
      this.rules[203].opcodes = [];
      this.rules[203].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[203].opcodes[1] = {type: 7, string: [52,49,49,61]};// TLS
      this.rules[203].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[203].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* purchaseFromParameter */
      this.rules[204].opcodes = [];
      this.rules[204].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[204].opcodes[1] = {type: 7, string: [52,49,50,61]};// TLS
      this.rules[204].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[204].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* shipForLocParameter */
      this.rules[205].opcodes = [];
      this.rules[205].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[205].opcodes[1] = {type: 7, string: [52,49,51,61]};// TLS
      this.rules[205].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[205].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* prodServLocParameter */
      this.rules[206].opcodes = [];
      this.rules[206].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[206].opcodes[1] = {type: 7, string: [52,49,54,61]};// TLS
      this.rules[206].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[206].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* shipToPostParameter */
      this.rules[207].opcodes = [];
      this.rules[207].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[207].opcodes[1] = {type: 7, string: [52,50,48,61]};// TLS
      this.rules[207].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[207].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToPostISOParameter */
      this.rules[208].opcodes = [];
      this.rules[208].opcodes[0] = {type: 2, children: [1,2,4]};// CAT
      this.rules[208].opcodes[1] = {type: 7, string: [52,50,49,61]};// TLS
      this.rules[208].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[208].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[208].opcodes[4] = {type: 3, min: 1, max: 9};// REP
      this.rules[208].opcodes[5] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* originParameter */
      this.rules[209].opcodes = [];
      this.rules[209].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[209].opcodes[1] = {type: 7, string: [52,50,50,61]};// TLS
      this.rules[209].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[209].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* countryProcessParameter */
      this.rules[210].opcodes = [];
      this.rules[210].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[210].opcodes[1] = {type: 7, string: [52,50,52,61]};// TLS
      this.rules[210].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[210].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* countryFullProcessParameter */
      this.rules[211].opcodes = [];
      this.rules[211].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[211].opcodes[1] = {type: 7, string: [52,50,54,61]};// TLS
      this.rules[211].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[211].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* countryInitialProcessParameter */
      this.rules[212].opcodes = [];
      this.rules[212].opcodes[0] = {type: 2, children: [1,2,4]};// CAT
      this.rules[212].opcodes[1] = {type: 7, string: [52,50,51,61]};// TLS
      this.rules[212].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[212].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[212].opcodes[4] = {type: 3, min: 1, max: 12};// REP
      this.rules[212].opcodes[5] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* countryDisassemblyParameter */
      this.rules[213].opcodes = [];
      this.rules[213].opcodes[0] = {type: 2, children: [1,2,4]};// CAT
      this.rules[213].opcodes[1] = {type: 7, string: [52,50,53,61]};// TLS
      this.rules[213].opcodes[2] = {type: 3, min: 3, max: 3};// REP
      this.rules[213].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[213].opcodes[4] = {type: 3, min: 1, max: 12};// REP
      this.rules[213].opcodes[5] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* originSubdivisionParameter */
      this.rules[214].opcodes = [];
      this.rules[214].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[214].opcodes[1] = {type: 7, string: [52,50,55,61]};// TLS
      this.rules[214].opcodes[2] = {type: 3, min: 1, max: 3};// REP
      this.rules[214].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnPZNParameter */
      this.rules[215].opcodes = [];
      this.rules[215].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[215].opcodes[1] = {type: 7, string: [55,49,48,61]};// TLS
      this.rules[215].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[215].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnCIPParameter */
      this.rules[216].opcodes = [];
      this.rules[216].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[216].opcodes[1] = {type: 7, string: [55,49,49,61]};// TLS
      this.rules[216].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[216].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnCNParameter */
      this.rules[217].opcodes = [];
      this.rules[217].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[217].opcodes[1] = {type: 7, string: [55,49,50,61]};// TLS
      this.rules[217].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[217].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnDRNParameter */
      this.rules[218].opcodes = [];
      this.rules[218].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[218].opcodes[1] = {type: 7, string: [55,49,51,61]};// TLS
      this.rules[218].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[218].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnAIMParameter */
      this.rules[219].opcodes = [];
      this.rules[219].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[219].opcodes[1] = {type: 7, string: [55,49,52,61]};// TLS
      this.rules[219].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[219].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nhrnUS-FDAParameter */
      this.rules[220].opcodes = [];
      this.rules[220].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[220].opcodes[1] = {type: 7, string: [55,49,53,61]};// TLS
      this.rules[220].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[220].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* nsnParameter */
      this.rules[221].opcodes = [];
      this.rules[221].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[221].opcodes[1] = {type: 7, string: [55,48,48,49,61]};// TLS
      this.rules[221].opcodes[2] = {type: 3, min: 13, max: 13};// REP
      this.rules[221].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* meatCutParameter */
      this.rules[222].opcodes = [];
      this.rules[222].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[222].opcodes[1] = {type: 7, string: [55,48,48,50,61]};// TLS
      this.rules[222].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[222].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* activePotencyParameter */
      this.rules[223].opcodes = [];
      this.rules[223].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[223].opcodes[1] = {type: 7, string: [55,48,48,52,61]};// TLS
      this.rules[223].opcodes[2] = {type: 3, min: 1, max: 4};// REP
      this.rules[223].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* catchAreaParameter */
      this.rules[224].opcodes = [];
      this.rules[224].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[224].opcodes[1] = {type: 7, string: [55,48,48,53,61]};// TLS
      this.rules[224].opcodes[2] = {type: 3, min: 1, max: 12};// REP
      this.rules[224].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* aquaticSpeciesParameter */
      this.rules[225].opcodes = [];
      this.rules[225].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[225].opcodes[1] = {type: 7, string: [55,48,48,56,61]};// TLS
      this.rules[225].opcodes[2] = {type: 3, min: 1, max: 3};// REP
      this.rules[225].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* fishingGearTypeParameter */
      this.rules[226].opcodes = [];
      this.rules[226].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[226].opcodes[1] = {type: 7, string: [55,48,48,57,61]};// TLS
      this.rules[226].opcodes[2] = {type: 3, min: 1, max: 10};// REP
      this.rules[226].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* prodMethodParameter */
      this.rules[227].opcodes = [];
      this.rules[227].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[227].opcodes[1] = {type: 7, string: [55,48,49,48,61]};// TLS
      this.rules[227].opcodes[2] = {type: 3, min: 1, max: 2};// REP
      this.rules[227].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* refurbLotParameter */
      this.rules[228].opcodes = [];
      this.rules[228].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[228].opcodes[1] = {type: 7, string: [55,48,50,48,61]};// TLS
      this.rules[228].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[228].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* funcStatParameter */
      this.rules[229].opcodes = [];
      this.rules[229].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[229].opcodes[1] = {type: 7, string: [55,48,50,49,61]};// TLS
      this.rules[229].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[229].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* revStatParameter */
      this.rules[230].opcodes = [];
      this.rules[230].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[230].opcodes[1] = {type: 7, string: [55,48,50,50,61]};// TLS
      this.rules[230].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[230].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* giaiAssemblyParameter */
      this.rules[231].opcodes = [];
      this.rules[231].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[231].opcodes[1] = {type: 7, string: [55,48,50,51,61]};// TLS
      this.rules[231].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[231].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* certificationRefCode */
      this.rules[232].opcodes = [];
      this.rules[232].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
      this.rules[232].opcodes[1] = {type: 7, string: [55,50,51,48]};// TLS
      this.rules[232].opcodes[2] = {type: 7, string: [55,50,51,49]};// TLS
      this.rules[232].opcodes[3] = {type: 7, string: [55,50,51,50]};// TLS
      this.rules[232].opcodes[4] = {type: 7, string: [55,50,51,51]};// TLS
      this.rules[232].opcodes[5] = {type: 7, string: [55,50,51,52]};// TLS
      this.rules[232].opcodes[6] = {type: 7, string: [55,50,51,53]};// TLS
      this.rules[232].opcodes[7] = {type: 7, string: [55,50,51,54]};// TLS
      this.rules[232].opcodes[8] = {type: 7, string: [55,50,51,55]};// TLS
      this.rules[232].opcodes[9] = {type: 7, string: [55,50,51,56]};// TLS
      this.rules[232].opcodes[10] = {type: 7, string: [55,50,51,57]};// TLS
  
      /* certificationRefValue */
      this.rules[233].opcodes = [];
      this.rules[233].opcodes[0] = {type: 2, children: [1,3]};// CAT
      this.rules[233].opcodes[1] = {type: 3, min: 2, max: 2};// REP
      this.rules[233].opcodes[2] = {type: 4, index: 26};// RNM(XCHAR)
      this.rules[233].opcodes[3] = {type: 3, min: 1, max: 28};// REP
      this.rules[233].opcodes[4] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* certificationRefParameter */
      this.rules[234].opcodes = [];
      this.rules[234].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[234].opcodes[1] = {type: 4, index: 232};// RNM(certificationRefCode)
      this.rules[234].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[234].opcodes[3] = {type: 4, index: 233};// RNM(certificationRefValue)
  
      /* dimensionsParameter */
      this.rules[235].opcodes = [];
      this.rules[235].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[235].opcodes[1] = {type: 7, string: [56,48,48,49,61]};// TLS
      this.rules[235].opcodes[2] = {type: 3, min: 14, max: 14};// REP
      this.rules[235].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* cmtNoParameter */
      this.rules[236].opcodes = [];
      this.rules[236].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[236].opcodes[1] = {type: 7, string: [56,48,48,50,61]};// TLS
      this.rules[236].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[236].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* ibanParameter */
      this.rules[237].opcodes = [];
      this.rules[237].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[237].opcodes[1] = {type: 7, string: [56,48,48,55,61]};// TLS
      this.rules[237].opcodes[2] = {type: 3, min: 1, max: 34};// REP
      this.rules[237].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* prodTimeParameter */
      this.rules[238].opcodes = [];
      this.rules[238].opcodes[0] = {type: 2, children: [1,2,4,7]};// CAT
      this.rules[238].opcodes[1] = {type: 7, string: [56,48,48,56,61]};// TLS
      this.rules[238].opcodes[2] = {type: 3, min: 8, max: 8};// REP
      this.rules[238].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[238].opcodes[4] = {type: 3, min: 0, max: 1};// REP
      this.rules[238].opcodes[5] = {type: 3, min: 2, max: 2};// REP
      this.rules[238].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[238].opcodes[7] = {type: 3, min: 0, max: 1};// REP
      this.rules[238].opcodes[8] = {type: 3, min: 2, max: 2};// REP
      this.rules[238].opcodes[9] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* opticalSensorParameter */
      this.rules[239].opcodes = [];
      this.rules[239].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[239].opcodes[1] = {type: 7, string: [56,48,48,57,61]};// TLS
      this.rules[239].opcodes[2] = {type: 3, min: 1, max: 50};// REP
      this.rules[239].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* versionParameter */
      this.rules[240].opcodes = [];
      this.rules[240].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[240].opcodes[1] = {type: 7, string: [56,48,49,50,61]};// TLS
      this.rules[240].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[240].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* refNoParameter */
      this.rules[241].opcodes = [];
      this.rules[241].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[241].opcodes[1] = {type: 7, string: [56,48,50,48,61]};// TLS
      this.rules[241].opcodes[2] = {type: 3, min: 1, max: 25};// REP
      this.rules[241].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* itipContentParameter */
      this.rules[242].opcodes = [];
      this.rules[242].opcodes[0] = {type: 2, children: [1,2,4,6]};// CAT
      this.rules[242].opcodes[1] = {type: 7, string: [56,48,50,54,61]};// TLS
      this.rules[242].opcodes[2] = {type: 3, min: 14, max: 14};// REP
      this.rules[242].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[242].opcodes[4] = {type: 3, min: 2, max: 2};// REP
      this.rules[242].opcodes[5] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[242].opcodes[6] = {type: 3, min: 2, max: 2};// REP
      this.rules[242].opcodes[7] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* couponIDNAParameter */
      this.rules[243].opcodes = [];
      this.rules[243].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[243].opcodes[1] = {type: 7, string: [56,49,49,48,61]};// TLS
      this.rules[243].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[243].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* pointsParameter */
      this.rules[244].opcodes = [];
      this.rules[244].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[244].opcodes[1] = {type: 7, string: [56,49,49,49,61]};// TLS
      this.rules[244].opcodes[2] = {type: 3, min: 4, max: 4};// REP
      this.rules[244].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* paperlessCouponIDNAParameter */
      this.rules[245].opcodes = [];
      this.rules[245].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[245].opcodes[1] = {type: 7, string: [56,49,49,50,61]};// TLS
      this.rules[245].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[245].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToCompParameter */
      this.rules[246].opcodes = [];
      this.rules[246].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[246].opcodes[1] = {type: 7, string: [52,51,48,48,61]};// TLS
      this.rules[246].opcodes[2] = {type: 3, min: 1, max: 35};// REP
      this.rules[246].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToNameParameter */
      this.rules[247].opcodes = [];
      this.rules[247].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[247].opcodes[1] = {type: 7, string: [52,51,48,49,61]};// TLS
      this.rules[247].opcodes[2] = {type: 3, min: 1, max: 35};// REP
      this.rules[247].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToAdd1Parameter */
      this.rules[248].opcodes = [];
      this.rules[248].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[248].opcodes[1] = {type: 7, string: [52,51,48,50,61]};// TLS
      this.rules[248].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[248].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToAdd2Parameter */
      this.rules[249].opcodes = [];
      this.rules[249].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[249].opcodes[1] = {type: 7, string: [52,51,48,51,61]};// TLS
      this.rules[249].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[249].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToSubParameter */
      this.rules[250].opcodes = [];
      this.rules[250].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[250].opcodes[1] = {type: 7, string: [52,51,48,52,61]};// TLS
      this.rules[250].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[250].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToLocalityParameter */
      this.rules[251].opcodes = [];
      this.rules[251].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[251].opcodes[1] = {type: 7, string: [52,51,48,53,61]};// TLS
      this.rules[251].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[251].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToRegParameter */
      this.rules[252].opcodes = [];
      this.rules[252].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[252].opcodes[1] = {type: 7, string: [52,51,48,54,61]};// TLS
      this.rules[252].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[252].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToCountryParameter */
      this.rules[253].opcodes = [];
      this.rules[253].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[253].opcodes[1] = {type: 7, string: [52,51,48,55,61]};// TLS
      this.rules[253].opcodes[2] = {type: 3, min: 2, max: 2};// REP
      this.rules[253].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* shipToPhoneParameter */
      this.rules[254].opcodes = [];
      this.rules[254].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[254].opcodes[1] = {type: 7, string: [52,51,48,56,61]};// TLS
      this.rules[254].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[254].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToCompParameter */
      this.rules[255].opcodes = [];
      this.rules[255].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[255].opcodes[1] = {type: 7, string: [52,51,49,48,61]};// TLS
      this.rules[255].opcodes[2] = {type: 3, min: 1, max: 35};// REP
      this.rules[255].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToNameParameter */
      this.rules[256].opcodes = [];
      this.rules[256].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[256].opcodes[1] = {type: 7, string: [52,51,49,49,61]};// TLS
      this.rules[256].opcodes[2] = {type: 3, min: 1, max: 35};// REP
      this.rules[256].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToAdd1Parameter */
      this.rules[257].opcodes = [];
      this.rules[257].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[257].opcodes[1] = {type: 7, string: [52,51,49,50,61]};// TLS
      this.rules[257].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[257].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToAdd2Parameter */
      this.rules[258].opcodes = [];
      this.rules[258].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[258].opcodes[1] = {type: 7, string: [52,51,49,51,61]};// TLS
      this.rules[258].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[258].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToSubParameter */
      this.rules[259].opcodes = [];
      this.rules[259].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[259].opcodes[1] = {type: 7, string: [52,51,49,52,61]};// TLS
      this.rules[259].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[259].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToLocParameter */
      this.rules[260].opcodes = [];
      this.rules[260].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[260].opcodes[1] = {type: 7, string: [52,51,49,53,61]};// TLS
      this.rules[260].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[260].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToRegParameter */
      this.rules[261].opcodes = [];
      this.rules[261].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[261].opcodes[1] = {type: 7, string: [52,51,49,54,61]};// TLS
      this.rules[261].opcodes[2] = {type: 3, min: 1, max: 70};// REP
      this.rules[261].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToCountryParameter */
      this.rules[262].opcodes = [];
      this.rules[262].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[262].opcodes[1] = {type: 7, string: [52,51,49,55,61]};// TLS
      this.rules[262].opcodes[2] = {type: 3, min: 2, max: 2};// REP
      this.rules[262].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToPostParameter */
      this.rules[263].opcodes = [];
      this.rules[263].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[263].opcodes[1] = {type: 7, string: [52,51,49,56,61]};// TLS
      this.rules[263].opcodes[2] = {type: 3, min: 1, max: 20};// REP
      this.rules[263].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* rtnToPhoneParameter */
      this.rules[264].opcodes = [];
      this.rules[264].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[264].opcodes[1] = {type: 7, string: [52,51,49,57,61]};// TLS
      this.rules[264].opcodes[2] = {type: 3, min: 1, max: 30};// REP
      this.rules[264].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* srvDescriptionParameter */
      this.rules[265].opcodes = [];
      this.rules[265].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[265].opcodes[1] = {type: 7, string: [52,51,50,48,61]};// TLS
      this.rules[265].opcodes[2] = {type: 3, min: 1, max: 35};// REP
      this.rules[265].opcodes[3] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* dangerousGoodsParameter */
      this.rules[266].opcodes = [];
      this.rules[266].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[266].opcodes[1] = {type: 7, string: [52,51,50,49,61]};// TLS
      this.rules[266].opcodes[2] = {type: 4, index: 1};// RNM(BOOLEAN)
  
      /* authToLeaveParameter */
      this.rules[267].opcodes = [];
      this.rules[267].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[267].opcodes[1] = {type: 7, string: [52,51,50,50,61]};// TLS
      this.rules[267].opcodes[2] = {type: 4, index: 1};// RNM(BOOLEAN)
  
      /* sigRequiredParameter */
      this.rules[268].opcodes = [];
      this.rules[268].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[268].opcodes[1] = {type: 7, string: [52,51,50,51,61]};// TLS
      this.rules[268].opcodes[2] = {type: 4, index: 1};// RNM(BOOLEAN)
  
      /* notBeforeDelDateParameter */
      this.rules[269].opcodes = [];
      this.rules[269].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[269].opcodes[1] = {type: 7, string: [52,51,50,52,61]};// TLS
      this.rules[269].opcodes[2] = {type: 3, min: 10, max: 10};// REP
      this.rules[269].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* notAfterDelDateParameter */
      this.rules[270].opcodes = [];
      this.rules[270].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[270].opcodes[1] = {type: 7, string: [52,51,50,53,61]};// TLS
      this.rules[270].opcodes[2] = {type: 3, min: 10, max: 10};// REP
      this.rules[270].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* releaseDateParameter */
      this.rules[271].opcodes = [];
      this.rules[271].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[271].opcodes[1] = {type: 7, string: [52,51,50,54,61]};// TLS
      this.rules[271].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[271].opcodes[3] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* amountPayPerUnitCode */
      this.rules[272].opcodes = [];
      this.rules[272].opcodes[0] = {type: 1, children: [1,2,3,4]};// ALT
      this.rules[272].opcodes[1] = {type: 7, string: [51,57,53,48]};// TLS
      this.rules[272].opcodes[2] = {type: 7, string: [51,57,53,49]};// TLS
      this.rules[272].opcodes[3] = {type: 7, string: [51,57,53,50]};// TLS
      this.rules[272].opcodes[4] = {type: 7, string: [51,57,53,51]};// TLS
  
      /* amountPayPerUnitValue */
      this.rules[273].opcodes = [];
      this.rules[273].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[273].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* amountPayPerUnitParameter */
      this.rules[274].opcodes = [];
      this.rules[274].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[274].opcodes[1] = {type: 4, index: 272};// RNM(amountPayPerUnitCode)
      this.rules[274].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[274].opcodes[3] = {type: 4, index: 273};// RNM(amountPayPerUnitValue)
  
      /* gtinParameter */
      this.rules[275].opcodes = [];
      this.rules[275].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[275].opcodes[1] = {type: 7, string: [48,49,61]};// TLS
      this.rules[275].opcodes[2] = {type: 4, index: 53};// RNM(gtin-value)
  
      /* itipParameter */
      this.rules[276].opcodes = [];
      this.rules[276].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[276].opcodes[1] = {type: 7, string: [56,48,48,54,61]};// TLS
      this.rules[276].opcodes[2] = {type: 4, index: 54};// RNM(itip-value)
  
      /* gmnParameter */
      this.rules[277].opcodes = [];
      this.rules[277].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[277].opcodes[1] = {type: 7, string: [56,48,49,51,61]};// TLS
      this.rules[277].opcodes[2] = {type: 4, index: 55};// RNM(gmn-value)
  
      /* cpidParameter */
      this.rules[278].opcodes = [];
      this.rules[278].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[278].opcodes[1] = {type: 7, string: [56,48,49,48,61]};// TLS
      this.rules[278].opcodes[2] = {type: 4, index: 56};// RNM(cpid-value)
  
      /* glnParameter */
      this.rules[279].opcodes = [];
      this.rules[279].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[279].opcodes[1] = {type: 7, string: [52,49,52,61]};// TLS
      this.rules[279].opcodes[2] = {type: 4, index: 57};// RNM(gln-value)
  
      /* payToParameter */
      this.rules[280].opcodes = [];
      this.rules[280].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[280].opcodes[1] = {type: 7, string: [52,49,53,61]};// TLS
      this.rules[280].opcodes[2] = {type: 4, index: 58};// RNM(payTo-value)
  
      /* partyGlnParameter */
      this.rules[281].opcodes = [];
      this.rules[281].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[281].opcodes[1] = {type: 7, string: [52,49,55,61]};// TLS
      this.rules[281].opcodes[2] = {type: 4, index: 59};// RNM(partyGln-value)
  
      /* gsrnpParameter */
      this.rules[282].opcodes = [];
      this.rules[282].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[282].opcodes[1] = {type: 7, string: [56,48,49,55,61]};// TLS
      this.rules[282].opcodes[2] = {type: 4, index: 60};// RNM(gsrnp-value)
  
      /* gsrnParameter */
      this.rules[283].opcodes = [];
      this.rules[283].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[283].opcodes[1] = {type: 7, string: [56,48,49,56,61]};// TLS
      this.rules[283].opcodes[2] = {type: 4, index: 61};// RNM(gsrn-value)
  
      /* gcnParameter */
      this.rules[284].opcodes = [];
      this.rules[284].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[284].opcodes[1] = {type: 7, string: [50,53,53,61]};// TLS
      this.rules[284].opcodes[2] = {type: 4, index: 62};// RNM(gcn-value)
  
      /* ssccParameter */
      this.rules[285].opcodes = [];
      this.rules[285].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[285].opcodes[1] = {type: 7, string: [48,48,61]};// TLS
      this.rules[285].opcodes[2] = {type: 4, index: 63};// RNM(sscc-value)
  
      /* gdtiParameter */
      this.rules[286].opcodes = [];
      this.rules[286].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[286].opcodes[1] = {type: 7, string: [50,53,51,61]};// TLS
      this.rules[286].opcodes[2] = {type: 4, index: 64};// RNM(gdti-value)
  
      /* gincParameter */
      this.rules[287].opcodes = [];
      this.rules[287].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[287].opcodes[1] = {type: 7, string: [52,48,49,61]};// TLS
      this.rules[287].opcodes[2] = {type: 4, index: 65};// RNM(ginc-value)
  
      /* gsinParameter */
      this.rules[288].opcodes = [];
      this.rules[288].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[288].opcodes[1] = {type: 7, string: [52,48,50,61]};// TLS
      this.rules[288].opcodes[2] = {type: 4, index: 66};// RNM(gsin-value)
  
      /* graiParameter */
      this.rules[289].opcodes = [];
      this.rules[289].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[289].opcodes[1] = {type: 7, string: [56,48,48,51,61]};// TLS
      this.rules[289].opcodes[2] = {type: 4, index: 67};// RNM(grai-value)
  
      /* giaiParameter */
      this.rules[290].opcodes = [];
      this.rules[290].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[290].opcodes[1] = {type: 7, string: [56,48,48,52,61]};// TLS
      this.rules[290].opcodes[2] = {type: 4, index: 68};// RNM(giai-value)
  
      /* internalCode */
      this.rules[291].opcodes = [];
      this.rules[291].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9]};// ALT
      this.rules[291].opcodes[1] = {type: 7, string: [57,49]};// TLS
      this.rules[291].opcodes[2] = {type: 7, string: [57,50]};// TLS
      this.rules[291].opcodes[3] = {type: 7, string: [57,51]};// TLS
      this.rules[291].opcodes[4] = {type: 7, string: [57,52]};// TLS
      this.rules[291].opcodes[5] = {type: 7, string: [57,53]};// TLS
      this.rules[291].opcodes[6] = {type: 7, string: [57,54]};// TLS
      this.rules[291].opcodes[7] = {type: 7, string: [57,55]};// TLS
      this.rules[291].opcodes[8] = {type: 7, string: [57,56]};// TLS
      this.rules[291].opcodes[9] = {type: 7, string: [57,57]};// TLS
  
      /* internalValue */
      this.rules[292].opcodes = [];
      this.rules[292].opcodes[0] = {type: 3, min: 1, max: 90};// REP
      this.rules[292].opcodes[1] = {type: 4, index: 26};// RNM(XCHAR)
  
      /* internalParameter */
      this.rules[293].opcodes = [];
      this.rules[293].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[293].opcodes[1] = {type: 4, index: 291};// RNM(internalCode)
      this.rules[293].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[293].opcodes[3] = {type: 4, index: 292};// RNM(internalValue)
  
      /* LotParameter */
      this.rules[294].opcodes = [];
      this.rules[294].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[294].opcodes[1] = {type: 4, index: 45};// RNM(lot-code)
      this.rules[294].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[294].opcodes[3] = {type: 4, index: 70};// RNM(lot-value)
  
      /* expiryDateCode */
      this.rules[295].opcodes = [];
      this.rules[295].opcodes[0] = {type: 7, string: [49,55]};// TLS
  
      /* expiryDateValue */
      this.rules[296].opcodes = [];
      this.rules[296].opcodes[0] = {type: 3, min: 6, max: 6};// REP
      this.rules[296].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* expiryDateParameter */
      this.rules[297].opcodes = [];
      this.rules[297].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[297].opcodes[1] = {type: 4, index: 295};// RNM(expiryDateCode)
      this.rules[297].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[297].opcodes[3] = {type: 4, index: 296};// RNM(expiryDateValue)
  
      /* expiryTimeCode */
      this.rules[298].opcodes = [];
      this.rules[298].opcodes[0] = {type: 7, string: [55,48,48,51]};// TLS
  
      /* expiryTimeValue */
      this.rules[299].opcodes = [];
      this.rules[299].opcodes[0] = {type: 3, min: 10, max: 10};// REP
      this.rules[299].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* expiryTimeParameter */
      this.rules[300].opcodes = [];
      this.rules[300].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[300].opcodes[1] = {type: 4, index: 298};// RNM(expiryTimeCode)
      this.rules[300].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[300].opcodes[3] = {type: 4, index: 299};// RNM(expiryTimeValue)
  
      /* extensionKey */
      this.rules[301].opcodes = [];
      this.rules[301].opcodes[0] = {type: 2, children: [1,3,4]};// CAT
      this.rules[301].opcodes[1] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[301].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[301].opcodes[3] = {type: 4, index: 312};// RNM(everythingExceptDigitsAndEquals)
      this.rules[301].opcodes[4] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[301].opcodes[5] = {type: 1, children: [6,7]};// ALT
      this.rules[301].opcodes[6] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[301].opcodes[7] = {type: 4, index: 312};// RNM(everythingExceptDigitsAndEquals)
  
      /* extensionValue */
      this.rules[302].opcodes = [];
      this.rules[302].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[302].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
      this.rules[302].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[302].opcodes[3] = {type: 4, index: 312};// RNM(everythingExceptDigitsAndEquals)
      this.rules[302].opcodes[4] = {type: 7, string: [61]};// TLS
  
      /* extensionParameter */
      this.rules[303].opcodes = [];
      this.rules[303].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[303].opcodes[1] = {type: 4, index: 301};// RNM(extensionKey)
      this.rules[303].opcodes[2] = {type: 7, string: [61]};// TLS
      this.rules[303].opcodes[3] = {type: 4, index: 302};// RNM(extensionValue)
  
      /* queryStringParam */
      this.rules[304].opcodes = [];
      this.rules[304].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,91,92,93,94,95,96,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128]};// ALT
      this.rules[304].opcodes[1] = {type: 4, index: 126};// RNM(netWeightVMTIParameter)
      this.rules[304].opcodes[2] = {type: 4, index: 129};// RNM(lengthVMTIParameter)
      this.rules[304].opcodes[3] = {type: 4, index: 132};// RNM(widthVMTIParameter)
      this.rules[304].opcodes[4] = {type: 4, index: 135};// RNM(depthVMTIParameter)
      this.rules[304].opcodes[5] = {type: 4, index: 138};// RNM(areaVMTIParameter)
      this.rules[304].opcodes[6] = {type: 4, index: 141};// RNM(netVolumeVMTIParameter)
      this.rules[304].opcodes[7] = {type: 4, index: 144};// RNM(massPerUnitAreaVMTIParameter)
      this.rules[304].opcodes[8] = {type: 4, index: 147};// RNM(grossWeightParameter)
      this.rules[304].opcodes[9] = {type: 4, index: 150};// RNM(logisticLengthParameter)
      this.rules[304].opcodes[10] = {type: 4, index: 153};// RNM(logisticWidthParameter)
      this.rules[304].opcodes[11] = {type: 4, index: 156};// RNM(logisticDepthParameter)
      this.rules[304].opcodes[12] = {type: 4, index: 159};// RNM(logisticAreaParameter)
      this.rules[304].opcodes[13] = {type: 4, index: 162};// RNM(logisticVolumeParameter)
      this.rules[304].opcodes[14] = {type: 4, index: 165};// RNM(processorParameter)
      this.rules[304].opcodes[15] = {type: 4, index: 294};// RNM(LotParameter)
      this.rules[304].opcodes[16] = {type: 4, index: 297};// RNM(expiryDateParameter)
      this.rules[304].opcodes[17] = {type: 4, index: 300};// RNM(expiryTimeParameter)
      this.rules[304].opcodes[18] = {type: 4, index: 166};// RNM(contentParameter)
      this.rules[304].opcodes[19] = {type: 4, index: 167};// RNM(prodDateParameter)
      this.rules[304].opcodes[20] = {type: 4, index: 168};// RNM(dueDateParameter)
      this.rules[304].opcodes[21] = {type: 4, index: 169};// RNM(packDateParameter)
      this.rules[304].opcodes[22] = {type: 4, index: 170};// RNM(bestBeforeDateParameter)
      this.rules[304].opcodes[23] = {type: 4, index: 171};// RNM(sellByDateParameter)
      this.rules[304].opcodes[24] = {type: 4, index: 172};// RNM(firstFreezeDateParameter)
      this.rules[304].opcodes[25] = {type: 4, index: 173};// RNM(harvestDateParameter)
      this.rules[304].opcodes[26] = {type: 4, index: 174};// RNM(pricePerUnitParameter)
      this.rules[304].opcodes[27] = {type: 4, index: 175};// RNM(variantParameter)
      this.rules[304].opcodes[28] = {type: 4, index: 176};// RNM(varCountParameter)
      this.rules[304].opcodes[29] = {type: 4, index: 177};// RNM(countParameter)
      this.rules[304].opcodes[30] = {type: 4, index: 274};// RNM(amountPayPerUnitParameter)
      this.rules[304].opcodes[31] = {type: 4, index: 179};// RNM(additionalIdParameter)
      this.rules[304].opcodes[32] = {type: 4, index: 180};// RNM(custPartNoParameter)
      this.rules[304].opcodes[33] = {type: 4, index: 181};// RNM(mtoVariantParameter)
      this.rules[304].opcodes[34] = {type: 4, index: 182};// RNM(pcnParameter)
      this.rules[304].opcodes[35] = {type: 4, index: 183};// RNM(secondarySerialParameter)
      this.rules[304].opcodes[36] = {type: 4, index: 184};// RNM(refToSourceParameter)
      this.rules[304].opcodes[37] = {type: 4, index: 187};// RNM(amountParameter)
      this.rules[304].opcodes[38] = {type: 4, index: 190};// RNM(amountISOParameter)
      this.rules[304].opcodes[39] = {type: 4, index: 193};// RNM(priceParameter)
      this.rules[304].opcodes[40] = {type: 4, index: 196};// RNM(priceISOParameter)
      this.rules[304].opcodes[41] = {type: 4, index: 199};// RNM(percentOffParameter)
      this.rules[304].opcodes[42] = {type: 4, index: 200};// RNM(orderNumberParameter)
      this.rules[304].opcodes[43] = {type: 4, index: 201};// RNM(routeParameter)
      this.rules[304].opcodes[44] = {type: 4, index: 202};// RNM(shipToLocParameter)
      this.rules[304].opcodes[45] = {type: 4, index: 203};// RNM(billToParameter)
      this.rules[304].opcodes[46] = {type: 4, index: 204};// RNM(purchaseFromParameter)
      this.rules[304].opcodes[47] = {type: 4, index: 205};// RNM(shipForLocParameter)
      this.rules[304].opcodes[48] = {type: 4, index: 206};// RNM(prodServLocParameter)
      this.rules[304].opcodes[49] = {type: 4, index: 207};// RNM(shipToPostParameter)
      this.rules[304].opcodes[50] = {type: 4, index: 208};// RNM(shipToPostISOParameter)
      this.rules[304].opcodes[51] = {type: 4, index: 209};// RNM(originParameter)
      this.rules[304].opcodes[52] = {type: 4, index: 210};// RNM(countryProcessParameter)
      this.rules[304].opcodes[53] = {type: 4, index: 211};// RNM(countryFullProcessParameter)
      this.rules[304].opcodes[54] = {type: 4, index: 212};// RNM(countryInitialProcessParameter)
      this.rules[304].opcodes[55] = {type: 4, index: 213};// RNM(countryDisassemblyParameter)
      this.rules[304].opcodes[56] = {type: 4, index: 214};// RNM(originSubdivisionParameter)
      this.rules[304].opcodes[57] = {type: 4, index: 215};// RNM(nhrnPZNParameter)
      this.rules[304].opcodes[58] = {type: 4, index: 216};// RNM(nhrnCIPParameter)
      this.rules[304].opcodes[59] = {type: 4, index: 217};// RNM(nhrnCNParameter)
      this.rules[304].opcodes[60] = {type: 4, index: 218};// RNM(nhrnDRNParameter)
      this.rules[304].opcodes[61] = {type: 4, index: 221};// RNM(nsnParameter)
      this.rules[304].opcodes[62] = {type: 4, index: 222};// RNM(meatCutParameter)
      this.rules[304].opcodes[63] = {type: 4, index: 223};// RNM(activePotencyParameter)
      this.rules[304].opcodes[64] = {type: 4, index: 224};// RNM(catchAreaParameter)
      this.rules[304].opcodes[65] = {type: 4, index: 226};// RNM(fishingGearTypeParameter)
      this.rules[304].opcodes[66] = {type: 4, index: 227};// RNM(prodMethodParameter)
      this.rules[304].opcodes[67] = {type: 4, index: 228};// RNM(refurbLotParameter)
      this.rules[304].opcodes[68] = {type: 4, index: 229};// RNM(funcStatParameter)
      this.rules[304].opcodes[69] = {type: 4, index: 230};// RNM(revStatParameter)
      this.rules[304].opcodes[70] = {type: 4, index: 231};// RNM(giaiAssemblyParameter)
      this.rules[304].opcodes[71] = {type: 4, index: 235};// RNM(dimensionsParameter)
      this.rules[304].opcodes[72] = {type: 4, index: 236};// RNM(cmtNoParameter)
      this.rules[304].opcodes[73] = {type: 4, index: 237};// RNM(ibanParameter)
      this.rules[304].opcodes[74] = {type: 4, index: 238};// RNM(prodTimeParameter)
      this.rules[304].opcodes[75] = {type: 4, index: 240};// RNM(versionParameter)
      this.rules[304].opcodes[76] = {type: 4, index: 241};// RNM(refNoParameter)
      this.rules[304].opcodes[77] = {type: 4, index: 243};// RNM(couponIDNAParameter)
      this.rules[304].opcodes[78] = {type: 4, index: 244};// RNM(pointsParameter)
      this.rules[304].opcodes[79] = {type: 4, index: 242};// RNM(itipContentParameter)
      this.rules[304].opcodes[80] = {type: 4, index: 234};// RNM(certificationRefParameter)
      this.rules[304].opcodes[81] = {type: 4, index: 225};// RNM(aquaticSpeciesParameter)
      this.rules[304].opcodes[82] = {type: 4, index: 239};// RNM(opticalSensorParameter)
      this.rules[304].opcodes[83] = {type: 4, index: 245};// RNM(paperlessCouponIDNAParameter)
      this.rules[304].opcodes[84] = {type: 4, index: 293};// RNM(internalParameter)
      this.rules[304].opcodes[85] = {type: 4, index: 178};// RNM(mutualParameter)
      this.rules[304].opcodes[86] = {type: 4, index: 303};// RNM(extensionParameter)
      this.rules[304].opcodes[87] = {type: 4, index: 246};// RNM(shipToCompParameter)
      this.rules[304].opcodes[88] = {type: 4, index: 247};// RNM(shipToNameParameter)
      this.rules[304].opcodes[89] = {type: 4, index: 248};// RNM(shipToAdd1Parameter)
      this.rules[304].opcodes[90] = {type: 4, index: 249};// RNM(shipToAdd2Parameter)
      this.rules[304].opcodes[91] = {type: 4, index: 250};// RNM(shipToSubParameter)
      this.rules[304].opcodes[92] = {type: 4, index: 251};// RNM(shipToLocalityParameter)
      this.rules[304].opcodes[93] = {type: 4, index: 252};// RNM(shipToRegParameter)
      this.rules[304].opcodes[94] = {type: 4, index: 253};// RNM(shipToCountryParameter)
      this.rules[304].opcodes[95] = {type: 4, index: 254};// RNM(shipToPhoneParameter)
      this.rules[304].opcodes[96] = {type: 4, index: 255};// RNM(rtnToCompParameter)
      this.rules[304].opcodes[97] = {type: 4, index: 256};// RNM(rtnToNameParameter)
      this.rules[304].opcodes[98] = {type: 4, index: 257};// RNM(rtnToAdd1Parameter)
      this.rules[304].opcodes[99] = {type: 4, index: 258};// RNM(rtnToAdd2Parameter)
      this.rules[304].opcodes[100] = {type: 4, index: 259};// RNM(rtnToSubParameter)
      this.rules[304].opcodes[101] = {type: 4, index: 260};// RNM(rtnToLocParameter)
      this.rules[304].opcodes[102] = {type: 4, index: 261};// RNM(rtnToRegParameter)
      this.rules[304].opcodes[103] = {type: 4, index: 262};// RNM(rtnToCountryParameter)
      this.rules[304].opcodes[104] = {type: 4, index: 263};// RNM(rtnToPostParameter)
      this.rules[304].opcodes[105] = {type: 4, index: 264};// RNM(rtnToPhoneParameter)
      this.rules[304].opcodes[106] = {type: 4, index: 265};// RNM(srvDescriptionParameter)
      this.rules[304].opcodes[107] = {type: 4, index: 266};// RNM(dangerousGoodsParameter)
      this.rules[304].opcodes[108] = {type: 4, index: 267};// RNM(authToLeaveParameter)
      this.rules[304].opcodes[109] = {type: 4, index: 268};// RNM(sigRequiredParameter)
      this.rules[304].opcodes[110] = {type: 4, index: 269};// RNM(notBeforeDelDateParameter)
      this.rules[304].opcodes[111] = {type: 4, index: 270};// RNM(notAfterDelDateParameter)
      this.rules[304].opcodes[112] = {type: 4, index: 271};// RNM(releaseDateParameter)
      this.rules[304].opcodes[113] = {type: 4, index: 275};// RNM(gtinParameter)
      this.rules[304].opcodes[114] = {type: 4, index: 276};// RNM(itipParameter)
      this.rules[304].opcodes[115] = {type: 4, index: 277};// RNM(gmnParameter)
      this.rules[304].opcodes[116] = {type: 4, index: 278};// RNM(cpidParameter)
      this.rules[304].opcodes[117] = {type: 4, index: 279};// RNM(glnParameter)
      this.rules[304].opcodes[118] = {type: 4, index: 280};// RNM(payToParameter)
      this.rules[304].opcodes[119] = {type: 4, index: 281};// RNM(partyGlnParameter)
      this.rules[304].opcodes[120] = {type: 4, index: 282};// RNM(gsrnpParameter)
      this.rules[304].opcodes[121] = {type: 4, index: 283};// RNM(gsrnParameter)
      this.rules[304].opcodes[122] = {type: 4, index: 284};// RNM(gcnParameter)
      this.rules[304].opcodes[123] = {type: 4, index: 285};// RNM(ssccParameter)
      this.rules[304].opcodes[124] = {type: 4, index: 286};// RNM(gdtiParameter)
      this.rules[304].opcodes[125] = {type: 4, index: 287};// RNM(gincParameter)
      this.rules[304].opcodes[126] = {type: 4, index: 288};// RNM(gsinParameter)
      this.rules[304].opcodes[127] = {type: 4, index: 289};// RNM(graiParameter)
      this.rules[304].opcodes[128] = {type: 4, index: 290};// RNM(giaiParameter)
  
      /* scheme */
      this.rules[305].opcodes = [];
      this.rules[305].opcodes[0] = {type: 1, children: [1,2]};// ALT
      this.rules[305].opcodes[1] = {type: 7, string: [104,116,116,112,115]};// TLS
      this.rules[305].opcodes[2] = {type: 7, string: [104,116,116,112]};// TLS
  
      /* unreserved */
      this.rules[306].opcodes = [];
      this.rules[306].opcodes[0] = {type: 1, children: [1,2,3,4,5,6]};// ALT
      this.rules[306].opcodes[1] = {type: 4, index: 4};// RNM(ALPHA)
      this.rules[306].opcodes[2] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[306].opcodes[3] = {type: 7, string: [45]};// TLS
      this.rules[306].opcodes[4] = {type: 7, string: [46]};// TLS
      this.rules[306].opcodes[5] = {type: 7, string: [95]};// TLS
      this.rules[306].opcodes[6] = {type: 7, string: [126]};// TLS
  
      /* reserved */
      this.rules[307].opcodes = [];
      this.rules[307].opcodes[0] = {type: 1, children: [1,2]};// ALT
      this.rules[307].opcodes[1] = {type: 4, index: 309};// RNM(gen-delims)
      this.rules[307].opcodes[2] = {type: 4, index: 310};// RNM(sub-delims)
  
      /* pct-encoded */
      this.rules[308].opcodes = [];
      this.rules[308].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[308].opcodes[1] = {type: 7, string: [37]};// TLS
      this.rules[308].opcodes[2] = {type: 4, index: 5};// RNM(HEXDIG)
      this.rules[308].opcodes[3] = {type: 4, index: 5};// RNM(HEXDIG)
  
      /* gen-delims */
      this.rules[309].opcodes = [];
      this.rules[309].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7]};// ALT
      this.rules[309].opcodes[1] = {type: 7, string: [58]};// TLS
      this.rules[309].opcodes[2] = {type: 7, string: [47]};// TLS
      this.rules[309].opcodes[3] = {type: 7, string: [63]};// TLS
      this.rules[309].opcodes[4] = {type: 7, string: [35]};// TLS
      this.rules[309].opcodes[5] = {type: 7, string: [91]};// TLS
      this.rules[309].opcodes[6] = {type: 7, string: [93]};// TLS
      this.rules[309].opcodes[7] = {type: 7, string: [64]};// TLS
  
      /* sub-delims */
      this.rules[310].opcodes = [];
      this.rules[310].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10,11]};// ALT
      this.rules[310].opcodes[1] = {type: 7, string: [33]};// TLS
      this.rules[310].opcodes[2] = {type: 7, string: [36]};// TLS
      this.rules[310].opcodes[3] = {type: 7, string: [38]};// TLS
      this.rules[310].opcodes[4] = {type: 7, string: [39]};// TLS
      this.rules[310].opcodes[5] = {type: 7, string: [40]};// TLS
      this.rules[310].opcodes[6] = {type: 7, string: [41]};// TLS
      this.rules[310].opcodes[7] = {type: 7, string: [42]};// TLS
      this.rules[310].opcodes[8] = {type: 7, string: [43]};// TLS
      this.rules[310].opcodes[9] = {type: 7, string: [44]};// TLS
      this.rules[310].opcodes[10] = {type: 7, string: [59]};// TLS
      this.rules[310].opcodes[11] = {type: 7, string: [61]};// TLS
  
      /* sub-delims-without-equals */
      this.rules[311].opcodes = [];
      this.rules[311].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7,8,9,10]};// ALT
      this.rules[311].opcodes[1] = {type: 7, string: [33]};// TLS
      this.rules[311].opcodes[2] = {type: 7, string: [36]};// TLS
      this.rules[311].opcodes[3] = {type: 7, string: [38]};// TLS
      this.rules[311].opcodes[4] = {type: 7, string: [39]};// TLS
      this.rules[311].opcodes[5] = {type: 7, string: [40]};// TLS
      this.rules[311].opcodes[6] = {type: 7, string: [41]};// TLS
      this.rules[311].opcodes[7] = {type: 7, string: [42]};// TLS
      this.rules[311].opcodes[8] = {type: 7, string: [43]};// TLS
      this.rules[311].opcodes[9] = {type: 7, string: [44]};// TLS
      this.rules[311].opcodes[10] = {type: 7, string: [59]};// TLS
  
      /* everythingExceptDigitsAndEquals */
      this.rules[312].opcodes = [];
      this.rules[312].opcodes[0] = {type: 1, children: [1,2,3,4,5,6,7]};// ALT
      this.rules[312].opcodes[1] = {type: 4, index: 306};// RNM(unreserved)
      this.rules[312].opcodes[2] = {type: 4, index: 308};// RNM(pct-encoded)
      this.rules[312].opcodes[3] = {type: 4, index: 311};// RNM(sub-delims-without-equals)
      this.rules[312].opcodes[4] = {type: 7, string: [58]};// TLS
      this.rules[312].opcodes[5] = {type: 7, string: [64]};// TLS
      this.rules[312].opcodes[6] = {type: 7, string: [47]};// TLS
      this.rules[312].opcodes[7] = {type: 7, string: [63]};// TLS
  
      /* pchar */
      this.rules[313].opcodes = [];
      this.rules[313].opcodes[0] = {type: 1, children: [1,2,3,4,5]};// ALT
      this.rules[313].opcodes[1] = {type: 4, index: 306};// RNM(unreserved)
      this.rules[313].opcodes[2] = {type: 4, index: 308};// RNM(pct-encoded)
      this.rules[313].opcodes[3] = {type: 4, index: 310};// RNM(sub-delims)
      this.rules[313].opcodes[4] = {type: 7, string: [58]};// TLS
      this.rules[313].opcodes[5] = {type: 7, string: [64]};// TLS
  
      /* segment */
      this.rules[314].opcodes = [];
      this.rules[314].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[314].opcodes[1] = {type: 4, index: 313};// RNM(pchar)
  
      /* reg-name */
      this.rules[315].opcodes = [];
      this.rules[315].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[315].opcodes[1] = {type: 1, children: [2,3,4]};// ALT
      this.rules[315].opcodes[2] = {type: 4, index: 306};// RNM(unreserved)
      this.rules[315].opcodes[3] = {type: 4, index: 308};// RNM(pct-encoded)
      this.rules[315].opcodes[4] = {type: 4, index: 310};// RNM(sub-delims)
  
      /* dec-octet */
      this.rules[316].opcodes = [];
      this.rules[316].opcodes[0] = {type: 1, children: [1,2,5,9,13]};// ALT
      this.rules[316].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[316].opcodes[2] = {type: 2, children: [3,4]};// CAT
      this.rules[316].opcodes[3] = {type: 5, min: 49, max: 57};// TRG
      this.rules[316].opcodes[4] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[316].opcodes[5] = {type: 2, children: [6,7]};// CAT
      this.rules[316].opcodes[6] = {type: 7, string: [49]};// TLS
      this.rules[316].opcodes[7] = {type: 3, min: 2, max: 2};// REP
      this.rules[316].opcodes[8] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[316].opcodes[9] = {type: 2, children: [10,11,12]};// CAT
      this.rules[316].opcodes[10] = {type: 7, string: [50]};// TLS
      this.rules[316].opcodes[11] = {type: 5, min: 48, max: 52};// TRG
      this.rules[316].opcodes[12] = {type: 4, index: 0};// RNM(DIGIT)
      this.rules[316].opcodes[13] = {type: 2, children: [14,15]};// CAT
      this.rules[316].opcodes[14] = {type: 7, string: [50,53]};// TLS
      this.rules[316].opcodes[15] = {type: 5, min: 48, max: 53};// TRG
  
      /* IPv4address */
      this.rules[317].opcodes = [];
      this.rules[317].opcodes[0] = {type: 2, children: [1,2,3,4,5,6,7]};// CAT
      this.rules[317].opcodes[1] = {type: 4, index: 316};// RNM(dec-octet)
      this.rules[317].opcodes[2] = {type: 7, string: [46]};// TLS
      this.rules[317].opcodes[3] = {type: 4, index: 316};// RNM(dec-octet)
      this.rules[317].opcodes[4] = {type: 7, string: [46]};// TLS
      this.rules[317].opcodes[5] = {type: 4, index: 316};// RNM(dec-octet)
      this.rules[317].opcodes[6] = {type: 7, string: [46]};// TLS
      this.rules[317].opcodes[7] = {type: 4, index: 316};// RNM(dec-octet)
  
      /* IPv6address */
      this.rules[318].opcodes = [];
      this.rules[318].opcodes[0] = {type: 1, children: [1,7,14,23,37,51,63,73,83]};// ALT
      this.rules[318].opcodes[1] = {type: 2, children: [2,6]};// CAT
      this.rules[318].opcodes[2] = {type: 3, min: 6, max: 6};// REP
      this.rules[318].opcodes[3] = {type: 2, children: [4,5]};// CAT
      this.rules[318].opcodes[4] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[5] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[6] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[7] = {type: 2, children: [8,9,13]};// CAT
      this.rules[318].opcodes[8] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[9] = {type: 3, min: 5, max: 5};// REP
      this.rules[318].opcodes[10] = {type: 2, children: [11,12]};// CAT
      this.rules[318].opcodes[11] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[12] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[13] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[14] = {type: 2, children: [15,17,18,22]};// CAT
      this.rules[318].opcodes[15] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[16] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[17] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[18] = {type: 3, min: 4, max: 4};// REP
      this.rules[318].opcodes[19] = {type: 2, children: [20,21]};// CAT
      this.rules[318].opcodes[20] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[21] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[22] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[23] = {type: 2, children: [24,31,32,36]};// CAT
      this.rules[318].opcodes[24] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[25] = {type: 2, children: [26,30]};// CAT
      this.rules[318].opcodes[26] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[27] = {type: 2, children: [28,29]};// CAT
      this.rules[318].opcodes[28] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[29] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[30] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[31] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[32] = {type: 3, min: 3, max: 3};// REP
      this.rules[318].opcodes[33] = {type: 2, children: [34,35]};// CAT
      this.rules[318].opcodes[34] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[35] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[36] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[37] = {type: 2, children: [38,45,46,50]};// CAT
      this.rules[318].opcodes[38] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[39] = {type: 2, children: [40,44]};// CAT
      this.rules[318].opcodes[40] = {type: 3, min: 0, max: 2};// REP
      this.rules[318].opcodes[41] = {type: 2, children: [42,43]};// CAT
      this.rules[318].opcodes[42] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[43] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[44] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[45] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[46] = {type: 3, min: 2, max: 2};// REP
      this.rules[318].opcodes[47] = {type: 2, children: [48,49]};// CAT
      this.rules[318].opcodes[48] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[49] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[50] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[51] = {type: 2, children: [52,59,60,61,62]};// CAT
      this.rules[318].opcodes[52] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[53] = {type: 2, children: [54,58]};// CAT
      this.rules[318].opcodes[54] = {type: 3, min: 0, max: 3};// REP
      this.rules[318].opcodes[55] = {type: 2, children: [56,57]};// CAT
      this.rules[318].opcodes[56] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[57] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[58] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[59] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[60] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[61] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[62] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[63] = {type: 2, children: [64,71,72]};// CAT
      this.rules[318].opcodes[64] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[65] = {type: 2, children: [66,70]};// CAT
      this.rules[318].opcodes[66] = {type: 3, min: 0, max: 4};// REP
      this.rules[318].opcodes[67] = {type: 2, children: [68,69]};// CAT
      this.rules[318].opcodes[68] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[69] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[70] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[71] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[72] = {type: 4, index: 319};// RNM(ls32)
      this.rules[318].opcodes[73] = {type: 2, children: [74,81,82]};// CAT
      this.rules[318].opcodes[74] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[75] = {type: 2, children: [76,80]};// CAT
      this.rules[318].opcodes[76] = {type: 3, min: 0, max: 5};// REP
      this.rules[318].opcodes[77] = {type: 2, children: [78,79]};// CAT
      this.rules[318].opcodes[78] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[79] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[80] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[81] = {type: 7, string: [58,58]};// TLS
      this.rules[318].opcodes[82] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[83] = {type: 2, children: [84,91]};// CAT
      this.rules[318].opcodes[84] = {type: 3, min: 0, max: 1};// REP
      this.rules[318].opcodes[85] = {type: 2, children: [86,90]};// CAT
      this.rules[318].opcodes[86] = {type: 3, min: 0, max: 6};// REP
      this.rules[318].opcodes[87] = {type: 2, children: [88,89]};// CAT
      this.rules[318].opcodes[88] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[89] = {type: 7, string: [58]};// TLS
      this.rules[318].opcodes[90] = {type: 4, index: 320};// RNM(h16)
      this.rules[318].opcodes[91] = {type: 7, string: [58,58]};// TLS
  
      /* ls32 */
      this.rules[319].opcodes = [];
      this.rules[319].opcodes[0] = {type: 1, children: [1,5]};// ALT
      this.rules[319].opcodes[1] = {type: 2, children: [2,3,4]};// CAT
      this.rules[319].opcodes[2] = {type: 4, index: 320};// RNM(h16)
      this.rules[319].opcodes[3] = {type: 7, string: [58]};// TLS
      this.rules[319].opcodes[4] = {type: 4, index: 320};// RNM(h16)
      this.rules[319].opcodes[5] = {type: 4, index: 317};// RNM(IPv4address)
  
      /* h16 */
      this.rules[320].opcodes = [];
      this.rules[320].opcodes[0] = {type: 3, min: 1, max: 4};// REP
      this.rules[320].opcodes[1] = {type: 4, index: 5};// RNM(HEXDIG)
  
      /* IP-literal */
      this.rules[321].opcodes = [];
      this.rules[321].opcodes[0] = {type: 2, children: [1,2,5]};// CAT
      this.rules[321].opcodes[1] = {type: 7, string: [91]};// TLS
      this.rules[321].opcodes[2] = {type: 1, children: [3,4]};// ALT
      this.rules[321].opcodes[3] = {type: 4, index: 318};// RNM(IPv6address)
      this.rules[321].opcodes[4] = {type: 4, index: 322};// RNM(IPvFuture)
      this.rules[321].opcodes[5] = {type: 7, string: [93]};// TLS
  
      /* IPvFuture */
      this.rules[322].opcodes = [];
      this.rules[322].opcodes[0] = {type: 2, children: [1,2,4,5]};// CAT
      this.rules[322].opcodes[1] = {type: 7, string: [118]};// TLS
      this.rules[322].opcodes[2] = {type: 3, min: 1, max: Infinity};// REP
      this.rules[322].opcodes[3] = {type: 4, index: 5};// RNM(HEXDIG)
      this.rules[322].opcodes[4] = {type: 7, string: [46]};// TLS
      this.rules[322].opcodes[5] = {type: 3, min: 1, max: Infinity};// REP
      this.rules[322].opcodes[6] = {type: 1, children: [7,8,9]};// ALT
      this.rules[322].opcodes[7] = {type: 4, index: 306};// RNM(unreserved)
      this.rules[322].opcodes[8] = {type: 4, index: 310};// RNM(sub-delims)
      this.rules[322].opcodes[9] = {type: 7, string: [58]};// TLS
  
      /* host */
      this.rules[323].opcodes = [];
      this.rules[323].opcodes[0] = {type: 1, children: [1,2,3]};// ALT
      this.rules[323].opcodes[1] = {type: 4, index: 321};// RNM(IP-literal)
      this.rules[323].opcodes[2] = {type: 4, index: 317};// RNM(IPv4address)
      this.rules[323].opcodes[3] = {type: 4, index: 315};// RNM(reg-name)
  
      /* port */
      this.rules[324].opcodes = [];
      this.rules[324].opcodes[0] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[324].opcodes[1] = {type: 4, index: 0};// RNM(DIGIT)
  
      /* hostname */
      this.rules[325].opcodes = [];
      this.rules[325].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[325].opcodes[1] = {type: 4, index: 323};// RNM(host)
      this.rules[325].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[325].opcodes[3] = {type: 2, children: [4,5]};// CAT
      this.rules[325].opcodes[4] = {type: 7, string: [58]};// TLS
      this.rules[325].opcodes[5] = {type: 4, index: 324};// RNM(port)
  
      /* queryStringDelim */
      this.rules[326].opcodes = [];
      this.rules[326].opcodes[0] = {type: 1, children: [1,2]};// ALT
      this.rules[326].opcodes[1] = {type: 7, string: [38]};// TLS
      this.rules[326].opcodes[2] = {type: 7, string: [59]};// TLS
  
      /* queryStringComp */
      this.rules[327].opcodes = [];
      this.rules[327].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[327].opcodes[1] = {type: 7, string: [63]};// TLS
      this.rules[327].opcodes[2] = {type: 4, index: 304};// RNM(queryStringParam)
      this.rules[327].opcodes[3] = {type: 3, min: 0, max: Infinity};// REP
      this.rules[327].opcodes[4] = {type: 2, children: [5,6]};// CAT
      this.rules[327].opcodes[5] = {type: 4, index: 326};// RNM(queryStringDelim)
      this.rules[327].opcodes[6] = {type: 4, index: 304};// RNM(queryStringParam)
  
      /* uncompressedGS1webURIPattern */
      this.rules[328].opcodes = [];
      this.rules[328].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[328].opcodes[1] = {type: 4, index: 123};// RNM(gs1path)
      this.rules[328].opcodes[2] = {type: 3, min: 0, max: 1};// REP
      this.rules[328].opcodes[3] = {type: 4, index: 327};// RNM(queryStringComp)
  
      /* referenceGS1webURI */
      this.rules[329].opcodes = [];
      this.rules[329].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[329].opcodes[1] = {type: 7, string: [104,116,116,112,115,58,47,47,105,100,46,103,115,49,46,111,114,103]};// TLS
      this.rules[329].opcodes[2] = {type: 4, index: 328};// RNM(uncompressedGS1webURIPattern)
  
      /* customURIstem */
      this.rules[330].opcodes = [];
      this.rules[330].opcodes[0] = {type: 2, children: [1,2,3]};// CAT
      this.rules[330].opcodes[1] = {type: 4, index: 305};// RNM(scheme)
      this.rules[330].opcodes[2] = {type: 7, string: [58,47,47]};// TLS
      this.rules[330].opcodes[3] = {type: 4, index: 325};// RNM(hostname)
  
      /* uncompressedCustomGS1webURI */
      this.rules[331].opcodes = [];
      this.rules[331].opcodes[0] = {type: 2, children: [1,2]};// CAT
      this.rules[331].opcodes[1] = {type: 4, index: 330};// RNM(customURIstem)
      this.rules[331].opcodes[2] = {type: 4, index: 328};// RNM(uncompressedGS1webURIPattern)
  
      // The `toString()` function will display the original grammar file(s) that produced these opcodes.
      this.toString = function(){
        var str = "";
        str += ";; GS1 Digital Link Web URI Grammar\n";
        str += ";; Corresponding to version 1.2 of the GS1 Digital Link standard\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Character sets  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "DIGIT = \"0\" / \"1\" / \"2\" / \"3\" / \"4\" /\n";
        str += "    \"5\" / \"6\" / \"7\" / \"8\" / \"9\"\n";
        str += "\n";
        str += "BOOLEAN = \"0\" / \"1\"\n";
        str += "\n";
        str += "UPPERALPHA = %x41-5A ; A-Z  ( ASCII characters 65-90 decimal, 41-5A hex)\n";
        str += "\n";
        str += "LOWERALPHA = %x61-7A ; a-z  ( ASCII characters 97-122 decimal, 61-7A hex)\n";
        str += "\n";
        str += "ALPHA = UPPERALPHA / LOWERALPHA ; A-Z or a-z\n";
        str += "\n";
        str += "HEXDIG = DIGIT / \"A\" / \"B\" / \"C\" / \"D\" / \"E\" / \"F\"\n";
        str += "\n";
        str += "DoubleQuote = '\"' ; the double-quote character \"\n";
        str += "\n";
        str += "Octothorpe = \"%23\" ; percent-encoding of the # character\n";
        str += "ForwardSlash = \"%2F\" ; percent-encoding of the / character\n";
        str += "\n";
        str += "Percent = \"%25\" ; percent-encoding of the % character\n";
        str += "Ampersand = \"%26\" ; percent-encoding of the & character\n";
        str += "Plus = \"%2B\" ; percent-encoding of the + character\n";
        str += "Comma = \"%2C\" ; percent-encoding of the , character\n";
        str += "\n";
        str += "Exclamation = \"%21\" ; percent-encoding of the ! character\n";
        str += "LeftBracket = \"%28\" ; percent-encoding of the ( character\n";
        str += "RightBracket = \"%29\" ; percent-encoding of the ) character\n";
        str += "Asterisk = \"%2A\" ; percent-encoding of the * character\n";
        str += "\n";
        str += "Apostrophe = \"%27\" ; percent-encoding of the ' character\n";
        str += "Colon = \"%3A\" ; percent-encoding of the : character\n";
        str += "Semicolon = \"%3B\" ; percent-encoding of the ; character\n";
        str += "LeftAngleBracket = \"%3C\" ; percent-encoding of the < character\n";
        str += "Equals = \"%3D\" ; percent-encoding of the = character\n";
        str += "RightAngleBracket = \"%3E\" ; percent-encoding of the > character\n";
        str += "QuestionMark = \"%3F\" ; percent-encoding of the ? character\n";
        str += "\n";
        str += "XSYMBOL   = DoubleQuote / \"-\" / \".\" / \"_\" / Exclamation / Percent /\n";
        str += "     Ampersand / Plus / Comma / ForwardSlash / Asterisk /\n";
        str += "     LeftBracket / RightBracket / Apostrophe / Semicolon /\n";
        str += "     Colon / LeftAngleBracket / RightAngleBracket / Equals /\n";
        str += "     QuestionMark\n";
        str += "\n";
        str += "YSYMBOL   = \"-\" / Octothorpe / ForwardSlash\n";
        str += "\n";
        str += "XCHAR   = DIGIT / UPPERALPHA / LOWERALPHA / XSYMBOL\n";
        str += "\n";
        str += "YCHAR   = DIGIT / UPPERALPHA / YSYMBOL\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;   SECTION - Primary identification keys  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "gtin-code = \"01\"  ; GTIN\n";
        str += "itip-code = \"8006\"  ; ITIP\n";
        str += "gmn-code = \"8013\"  ; Global Model Number\n";
        str += "cpid-code = \"8010\"  ; CPID\n";
        str += "gln-code  = \"414\"  ; Physical Location GLN\n";
        str += "payTo-code = \"415\" ; GLN of invoicing party\n";
        str += "partyGln-code = \"417\" ; Party GLN\n";
        str += "gsrnp-code  = \"8017\" ; GSRN of the Provider\n";
        str += "gsrn-code  = \"8018\" ; GSRN of the Recipient\n";
        str += "gcn-code  = \"255\" ; GCN\n";
        str += "sscc-code  = \"00\" ; SSCC\n";
        str += "gdti-code  = \"253\" ; GDTI\n";
        str += "ginc-code  = \"401\" ; GINC\n";
        str += "gsin-code  = \"402\" ; GSIN\n";
        str += "grai-code  = \"8003\" ; GRAI\n";
        str += "giai-code  = \"8004\" ; GIAI\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Key qualifiers  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "cpv-code  = \"22\" ; Consumer Product Variant\n";
        str += "lot-code  = \"10\" ; Batch/Lot identifier\n";
        str += "ser-code  = \"21\" ; GTIN Serial Number\n";
        str += "cpsn-code  = \"8011\" ; CPID Serial Number\n";
        str += "glnx-code  = \"254\" ; GLN extension\n";
        str += "refno-code = \"8020\" ; Payment Reference Number\n";
        str += "srin-code  = \"8019\" ; Service Relation Instance Number\n";
        str += "tpx-code = \"235\" ; third-party controlled serialised extension to GTIN\n";
        str += "uic-ext-code = \"7040\" ; GS1 UIC with Extension 1 and Importer Index\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Primary key formats  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "gtin-value  = 14DIGIT ; GTIN-8, GTIN-12 and GTIN-13 SHALL be expressed as 14 digits, with leading zeroes serving as filler digits\n";
        str += "itip-value = 14DIGIT 2DIGIT 2DIGIT ; 14 digits then 2 digits then 2 digits\n";
        str += "gmn-value  = 1*25XCHAR  ; 1-25 characters from 82-chr subset\n";
        str += "cpid-value  = 1*30YCHAR  ; 1-30 characters from 39-chr subset\n";
        str += "\n";
        str += "gln-value  = 13DIGIT   ; exactly 13 digits\n";
        str += "payTo-value  = 13DIGIT   ; exactly 13 digits\n";
        str += "partyGln-value  = 13DIGIT   ; exactly 13 digits\n";
        str += "gsrnp-value  = 18DIGIT   ; exactly 18 digits\n";
        str += "gsrn-value  = 18DIGIT   ; exactly 18 digits\n";
        str += "gcn-value  = 13DIGIT [1*12DIGIT]  ; 13 digits then optional 1-12 digits\n";
        str += "sscc-value  = 18DIGIT   ; exactly 18 digits\n";
        str += "gdti-value  = 13DIGIT [1*17XCHAR]  ; 13 digits then optional 1-17 characters ; from the 82-character subset\n";
        str += "ginc-value  = 1*30XCHAR  ; 1-30 characters from the 82-character subset\n";
        str += "gsin-value  = 17DIGIT   ; exactly 17 digits\n";
        str += "grai-value  = 14DIGIT [1*16XCHAR]; 14 digits then optional 1-16 characters ; from the 82-character subset of ISO/IEC 646\n";
        str += "giai-value  = 1*30XCHAR  ; 1-30 characters from 82-chr subset\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Key qualifier formats  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "cpv-value = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
        str += "lot-value = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
        str += "ser-value = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
        str += "cpsn-value = 1*12DIGIT  ; 1-12 digits\n";
        str += "glnx-value = 1*20XCHAR  ; 1-20 characters from 82-chr subset\n";
        str += "refno-value  = 1*25XCHAR  ; 1-25 characters from 82-chr subset\n";
        str += "srin-value  = 1*10DIGIT  ; 1-10 digits\n";
        str += "tpx-value = 1*28XCHAR  ; 1-28 characters from 82-chr subset\n";
        str += "uic-ext-value = 1DIGIT 3XCHAR ; 1 digit then 3 characters from 82-chr subset\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Primary identifier and value concatenation  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "gtin-comp = \"/\" gtin-code \"/\" gtin-value\n";
        str += "itip-comp  = \"/\" itip-code \"/\" itip-value\n";
        str += "gmn-comp  = \"/\" gmn-code \"/\" gmn-value\n";
        str += "cpid-comp  = \"/\" cpid-code \"/\" cpid-value\n";
        str += "gln-comp  = \"/\" gln-code \"/\" gln-value\n";
        str += "payTo-comp = \"/\" payTo-code \"/\" payTo-value\n";
        str += "partyGln-comp = \"/\" partyGln-code \"/\" partyGln-value\n";
        str += "gsrnp-comp = \"/\" gsrnp-code \"/\" gsrnp-value\n";
        str += "gsrn-comp = \"/\" gsrn-code \"/\" gsrn-value\n";
        str += "gcn-comp  = \"/\" gcn-code \"/\" gcn-value\n";
        str += "sscc-comp  = \"/\" sscc-code \"/\" sscc-value\n";
        str += "gdti-comp  = \"/\" gdti-code \"/\" gdti-value\n";
        str += "ginc-comp  = \"/\" ginc-code \"/\" ginc-value\n";
        str += "gsin-comp  = \"/\" gsin-code \"/\" gsin-value\n";
        str += "grai-comp  = \"/\" grai-code \"/\" grai-value\n";
        str += "giai-comp  = \"/\" giai-code \"/\" giai-value\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Key qualifier concatenation  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "cpv-comp  = \"/\" cpv-code \"/\" cpv-value\n";
        str += "lot-comp  = \"/\" lot-code \"/\" lot-value\n";
        str += "ser-comp  = \"/\" ser-code \"/\" ser-value\n";
        str += "cpsn-comp  = \"/\" cpsn-code \"/\" cpsn-value\n";
        str += "glnx-comp  = \"/\" glnx-code \"/\" glnx-value\n";
        str += "refno-comp = \"/\" refno-code \"/\" refno-value\n";
        str += "srin-comp  = \"/\" srin-code \"/\" srin-value\n";
        str += "tpx-comp = \"/\" tpx-code \"/\" tpx-value\n";
        str += "uic-ext-comp = \"/\" uic-ext-code \"/\" uic-ext-value\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Path element order  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "gtin-path  = gtin-comp  [cpv-comp] [lot-comp] [ser-comp]\n";
        str += "itip-path  = itip-comp  [cpv-comp] [lot-comp] [ser-comp]\n";
        str += "gmn-path  = gmn-comp\n";
        str += "cpid-path  = cpid-comp  [cpsn-comp]\n";
        str += "gln-path  = gln-comp   [glnx-comp]\n";
        str += "payTo-path = payTo-comp\n";
        str += "partyGln-path = partyGln-comp\n";
        str += "gsrnp-path = gsrnp-comp [srin-comp]\n";
        str += "gsrn-path  = gsrn-comp  [srin-comp]\n";
        str += "gcn-path  = gcn-comp\n";
        str += "sscc-path  = sscc-comp\n";
        str += "gdti-path  = gdti-comp\n";
        str += "ginc-path  = ginc-comp\n";
        str += "gsin-path  = gsin-comp\n";
        str += "grai-path  = grai-comp\n";
        str += "giai-path  = giai-comp\n";
        str += "upui-path = gtin-comp tpx-comp\n";
        str += "eoid-path = partyGln-comp uic-ext-comp\n";
        str += "fid-path = gln-comp uic-ext-comp\n";
        str += "mid-path = giai-comp uic-ext-comp\n";
        str += "gs1path  = gtin-path / itip-path / gmn-path / cpid-path / gln-path / partyGln-path / gsrnp-path /\n";
        str += "  gsrn-path / gcn-path / sscc-path / gdti-path / ginc-path /\n";
        str += "  gsin-path / grai-path / giai-path / upui-path / eoid-path /\n";
        str += "  fid-path / mid-path\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Data attributes  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "netWeightVMTICode  = \"3100\" / \"3101\" / \"3102\" / \"3103\" / \"3104\" / \"3105\" /\n";
        str += "    \"3200\" / \"3201\" / \"3202\" / \"3203\" / \"3204\" / \"3205\" /\n";
        str += "    \"3560\" / \"3561\" / \"3562\" / \"3563\" / \"3564\" / \"3565\" /\n";
        str += "    \"3570\" / \"3571\" / \"3572\" / \"3573\" / \"3574\" / \"3575\"\n";
        str += "netWeightVMTIValue = 6DIGIT\n";
        str += "netWeightVMTIParameter = netWeightVMTICode \"=\" netWeightVMTIValue\n";
        str += "\n";
        str += "lengthVMTICode  = \"3110\" / \"3111\" / \"3112\" / \"3113\" / \"3114\" / \"3115\" /\n";
        str += "   \"3210\" / \"3211\" / \"3212\" / \"3213\" / \"3214\" / \"3215\" /\n";
        str += "   \"3220\" / \"3221\" / \"3222\" / \"3223\" / \"3224\" / \"3225\" /\n";
        str += "   \"3230\" / \"3231\" / \"3232\" / \"3233\" / \"3234\" / \"3235\"\n";
        str += "lengthVMTIValue = 6DIGIT\n";
        str += "lengthVMTIParameter = lengthVMTICode \"=\" lengthVMTIValue\n";
        str += "\n";
        str += "widthVMTICode  = \"3120\" / \"3121\" / \"3122\" / \"3123\" / \"3124\" / \"3125\" /\n";
        str += "   \"3240\" / \"3241\" / \"3242\" / \"3243\" / \"3244\" / \"3245\" /\n";
        str += "   \"3250\" / \"3251\" / \"3252\" / \"3253\" / \"3254\" / \"3255\" /\n";
        str += "   \"3260\" / \"3261\" / \"3262\" / \"3263\" / \"3264\" / \"3265\"\n";
        str += "widthVMTIValue = 6DIGIT\n";
        str += "widthVMTIParameter = widthVMTICode \"=\" widthVMTIValue\n";
        str += "\n";
        str += "depthVMTICode = \"3130\" / \"3131\" / \"3132\" / \"3133\" / \"3134\" / \"3135\" /\n";
        str += "   \"3270\" / \"3271\" / \"3272\" / \"3273\" / \"3274\" / \"3275\" /\n";
        str += "   \"3280\" / \"3281\" / \"3282\" / \"3283\" / \"3284\" / \"3285\" /\n";
        str += "   \"3290\" / \"3291\" / \"3292\" / \"3293\" / \"3294\" / \"3295\"\n";
        str += "\n";
        str += "depthVMTIValue = 6DIGIT\n";
        str += "depthVMTIParameter = depthVMTICode \"=\" depthVMTIValue\n";
        str += "\n";
        str += "areaVMTICode  = \"3140\" / \"3141\" / \"3142\" / \"3143\" / \"3144\" / \"3145\" /\n";
        str += "   \"3500\" / \"3501\" / \"3502\" / \"3503\" / \"3504\" / \"3505\" /\n";
        str += "   \"3510\" / \"3511\" / \"3512\" / \"3513\" / \"3514\" / \"3515\" /\n";
        str += "   \"3520\" / \"3521\" / \"3522\" / \"3523\" / \"3524\" / \"3525\"\n";
        str += "\n";
        str += "areaVMTIValue = 6DIGIT\n";
        str += "areaVMTIParameter = areaVMTICode \"=\" areaVMTIValue\n";
        str += "\n";
        str += "netVolumeVMTICode  = \"3150\" / \"3151\" / \"3152\" / \"3153\" / \"3154\" / \"3155\" /\n";
        str += "   \"3160\" / \"3161\" / \"3162\" / \"3163\" / \"3164\" / \"3165\" /\n";
        str += "   \"3600\" / \"3601\" / \"3602\" / \"3603\" / \"3604\" / \"3605\" /\n";
        str += "   \"3610\" / \"3611\" / \"3612\" / \"3613\" / \"3614\" / \"3615\" /\n";
        str += "   \"3640\" / \"3641\" / \"3642\" / \"3643\" / \"3644\" / \"3645\" /\n";
        str += "   \"3650\" / \"3651\" / \"3652\" / \"3653\" / \"3654\" / \"3655\" /\n";
        str += "   \"3660\" / \"3661\" / \"3662\" / \"3663\" / \"3664\" / \"3665\"\n";
        str += "\n";
        str += "netVolumeVMTIValue   = 6DIGIT\n";
        str += "netVolumeVMTIParameter  = netVolumeVMTICode \"=\" netVolumeVMTIValue\n";
        str += "\n";
        str += "massPerUnitAreaVMTICode  = \"3370\" / \"3371\" / \"3372\" / \"3373\" / \"3374\" / \"3375\"\n";
        str += "massPerUnitAreaVMTIValue   = 6DIGIT\n";
        str += "massPerUnitAreaVMTIParameter = massPerUnitAreaVMTICode \"=\" massPerUnitAreaVMTIValue\n";
        str += "\n";
        str += "grossWeightCode  = \"3300\" / \"3301\" / \"3302\" / \"3303\" / \"3304\" / \"3305\" /\n";
        str += "   \"3400\" / \"3401\" / \"3402\" / \"3403\" / \"3404\" / \"3405\"\n";
        str += "grossWeightValue   = 6DIGIT\n";
        str += "grossWeightParameter   = grossWeightCode \"=\" grossWeightValue\n";
        str += "\n";
        str += "logisticLengthCode  = \"3310\" / \"3311\" / \"3312\" / \"3313\" / \"3314\" / \"3315\" /\n";
        str += "   \"3410\" / \"3411\" / \"3412\" / \"3413\" / \"3414\" / \"3415\" /   \"3420\" / \"3421\" / \"3422\" / \"3423\" / \"3424\" / \"3425\" /   \"3430\" / \"3431\" / \"3432\" / \"3433\" / \"3434\" / \"3435\"\n";
        str += "logisticLengthValue   = 6DIGIT\n";
        str += "logisticLengthParameter = logisticLengthCode \"=\" logisticLengthValue\n";
        str += "\n";
        str += "logisticWidthCode  = \"3320\" / \"3321\" / \"3322\" / \"3323\" / \"3324\" / \"3325\" /\n";
        str += "   \"3440\" / \"3441\" / \"3442\" / \"3443\" / \"3444\" / \"3445\" /   \"3450\" / \"3451\" / \"3452\" / \"3453\" / \"3454\" / \"3455\" /   \"3460\" / \"3461\" / \"3462\" / \"3463\" / \"3464\" / \"3465\"\n";
        str += "logisticWidthValue   = 6DIGIT\n";
        str += "logisticWidthParameter  = logisticWidthCode \"=\" logisticWidthValue\n";
        str += "\n";
        str += "logisticDepthCode  = \"3330\" / \"3331\" / \"3332\" / \"3333\" / \"3334\" / \"3335\" /\n";
        str += "   \"3470\" / \"3471\" / \"3472\" / \"3473\" / \"3474\" / \"3475\" /\n";
        str += "   \"3480\" / \"3481\" / \"3482\" / \"3483\" / \"3484\" / \"3485\" /\n";
        str += "   \"3490\" / \"3491\" / \"3492\" / \"3493\" / \"3494\" / \"3495\"\n";
        str += "logisticDepthValue   = 6DIGIT\n";
        str += "logisticDepthParameter  = logisticDepthCode \"=\" logisticDepthValue\n";
        str += "\n";
        str += "logisticAreaCode  = \"3340\" / \"3341\" / \"3342\" / \"3343\" / \"3344\" / \"3345\" /\n";
        str += "   \"3530\" / \"3531\" / \"3532\" / \"3533\" / \"3534\" / \"3535\" /   \"3540\" / \"3541\" / \"3542\" / \"3543\" / \"3544\" / \"3545\" /   \"3550\" / \"3551\" / \"3552\" / \"3553\" / \"3554\" / \"3555\"\n";
        str += "logisticAreaValue   = 6DIGIT\n";
        str += "logisticAreaParameter  = logisticAreaCode \"=\" logisticAreaValue\n";
        str += "\n";
        str += "logisticVolumeCode  = \"3350\" / \"3351\" / \"3352\" / \"3353\" / \"3354\" / \"3355\" /   \"3360\" / \"3361\" / \"3362\" / \"3363\" / \"3364\" / \"3365\" /   \"3620\" / \"3621\" / \"3622\" / \"3623\" / \"3624\" / \"3625\" /   \"3630\" / \"3631\" / \"3632\" / \"3633\" / \"3634\" / \"3635\" /   \"3670\" / \"3671\" / \"3672\" / \"3673\" / \"3674\" / \"3675\" /   \"3680\" / \"3681\" / \"3682\" / \"3683\" / \"3684\" / \"3685\" /   \"3690\" / \"3691\" / \"3692\" / \"3693\" / \"3694\" / \"3695\"\n";
        str += "logisticVolumeValue   = 6DIGIT\n";
        str += "logisticVolumeParameter  = logisticVolumeCode \"=\" logisticVolumeValue\n";
        str += "\n";
        str += "processorCode  = \"7030\" / \"7031\" / \"7032\" / \"7033\" / \"7034\" / \"7035\" /\n";
        str += "   \"7036\" / \"7037\" / \"7038\" / \"7039\"\n";
        str += "processorValue   = 3DIGIT   1*27XCHAR\n";
        str += "processorParameter   = processorCode \"=\" processorValue\n";
        str += "\n";
        str += "contentParameter = \"02=\" 14DIGIT\n";
        str += "\n";
        str += "prodDateParameter = \"11=\" 6DIGIT\n";
        str += "\n";
        str += "dueDateParameter = \"12=\" 6DIGIT\n";
        str += "\n";
        str += "packDateParameter = \"13=\" 6DIGIT\n";
        str += "\n";
        str += "bestBeforeDateParameter = \"15=\" 6DIGIT\n";
        str += "\n";
        str += "sellByDateParameter = \"16=\" 6DIGIT\n";
        str += "\n";
        str += "firstFreezeDateParameter = \"7006=\" 6DIGIT\n";
        str += "\n";
        str += "harvestDateParameter = \"7007=\" 6DIGIT [6DIGIT]\n";
        str += "\n";
        str += "pricePerUnitParameter = \"8005=\" 6DIGIT\n";
        str += "\n";
        str += "variantParameter = \"20=\" 2DIGIT\n";
        str += "\n";
        str += "varCountParameter = \"30=\" 1*8DIGIT\n";
        str += "\n";
        str += "countParameter = \"37=\" 1*8DIGIT\n";
        str += "\n";
        str += "mutualParameter = \"90=\" 1*30XCHAR\n";
        str += "\n";
        str += "additionalIdParameter = \"240=\" 1*30XCHAR\n";
        str += "\n";
        str += "custPartNoParameter = \"241=\" 1*30XCHAR\n";
        str += "\n";
        str += "mtoVariantParameter = \"242=\" 1*6DIGIT\n";
        str += "\n";
        str += "pcnParameter = \"243=\" 1*20XCHAR\n";
        str += "\n";
        str += "secondarySerialParameter = \"250=\" 1*30XCHAR\n";
        str += "\n";
        str += "refToSourceParameter = \"251=\" 1*30XCHAR\n";
        str += "\n";
        str += "amountCode  = \"3900\" / \"3901\" / \"3902\" / \"3903\" / \"3904\" / \"3905\"\n";
        str += "amountValue  = 1*15DIGIT\n";
        str += "amountParameter  = amountCode \"=\" amountValue\n";
        str += "\n";
        str += "amountISOCode  = \"3910\" / \"3911\" / \"3912\" / \"3913\" / \"3914\" / \"3915\"\n";
        str += "amountISOValue  = 3DIGIT 1*15DIGIT\n";
        str += "amountISOParameter  = amountISOCode \"=\" amountISOValue\n";
        str += "\n";
        str += "priceCode  = \"3920\" / \"3921\" / \"3922\" / \"3923\" / \"3924\" / \"3925\"\n";
        str += "priceValue  = 1*15DIGIT\n";
        str += "priceParameter  = priceCode \"=\" priceValue\n";
        str += "\n";
        str += "priceISOCode  = \"3930\" / \"3931\" / \"3932\" / \"3933\" / \"3934\" / \"3935\"\n";
        str += "priceISOValue  = 3DIGIT  1*15DIGIT\n";
        str += "priceISOParameter  = priceISOCode \"=\" priceISOValue\n";
        str += "\n";
        str += "percentOffCode  = \"3940\" / \"3941\" / \"3942\" / \"3943\" / \"3944\" / \"3945\"\n";
        str += "percentOffValue  = 4DIGIT\n";
        str += "percentOffParameter  = percentOffCode \"=\" percentOffValue\n";
        str += "\n";
        str += "orderNumberParameter = \"400=\" 1*30XCHAR\n";
        str += "\n";
        str += "routeParameter = \"403=\" 1*30XCHAR\n";
        str += "\n";
        str += "shipToLocParameter = \"410=\" 13DIGIT\n";
        str += "\n";
        str += "billToParameter = \"411=\" 13DIGIT\n";
        str += "\n";
        str += "purchaseFromParameter = \"412=\" 13DIGIT\n";
        str += "\n";
        str += "shipForLocParameter = \"413=\" 13DIGIT\n";
        str += "\n";
        str += "prodServLocParameter = \"416=\" 13DIGIT\n";
        str += "\n";
        str += "shipToPostParameter = \"420=\" 1*20XCHAR\n";
        str += "\n";
        str += "shipToPostISOParameter = \"421=\" 3DIGIT 1*9XCHAR\n";
        str += "\n";
        str += "originParameter = \"422=\" 3DIGIT\n";
        str += "\n";
        str += "countryProcessParameter = \"424=\" 3DIGIT\n";
        str += "\n";
        str += "countryFullProcessParameter = \"426=\" 3DIGIT\n";
        str += "\n";
        str += "countryInitialProcessParameter = \"423=\" 3DIGIT 1*12DIGIT\n";
        str += "\n";
        str += "countryDisassemblyParameter = \"425=\" 3DIGIT 1*12DIGIT\n";
        str += "\n";
        str += "originSubdivisionParameter = \"427=\" 1*3XCHAR\n";
        str += "\n";
        str += "nhrnPZNParameter = \"710=\" 1*20XCHAR\n";
        str += "\n";
        str += "nhrnCIPParameter = \"711=\" 1*20XCHAR\n";
        str += "\n";
        str += "nhrnCNParameter = \"712=\" 1*20XCHAR\n";
        str += "\n";
        str += "nhrnDRNParameter = \"713=\" 1*20XCHAR\n";
        str += "\n";
        str += "nhrnAIMParameter = \"714=\" 1*20XCHAR\n";
        str += "\n";
        str += "nhrnUS-FDAParameter = \"715=\" 1*20XCHAR\n";
        str += "\n";
        str += "nsnParameter = \"7001=\" 13DIGIT\n";
        str += "\n";
        str += "meatCutParameter = \"7002=\" 1*30XCHAR\n";
        str += "\n";
        str += "activePotencyParameter = \"7004=\" 1*4DIGIT\n";
        str += "\n";
        str += "catchAreaParameter = \"7005=\" 1*12XCHAR\n";
        str += "\n";
        str += "aquaticSpeciesParameter = \"7008=\" 1*3XCHAR\n";
        str += "\n";
        str += "fishingGearTypeParameter = \"7009=\" 1*10XCHAR\n";
        str += "\n";
        str += "prodMethodParameter = \"7010=\" 1*2XCHAR\n";
        str += "\n";
        str += "refurbLotParameter = \"7020=\" 1*20XCHAR\n";
        str += "\n";
        str += "funcStatParameter = \"7021=\" 1*20XCHAR\n";
        str += "\n";
        str += "revStatParameter = \"7022=\" 1*20XCHAR\n";
        str += "\n";
        str += "giaiAssemblyParameter = \"7023=\" 1*30XCHAR\n";
        str += "\n";
        str += "certificationRefCode   = \"7230\" / \"7231\" / \"7232\" / \"7233\" / \"7234\" /\n";
        str += " \"7235\" / \"7236\" / \"7237\" / \"7238\" / \"7239\"\n";
        str += "certificationRefValue  = 2XCHAR 1*28XCHAR\n";
        str += "certificationRefParameter = certificationRefCode \"=\" certificationRefValue\n";
        str += "\n";
        str += "dimensionsParameter = \"8001=\" 14DIGIT\n";
        str += "\n";
        str += "cmtNoParameter = \"8002=\" 1*20XCHAR\n";
        str += "\n";
        str += "ibanParameter = \"8007=\" 1*34XCHAR\n";
        str += "\n";
        str += "prodTimeParameter = \"8008=\" 8DIGIT [2DIGIT] [2DIGIT]\n";
        str += "\n";
        str += "opticalSensorParameter = \"8009=\" 1*50XCHAR\n";
        str += "\n";
        str += "versionParameter = \"8012=\" 1*20XCHAR\n";
        str += "\n";
        str += "refNoParameter = \"8020=\" 1*25XCHAR\n";
        str += "\n";
        str += "itipContentParameter = \"8026=\" 14DIGIT 2DIGIT 2DIGIT\n";
        str += "\n";
        str += "couponIDNAParameter = \"8110=\" 1*70XCHAR\n";
        str += "\n";
        str += "pointsParameter = \"8111=\" 4DIGIT\n";
        str += "\n";
        str += "paperlessCouponIDNAParameter = \"8112=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToCompParameter = \"4300=\" 1*35XCHAR\n";
        str += "\n";
        str += "shipToNameParameter = \"4301=\" 1*35XCHAR\n";
        str += "\n";
        str += "shipToAdd1Parameter = \"4302=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToAdd2Parameter = \"4303=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToSubParameter = \"4304=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToLocalityParameter = \"4305=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToRegParameter = \"4306=\" 1*70XCHAR\n";
        str += "\n";
        str += "shipToCountryParameter = \"4307=\" 2XCHAR\n";
        str += "\n";
        str += "shipToPhoneParameter = \"4308=\" 1*30XCHAR\n";
        str += "\n";
        str += "rtnToCompParameter = \"4310=\" 1*35XCHAR\n";
        str += "\n";
        str += "rtnToNameParameter = \"4311=\" 1*35XCHAR\n";
        str += "\n";
        str += "rtnToAdd1Parameter = \"4312=\" 1*70XCHAR\n";
        str += "\n";
        str += "rtnToAdd2Parameter = \"4313=\" 1*70XCHAR\n";
        str += "\n";
        str += "rtnToSubParameter = \"4314=\" 1*70XCHAR\n";
        str += "\n";
        str += "rtnToLocParameter = \"4315=\" 1*70XCHAR\n";
        str += "\n";
        str += "rtnToRegParameter = \"4316=\" 1*70XCHAR\n";
        str += "\n";
        str += "rtnToCountryParameter = \"4317=\" 2XCHAR\n";
        str += "\n";
        str += "rtnToPostParameter = \"4318=\" 1*20XCHAR\n";
        str += "\n";
        str += "rtnToPhoneParameter = \"4319=\" 1*30XCHAR\n";
        str += "\n";
        str += "srvDescriptionParameter = \"4320=\" 1*35XCHAR\n";
        str += "\n";
        str += "dangerousGoodsParameter = \"4321=\" BOOLEAN\n";
        str += "\n";
        str += "authToLeaveParameter = \"4322=\" BOOLEAN\n";
        str += "\n";
        str += "sigRequiredParameter = \"4323=\" BOOLEAN\n";
        str += "\n";
        str += "notBeforeDelDateParameter = \"4324=\" 10DIGIT\n";
        str += "\n";
        str += "notAfterDelDateParameter = \"4325=\" 10DIGIT\n";
        str += "\n";
        str += "releaseDateParameter = \"4326=\" 6DIGIT\n";
        str += "\n";
        str += "amountPayPerUnitCode = \"3950\" / \"3951\" / \"3952\" / \"3953\"\n";
        str += "\n";
        str += "amountPayPerUnitValue = 6DIGIT\n";
        str += "\n";
        str += "amountPayPerUnitParameter = amountPayPerUnitCode \"=\" amountPayPerUnitValue\n";
        str += "\n";
        str += "gtinParameter = \"01=\" gtin-value\n";
        str += "\n";
        str += "itipParameter = \"8006=\" itip-value\n";
        str += "\n";
        str += "gmnParameter = \"8013=\" gmn-value\n";
        str += "\n";
        str += "cpidParameter = \"8010=\" cpid-value\n";
        str += "\n";
        str += "glnParameter = \"414=\" gln-value\n";
        str += "\n";
        str += "payToParameter = \"415=\" payTo-value\n";
        str += "\n";
        str += "partyGlnParameter = \"417=\" partyGln-value\n";
        str += "\n";
        str += "gsrnpParameter = \"8017=\" gsrnp-value\n";
        str += "\n";
        str += "gsrnParameter = \"8018=\" gsrn-value\n";
        str += "\n";
        str += "gcnParameter = \"255=\" gcn-value\n";
        str += "\n";
        str += "ssccParameter = \"00=\" sscc-value\n";
        str += "\n";
        str += "gdtiParameter = \"253=\" gdti-value\n";
        str += "\n";
        str += "gincParameter = \"401=\" ginc-value\n";
        str += "\n";
        str += "gsinParameter = \"402=\" gsin-value\n";
        str += "\n";
        str += "graiParameter = \"8003=\" grai-value\n";
        str += "\n";
        str += "giaiParameter = \"8004=\" giai-value\n";
        str += "\n";
        str += "internalCode  = \"91\" / \"92\" / \"93\" / \"94\" / \"95\" / \"96\" / \"97\" / \"98\" / \"99\"\n";
        str += "internalValue  = 1*90XCHAR\n";
        str += "internalParameter = internalCode \"=\" internalValue\n";
        str += "\n";
        str += "LotParameter  = lot-code \"=\" lot-value\n";
        str += "\n";
        str += "expiryDateCode  = \"17\"\n";
        str += "expiryDateValue  = 6DIGIT\n";
        str += "expiryDateParameter  = expiryDateCode \"=\" expiryDateValue\n";
        str += "\n";
        str += "expiryTimeCode  = \"7003\"\n";
        str += "expiryTimeValue  = 10DIGIT\n";
        str += "expiryTimeParameter  = expiryTimeCode \"=\" expiryTimeValue\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Extension mechanism and reserved keywords  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "extensionKey = *( DIGIT ) everythingExceptDigitsAndEquals *( DIGIT / everythingExceptDigitsAndEquals)\n";
        str += "extensionValue = *( DIGIT / everythingExceptDigitsAndEquals / \"=\")\n";
        str += "extensionParameter = extensionKey \"=\" extensionValue\n";
        str += " ; any other query string parameter permitted by RFC 3986\n";
        str += " ; including additional arbitrary key=value pairs except as\n";
        str += " ; restricted in the above paragraph\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Constructing the query string  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "queryStringParam  = netWeightVMTIParameter / lengthVMTIParameter /\n";
        str += "  widthVMTIParameter  / depthVMTIParameter / areaVMTIParameter /\n";
        str += "  netVolumeVMTIParameter / massPerUnitAreaVMTIParameter /\n";
        str += "  grossWeightParameter / logisticLengthParameter /\n";
        str += "  logisticWidthParameter / logisticDepthParameter /\n";
        str += "  logisticAreaParameter / logisticVolumeParameter /\n";
        str += "  processorParameter / LotParameter / expiryDateParameter /\n";
        str += "  expiryTimeParameter / contentParameter / prodDateParameter /\n";
        str += "  dueDateParameter / packDateParameter / bestBeforeDateParameter /\n";
        str += "  sellByDateParameter / firstFreezeDateParameter /\n";
        str += "  harvestDateParameter / pricePerUnitParameter / variantParameter /\n";
        str += "  varCountParameter / countParameter / amountPayPerUnitParameter /\n";
        str += "  additionalIdParameter / custPartNoParameter /\n";
        str += "  mtoVariantParameter / pcnParameter / secondarySerialParameter /\n";
        str += "  refToSourceParameter / amountParameter / amountISOParameter /\n";
        str += "  priceParameter / priceISOParameter / percentOffParameter /\n";
        str += "  orderNumberParameter / routeParameter / shipToLocParameter /\n";
        str += "  billToParameter / purchaseFromParameter / shipForLocParameter /\n";
        str += "  prodServLocParameter / shipToPostParameter /\n";
        str += "  shipToPostISOParameter / originParameter /\n";
        str += "  countryProcessParameter / countryFullProcessParameter /\n";
        str += "  countryInitialProcessParameter / countryDisassemblyParameter /\n";
        str += "  originSubdivisionParameter / nhrnPZNParameter / nhrnCIPParameter /\n";
        str += "  nhrnCNParameter / nhrnDRNParameter / nsnParameter /\n";
        str += "  meatCutParameter / activePotencyParameter / catchAreaParameter /\n";
        str += "  fishingGearTypeParameter / prodMethodParameter /\n";
        str += "  refurbLotParameter / funcStatParameter / revStatParameter /\n";
        str += "  giaiAssemblyParameter / dimensionsParameter / cmtNoParameter /\n";
        str += "  ibanParameter / prodTimeParameter / versionParameter /\n";
        str += "  refNoParameter / couponIDNAParameter / pointsParameter /\n";
        str += "  itipContentParameter / certificationRefParameter /\n";
        str += "  aquaticSpeciesParameter / opticalSensorParameter /\n";
        str += "  paperlessCouponIDNAParameter / internalParameter / mutualParameter / extensionParameter /\n";
        str += "  shipToCompParameter / shipToNameParameter /\n";
        str += "  shipToAdd1Parameter / shipToAdd2Parameter /\n";
        str += "  shipToSubParameter / shipToLocalityParameter /\n";
        str += "  shipToRegParameter / shipToCountryParameter /\n";
        str += "  shipToPhoneParameter / rtnToCompParameter /\n";
        str += "  rtnToNameParameter / rtnToAdd1Parameter /\n";
        str += "  rtnToAdd2Parameter / rtnToSubParameter /\n";
        str += "  rtnToLocParameter / rtnToRegParameter /\n";
        str += "  rtnToCountryParameter / rtnToPostParameter /\n";
        str += "  rtnToPhoneParameter / srvDescriptionParameter /\n";
        str += "  dangerousGoodsParameter / authToLeaveParameter /\n";
        str += "  sigRequiredParameter / notBeforeDelDateParameter /\n";
        str += "  notAfterDelDateParameter / releaseDateParameter /\n";
        str += "  gtinParameter  / itipParameter / gmnParameter / cpidParameter /\n";
        str += "  glnParameter / payToParameter / partyGlnParameter / gsrnpParameter /\n";
        str += "  gsrnParameter / gcnParameter / ssccParameter / gdtiParameter /\n";
        str += "  gincParameter / gsinParameter / graiParameter /\n";
        str += "  giaiParameter\n";
        str += "\n";
        str += ";;;;;;;;;;;;;;;;;;;;;;;;;;;;; SECTION - Constructing the GS1 Digital Link URI  ;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;\n";
        str += "\n";
        str += "scheme = \"https\" / \"http\"\n";
        str += "\n";
        str += "unreserved = ALPHA / DIGIT / \"-\" / \".\" / \"_\" / \"~\"\n";
        str += "\n";
        str += "reserved = gen-delims / sub-delims\n";
        str += "\n";
        str += "pct-encoded = \"%\" HEXDIG HEXDIG\n";
        str += "\n";
        str += "gen-delims = \":\" / \"/\" / \"?\" / \"#\" / \"[\" / \"]\" / \"@\"\n";
        str += "\n";
        str += "sub-delims = \"!\" / \"$\" / \"&\" / \"'\" / \"(\" / \")\" / \"*\" /\n";
        str += "      \"+\" / \",\" / \";\" / \"=\"\n";
        str += "\n";
        str += "sub-delims-without-equals = \"!\" / \"$\" / \"&\" / \"'\" / \"(\" / \")\" / \"*\" /\n";
        str += "      \"+\" / \",\" / \";\"\n";
        str += "everythingExceptDigitsAndEquals =  unreserved / pct-encoded /\n";
        str += "                                   sub-delims-without-equals /\n";
        str += "                                   \":\" / \"@\" / \"/\" / \"?\"\n";
        str += "\n";
        str += "pchar = unreserved / pct-encoded / sub-delims / \":\" / \"@\"\n";
        str += "\n";
        str += "segment = *pchar\n";
        str += "\n";
        str += "reg-name = *( unreserved / pct-encoded / sub-delims )\n";
        str += "\n";
        str += "dec-octet = DIGIT                 ; 0-9\n";
        str += "    / %x31-39 DIGIT         ; 10-99\n";
        str += "    / \"1\" 2DIGIT            ; 100-199\n";
        str += "    / \"2\" %x30-34 DIGIT     ; 200-249\n";
        str += "    / \"25\" %x30-35          ; 250-255\n";
        str += "\n";
        str += "IPv4address  = dec-octet \".\" dec-octet \".\" dec-octet \".\" dec-octet\n";
        str += "\n";
        str += "IPv6address  = 6( h16 \":\" ) ls32\n";
        str += "    /  \"::\" 5( h16 \":\" ) ls32\n";
        str += "    / [ h16 ] \"::\" 4( h16 \":\" ) ls32\n";
        str += "    / [ *1( h16 \":\" ) h16 ] \"::\" 3( h16 \":\" ) ls32\n";
        str += "    / [ *2( h16 \":\" ) h16 ] \"::\" 2( h16 \":\" ) ls32\n";
        str += "    / [ *3( h16 \":\" ) h16 ] \"::\"    h16 \":\"   ls32\n";
        str += "    / [ *4( h16 \":\" ) h16 ] \"::\"              ls32\n";
        str += "    / [ *5( h16 \":\" ) h16 ] \"::\"              h16\n";
        str += "    / [ *6( h16 \":\" ) h16 ] \"::\"\n";
        str += "\n";
        str += "ls32 = ( h16 \":\" h16 ) / IPv4address\n";
        str += "    ; least-significant 32 bits of address\n";
        str += "\n";
        str += "h16 = 1*4HEXDIG\n";
        str += "    ; 16 bits of address represented in hexadecimal\n";
        str += "\n";
        str += "IP-literal = \"[\" ( IPv6address / IPvFuture  ) \"]\"\n";
        str += "\n";
        str += "IPvFuture = \"v\" 1*HEXDIG \".\" 1*( unreserved / sub-delims / \":\" )\n";
        str += "\n";
        str += "host = IP-literal / IPv4address / reg-name\n";
        str += "\n";
        str += "port  = *DIGIT\n";
        str += "\n";
        str += "hostname = host [ \":\" port ]\n";
        str += "queryStringDelim  = \"&\" / \";\"\n";
        str += "\n";
        str += "queryStringComp  =\n";
        str += "    \"?\" queryStringParam *( queryStringDelim queryStringParam)\n";
        str += "\n";
        str += "uncompressedGS1webURIPattern  = gs1path [queryStringComp]\n";
        str += "\n";
        str += "referenceGS1webURI = \"https://id.gs1.org\" uncompressedGS1webURIPattern\n";
        str += "\n";
        str += "customURIstem  = scheme \"://\" hostname ; *( \"/\" segment )\n";
        str += "\n";
        str += "uncompressedCustomGS1webURI  = customURIstem uncompressedGS1webURIPattern\n";
        return str;
      }
    }
  }